// src/models/accountDetails/types.ts
import * as t5 from "io-ts";

// src/models/address/types.ts
import * as t3 from "io-ts";

// src/models/country/types.ts
import * as t from "io-ts";
var countries = {
  AF: "Afghanistan",
  AX: "\xC5land Islands",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia (Plurinational State of)",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  CV: "Cabo Verde",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CD: "Congo (the Democratic Republic of the)",
  CG: "Congo",
  CK: "Cook Islands",
  CR: "Costa Rica",
  HR: "Croatia",
  CU: "Cuba",
  CW: "Cura\xE7ao",
  CY: "Cyprus",
  CZ: "Czechia",
  CI: "C\xF4te d'Ivoire",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  SZ: "Eswatini",
  ET: "Ethiopia",
  FK: "Falkland Islands [Malvinas]",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and McDonald Islands",
  VA: "Holy See",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran (Islamic Republic of)",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea (the Democratic People's Republic of)",
  KR: "Korea (the Republic of)",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia (Federated States of)",
  MD: "Moldova (the Republic of)",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestine, State of",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  MK: "Republic of North Macedonia",
  RO: "Romania",
  RU: "Russian Federation",
  RW: "Rwanda",
  RE: "R\xE9union",
  BL: "Saint Barth\xE9lemy",
  SH: "Saint Helena, Ascension and Tristan da Cunha",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin (French part)",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten (Dutch part)",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  SS: "South Sudan",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania, United Republic of",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  UM: "United States Minor Outlying Islands",
  US: "United States of America",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela (Bolivarian Republic of)",
  VN: "Viet Nam",
  VG: "Virgin Islands (British)",
  VI: "Virgin Islands (U.S.)",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe"
};
var country = t.keyof(countries);

// src/models/state/types.ts
import * as t2 from "io-ts";
var states = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DC: "Washington DC",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
  AB: "Alberta",
  BC: "British Columbia",
  MB: "Manitoba",
  NB: "New Brunswick",
  NL: "Newfoundland and Labrador",
  NS: "Nova Scotia",
  ON: "Ontario",
  PE: "Prince Edward Island",
  QC: "Quebec",
  SK: "Saskatchewan",
  NU: "Nunavut",
  YT: "Yukon",
  NT: "Northwest Territories"
};
var state = t2.keyof(states);
var byCountry = {
  US: [
    "AL",
    "AK",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DC",
    "DE",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY"
  ],
  CA: [
    "AB",
    "BC",
    "MB",
    "NB",
    "NL",
    "NS",
    "NT",
    "NU",
    "ON",
    "PE",
    "QC",
    "SK",
    "YT"
  ]
};
var statesForCountry = (country2) => byCountry[country2] || [];
var fieldNames = {
  US: "state",
  CA: "province"
};
var stateFieldName = (country2) => fieldNames[country2] || "state";

// src/models/address/types.ts
var addressModel = t3.exact(
  t3.intersection(
    [
      t3.type({
        line1: t3.string,
        town: t3.string,
        country,
        postcode: t3.string
      }),
      t3.partial({
        line2: t3.string,
        state
      })
    ],
    "AddressModel"
  )
);

// src/models/sortCodeAccountNumber/types.ts
import * as t4 from "io-ts";
var sortCodeAccountNumberModel = t4.exact(
  t4.type(
    {
      sortCode: t4.string,
      accountNumber: t4.string
    },
    "SortCodeAccountNumberModel"
  )
);

// src/models/accountDetails/types.ts
var accountDetailsType = t5.keyof({
  UK_BANK_ACCOUNT: null,
  IBAN: null,
  US_ACH: null,
  US_WIRE: null,
  CA_BANK_ACCOUNT: null,
  CA_INTERNATIONAL: null,
  AUSTRALIAN: null
});
var accountDetailsTypeDescription = {
  IBAN: "IBAN",
  UK_BANK_ACCOUNT: "UK Account Details",
  US_ACH: "US ACH Details",
  US_WIRE: "US Wire Details",
  CA_BANK_ACCOUNT: "Canadian Account Details",
  CA_INTERNATIONAL: "Canadian International Details",
  AUSTRALIAN: "Australian Account Details"
};
var usAchDestinationModel = t5.exact(
  t5.type({
    accountNumber: t5.string,
    accountName: t5.string,
    bankName: t5.string,
    bankRoutingNumber: t5.string
  })
);
var usWireDestinationModel = t5.exact(
  t5.type({
    accountNumber: t5.string,
    accountName: t5.string,
    bankName: t5.string,
    bankRoutingNumber: t5.string,
    swiftCode: t5.string,
    bankAddress: addressModel
  })
);
var canadianDestinationModel = t5.exact(
  t5.type({
    transitNumber: t5.string,
    institutionNumber: t5.string,
    accountNumber: t5.string
  })
);
var canadianInternationalDestinationModel = t5.exact(
  t5.intersection([
    t5.type({
      accountNumber: t5.string,
      legalName: t5.string,
      bankName: t5.string,
      institutionNumber: t5.string,
      swiftCode: t5.string,
      bankAddress: addressModel,
      transitNumber: t5.string
    }),
    t5.partial({
      intermediaryBank: t5.exact(
        t5.type({
          bankName: t5.string,
          routingNumber: t5.string,
          swiftCode: t5.string,
          bankAddress: addressModel
        })
      )
    })
  ])
);
var australianDestinationModel = t5.exact(
  t5.type({
    accountNumber: t5.string,
    legalName: t5.string,
    bsb: t5.string,
    swiftCode: t5.string
  })
);
var accountDetailsModel = t5.exact(
  t5.intersection(
    [
      t5.type({
        type: accountDetailsType
      }),
      t5.partial({
        iban: t5.string,
        ukBankAccount: sortCodeAccountNumberModel,
        usAchDestination: usAchDestinationModel,
        usWireDestination: usWireDestinationModel,
        canadianBankAccount: canadianDestinationModel,
        canadianInternationalDestination: canadianInternationalDestinationModel,
        australianDestination: australianDestinationModel
      })
    ],
    "AccountDetailsModel"
  )
);

// src/models/aggregationType/format.ts
var toAggregationType = (aggregationType2) => {
  switch (aggregationType2) {
    case "COUNT":
      return "Count";
    case "UNIQUE":
      return "Unique";
    case "SUM":
      return "Sum";
    case "CUSTOM":
      return "Result";
  }
};

// src/models/aggregationType/types.ts
import * as t6 from "io-ts";
var aggregationType = t6.keyof({
  COUNT: null,
  UNIQUE: null,
  SUM: null,
  CUSTOM: null
});

// src/models/billingFrequency/types.ts
import * as t7 from "io-ts";
var billingFrequency = t7.keyof({
  ONE_TIME: null,
  MONTHLY: null,
  QUARTERLY: null,
  HALF_YEARLY: null,
  YEARLY: null,
  ON_DEMAND: null
});

// src/models/billingFrequency/format.ts
var typeDescriptions = {
  ONE_TIME: {
    label: "One time",
    name: "one time",
    pluralName: "one time"
  },
  MONTHLY: {
    label: "Monthly",
    name: "month",
    pluralName: "months"
  },
  QUARTERLY: {
    label: "Quarterly",
    name: "quarter",
    pluralName: "quarters"
  },
  YEARLY: {
    label: "Annually",
    name: "year",
    pluralName: "years"
  },
  HALF_YEARLY: {
    label: "Semi-annually",
    name: "semi-annual",
    pluralName: "semi-annual"
  },
  ON_DEMAND: {
    label: "On demand",
    name: "on demand",
    pluralName: "on demand"
  }
};
var billingFrequencyOptions = Object.entries(typeDescriptions).reduce((acc, [value, { label }]) => {
  if (["ONE_TIME"].includes(value)) {
    return acc;
  }
  if (billingFrequency.is(value)) {
    acc.push({ label, value });
  }
  return acc;
}, []);
var toBillingFrequencyLabel = (value, fallback = " - ") => value ? typeDescriptions[value].label : fallback;
var toBillingFrequencyName = (value, fallback) => typeDescriptions[value]?.name ?? fallback;
var toBillingFrequencyPluralName = (value, fallback) => typeDescriptions[value]?.pluralName ?? fallback;

// src/lib/validate/validate.ts
import { either as E } from "fp-ts";
import * as ioTsReporters from "io-ts-reporters";
var reporting = {
  notify: ({ formattedMessage }) => {
    console.log(formattedMessage);
  }
};
var setNotify = (notify) => {
  reporting.notify = notify;
};
var validateDirect = ({
  value,
  codec,
  callerFunctionName
}) => {
  const result = codec.decode(value);
  if (E.isLeft(result)) {
    const messages = ioTsReporters.reporter(result);
    messages.forEach((message) => {
      const formattedMessage = `${callerFunctionName}: ${message}`;
      reporting.notify({ formattedMessage, codec });
    });
  }
  return result;
};
var parseResponse = ({
  value,
  codec,
  callerFunctionName
}) => {
  const result = validateDirect({
    value,
    codec,
    callerFunctionName
  });
  return {
    valueOr: (fallback) => {
      return E.isLeft(result) ? fallback : result.right;
    },
    value: () => {
      return E.isLeft(result) ? void 0 : result.right;
    }
  };
};

// src/models/billingProduct/types.ts
import * as t18 from "io-ts";

// src/models/pagination/types.ts
import * as t8 from "io-ts";
var paginationResponseNew = t8.exact(
  t8.partial(
    {
      before: t8.string,
      after: t8.string,
      totalResultSize: t8.number
    },
    "PaginationResponseNew"
  )
);
var createPaginatedResponseNew = (model, name) => {
  return t8.strict(
    {
      items: t8.array(model),
      pagination: paginationResponseNew
    },
    name
  );
};
var createUnpaginatedResponse = (model, name) => {
  return t8.strict(
    {
      items: t8.array(model)
    },
    name
  );
};

// src/models/price/types.ts
import * as t16 from "io-ts";

// src/models/billingType/types.ts
import * as t9 from "io-ts";
var billingType = t9.keyof({
  IN_ARREARS: null,
  IN_ADVANCE: null
});

// src/models/billingType/format.ts
import { match } from "ts-pattern";
var priceToBillingType = ({
  billingType: billingType2,
  pricingType: pricingType2
}) => {
  return match(pricingType2).with("FIXED", () => {
    return billingType2 ? toBillingType(billingType2) : void 0;
  }).with("ONE_TIME", () => {
    return billingType2 ? toBillingType(billingType2) : void 0;
  }).otherwise(() => void 0);
};
var toBillingType = (billingType2) => {
  return match(billingType2).with("IN_ARREARS", () => "In arrears").with("IN_ADVANCE", () => "In advance").exhaustive();
};

// src/models/currency/types.tsx
import * as t10 from "io-ts";
var currencyToSymbol = {
  ARS: "ARS",
  AUD: "A$",
  BRL: "R$",
  CAD: "CA$",
  CHF: "CHF",
  CNY: "CN\xA5",
  COP: "COP",
  CZK: "CZK",
  DKK: "DKK",
  EUR: "\u20AC",
  GBP: "\xA3",
  HKD: "HK$",
  ILS: "\u20AA",
  INR: "\u20B9",
  JPY: "JP\xA5",
  KRW: "\u20A9",
  MXN: "MX$",
  NOK: "NOK",
  NZD: "NZ$",
  PLN: "PLN",
  SEK: "SEK",
  SGD: "SGD",
  THB: "THB",
  USD: "$",
  UYU: "UYU",
  ZAR: "ZAR"
};
var currencyToName = {
  ARS: "Argentinian Pesos",
  AUD: "Australian Dollars",
  BRL: "Brazilian Real",
  CAD: "Canadian Dollars",
  CHF: "Swiss Franc",
  CNY: "Yuan Renminbi",
  COP: "Colombian Pesos",
  CZK: "Czech Koruna",
  DKK: "Danish Krone",
  EUR: "Euros",
  GBP: "Great British Pounds",
  HKD: "Hong Kong Dollar",
  INR: "Indian Rupee",
  ILS: "New Israeli Sheqel",
  JPY: "Yen",
  KRW: "South Korean Won",
  MXN: "Mexican Pesos",
  NOK: "Norwegian Krone",
  NZD: "New Zealand Dollar",
  PLN: "Zloty",
  SEK: "Swedish Krona",
  SGD: "Singapore Dollar",
  THB: "Baht",
  USD: "US Dollars",
  UYU: "Uruguayan Pesos",
  ZAR: "South African Rand"
};
var currency = t10.keyof(currencyToSymbol);
var currencies = Object.keys(currencyToSymbol);

// src/models/integration/types.ts
import * as t12 from "io-ts";

// src/models/keyValuePair/types.ts
import * as t11 from "io-ts";
var keyValuePairModel = t11.exact(
  t11.type({
    key: t11.string,
    value: t11.string
  })
);

// src/models/integration/types.ts
var integrationType = t12.keyof({
  Accounting: null,
  Communication: null,
  CRM: null,
  Data: null,
  Payments: null
});
var integrationService = t12.keyof({
  Amazon_Redshift: null,
  Avalara: null,
  Google_BigQuery: null,
  Google_Sheets: null,
  HubSpot: null,
  NetSuite: null,
  QuickBooks_Online: null,
  Salesforce: null,
  Slack: null,
  Snowflake: null,
  Stripe: null,
  Xero: null
});
var integrationState = t12.keyof({
  UNAVAILABLE: null,
  AVAILABLE: null,
  PENDING: null,
  CONNECTED: null,
  COMING_SOON: null
});
var integration = t12.exact(
  t12.type({
    sequenceAccountId: t12.string,
    state: integrationState,
    enabled: t12.boolean,
    settings: t12.array(keyValuePairModel),
    service: integrationService,
    type: integrationType,
    rawState: t12.string,
    authFailure: t12.boolean
  })
);
var integrationOAuthRedirectResponse = t12.exact(
  t12.type({
    url: t12.string
  })
);
var integrationLedgerAccountStatus = t12.keyof({
  active: null,
  inactive: null,
  archived: null
});
var integrationLedgerAccount = t12.exact(
  t12.type({
    id: t12.string,
    name: t12.string,
    status: integrationLedgerAccountStatus,
    code: t12.string
  })
);
var integrationLedgerAccountOptions = t12.exact(
  t12.intersection([
    t12.type({
      key: integrationService,
      value: t12.array(integrationLedgerAccount)
    }),
    t12.partial({
      defaultLedgerAccount: t12.string,
      creditDefaultLedgerAccount: t12.string
    })
  ])
);
var integrationLedgerAccountsResponse = t12.exact(
  t12.type({
    ledgerAccounts: t12.array(integrationLedgerAccountOptions)
  })
);
var integrationCustomer = t12.exact(
  t12.intersection([
    t12.type({
      id: t12.string,
      companyName: t12.string,
      isLinked: t12.boolean,
      externalUrl: t12.string
    }),
    t12.partial({
      country: t12.string,
      invalidReason: t12.string
    })
  ])
);
var integrationCustomersForServiceResponse = t12.exact(
  t12.type({
    items: t12.array(integrationCustomer)
  })
);
var integrationCustomersResponse = t12.exact(
  t12.type({
    customers: t12.array(
      t12.exact(
        t12.type({
          key: integrationService,
          value: t12.array(integrationCustomer)
        })
      )
    )
  })
);
var importIntegrationCustomersResponse = t12.exact(
  t12.type({
    count: t12.number
  })
);
var importIntegrationCustomersProgressResponse = t12.exact(
  t12.type({
    totalCount: t12.number,
    currentCount: t12.number
  })
);
var integrationExternalId = t12.exact(
  t12.type({
    key: integrationService,
    value: t12.string
  })
);
var tokenResponse = t12.exact(
  t12.type({
    token: t12.string
  })
);

// src/models/pagination/mocks.ts
var mockPagination = {
  totalResultSize: 52
};

// src/models/pagination/data.ts
var emptyPaginatedResponseNew = {
  items: [],
  pagination: { before: void 0, after: void 0, totalResultSize: 0 }
};
var emptyUnpaginatedResponse = {
  items: []
};

// src/models/integration/decoder.ts
var toIntegration = (value) => {
  return parseResponse({
    value,
    codec: integration,
    callerFunctionName: "toIntegration"
  });
};
var toIntegrationOAuthRedirectResponse = (value) => {
  return parseResponse({
    value,
    codec: integrationOAuthRedirectResponse,
    callerFunctionName: "toIntegrationOAuthRedirectResponse"
  });
};
var toListIntegrationsResponse = (value) => {
  return parseResponse({
    value,
    codec: createUnpaginatedResponse(integration, "Integrations"),
    callerFunctionName: "toListIntegrationsResponse"
  });
};
var toIntegrationLedgerAccountsResponse = (value) => {
  return parseResponse({
    value,
    codec: integrationLedgerAccountsResponse,
    callerFunctionName: "toIntegrationLedgerAccountsResponse"
  });
};
var toIntegrationCustomersResponse = (value) => {
  return parseResponse({
    value,
    codec: integrationCustomersResponse,
    callerFunctionName: "toIntegrationCustomersResponse"
  });
};
var toIntegrationCustomersForServiceResponse = (value) => {
  return parseResponse({
    value,
    codec: integrationCustomersForServiceResponse,
    callerFunctionName: "toIntegrationCustomersForServiceResponse"
  });
};
var toImportIntegrationCustomersResponse = (value) => {
  return parseResponse({
    value,
    codec: importIntegrationCustomersResponse,
    callerFunctionName: "toImportIntegrationCustomersResponse"
  });
};
var toImportIntegrationCustomersProgressResponse = (value) => {
  return parseResponse({
    value,
    codec: importIntegrationCustomersProgressResponse,
    callerFunctionName: "toImportIntegrationCustomersProgressResponse"
  });
};
var toTokenResponse = (value) => {
  return parseResponse({
    value,
    codec: tokenResponse,
    callerFunctionName: "toTokenResponse"
  });
};

// src/models/integration/mocks.ts
var mockIntegration = {
  service: "Xero",
  sequenceAccountId: "id",
  type: "Accounting",
  enabled: true,
  settings: [
    {
      key: "Organisation",
      value: "My company"
    }
  ],
  state: "CONNECTED",
  rawState: "callable",
  authFailure: false
};
var mockIntegrationsResponse = {
  items: [mockIntegration]
};
var mockIntegrationOAuthRedirectResponse = {
  url: "authorise&redirect_uri=http://localhost/dashboard/integrations?connected=Xero"
};
var mockIntegrationLedgerAccounts = {
  ledgerAccounts: [
    {
      key: "Xero",
      value: [
        {
          id: "id",
          name: "name",
          status: "active",
          code: "code"
        }
      ]
    }
  ]
};
var mockIntegrationCustomers = {
  customers: [
    {
      key: "Xero",
      value: [
        {
          id: "id",
          companyName: "name",
          isLinked: true,
          externalUrl: "www.example.com"
        }
      ]
    }
  ]
};
var mockIntegrationCustomersForService = {
  items: [
    {
      id: "id",
      companyName: "name",
      isLinked: true,
      externalUrl: "www.example.com"
    }
  ]
};
var mockImportIntegrationCustomersResponse = {
  count: 2
};
var mockImportIntegrationCustomersProgressResponse = {
  totalCount: 2,
  currentCount: 1
};
var mockTokenResponse = {
  token: "token"
};

// src/models/pricingStructure/types.ts
import * as t15 from "io-ts";

// src/models/pricingTier/types.ts
import * as t13 from "io-ts";
var INFINITY = "\u221E";
var pricingTier = t13.exact(
  t13.intersection(
    [
      t13.type({ price: t13.string, isPricePercentage: t13.boolean }),
      t13.partial({
        upperBound: t13.string,
        fee: t13.string,
        maxPrice: t13.string,
        minPrice: t13.string
      })
    ],
    "pricingTier"
  )
);

// src/models/usageCalculationMode/types.ts
import * as t14 from "io-ts";
var usageCalculationMode = t14.keyof({
  BILLING_PERIOD: null,
  CUMULATIVE: null
});

// src/models/usageCalculationMode/format.ts
var typeDescriptions2 = {
  BILLING_PERIOD: {
    label: "Billing period calculation (default)",
    description: "Charges are based on usage in each billing period."
  },
  CUMULATIVE: {
    label: "Cumulative calculation",
    description: "Usage is counted from the billing start date and accumulates with each billing period."
  }
};
var usageCalculationModeOptions = Object.entries(
  typeDescriptions2
).reduce((acc, [value, { label }]) => {
  if (usageCalculationMode.is(value)) {
    acc.push({ label, value });
  }
  return acc;
}, []);
var toUsageCalculationModeLabel = (value, fallback = " - ") => value ? typeDescriptions2[value].label : fallback;
var toUsageCalculationModeDescription = (value, fallback = "") => value ? typeDescriptions2[value].description : fallback;

// src/models/pricingStructure/types.ts
var priceTypeUrlChunk = t15.keyof({
  standard: null,
  linear: null,
  packaged: null,
  volume: null,
  graduated: null,
  "volume-percentage": null,
  "graduated-percentage": null,
  seat: null
});
var prorationStrategy = t15.keyof({
  USE_FIRST: null,
  USE_MAXIMUM: null,
  PRORATE_INCREMENTS: null,
  PRORATE_ALL_CHANGES: null
});
var chargeMethod = t15.keyof({
  CHARGE_FIXED: null,
  CHARGE_OVERAGES: null,
  CHARGE_CONSUMED: null,
  CHARGE_MINIMUM: null
});
var pricingTypeDescriptions = {
  FIXED: {
    pricingType: "FIXED",
    urlChunk: "standard",
    isPricePercentage: false,
    group: "Fixed charge",
    label: "Fixed pricing",
    labelShort: "Fixed",
    tableLabel: "Fixed",
    description: "Charge the same price for each unit. Choose between recurring and one-off charges."
  },
  ONE_TIME: {
    pricingType: "ONE_TIME",
    urlChunk: "standard",
    isPricePercentage: false,
    group: "Fixed charge",
    label: "Fixed pricing",
    labelShort: "Charged once",
    tableLabel: "Fixed",
    description: "Charge a one-time fee (e.g. setup fee)."
  },
  LINEAR: {
    pricingType: "LINEAR",
    urlChunk: "linear",
    isPricePercentage: false,
    group: "Usage-based charge",
    label: "Linear pricing",
    labelShort: "Linear rate",
    tableLabel: "Linear",
    description: "Charge a single, linear rate for usage."
  },
  PACKAGE: {
    pricingType: "PACKAGE",
    urlChunk: "packaged",
    isPricePercentage: false,
    group: "Usage-based charge",
    label: "Packaged pricing",
    labelShort: "Packaged",
    tableLabel: "Package",
    description: "Charge a fixed fee for a packaged quantity of units."
  },
  VOLUME: {
    pricingType: "VOLUME",
    urlChunk: "volume",
    isPricePercentage: false,
    group: "Usage-based charge",
    label: "Volume pricing",
    labelShort: "Volume tiers",
    tableLabel: "Volume tiers",
    description: "All usage is charged a single unit fee based on total volume."
  },
  GRADUATED: {
    pricingType: "GRADUATED",
    urlChunk: "graduated",
    isPricePercentage: false,
    group: "Usage-based charge",
    label: "Graduated pricing",
    labelShort: "Graduated tiers",
    tableLabel: "Graduated tiers",
    description: "Usage in each tier is charged separately using respective tier fees."
  },
  SEAT_BASED: {
    pricingType: "SEAT_BASED",
    urlChunk: "seat",
    isPricePercentage: false,
    group: "Seat-based charge",
    label: "Seat-based pricing",
    labelShort: "Per seat",
    tableLabel: "Seat-based",
    description: "Charge a per-seat fee and track the number of live seats."
  }
};
var usageBasedPricingTypes = Object.keys(pricingTypeDescriptions).filter(
  (pricingTypeKey) => pricingTypeDescriptions[pricingTypeKey].group === "Usage-based charge"
);
var pricingType = t15.keyof({
  FIXED: null,
  ONE_TIME: null,
  LINEAR: null,
  PACKAGE: null,
  VOLUME: null,
  GRADUATED: null,
  SEAT_BASED: null
});
var pricingStructureOneTime = t15.strict(
  {
    price: t15.string,
    pricingType: t15.literal("ONE_TIME")
  },
  "pricingStructureOneTime"
);
var pricingStructureFixed = t15.strict(
  {
    price: t15.string,
    pricingType: t15.literal("FIXED")
  },
  "pricingStructureFixed"
);
var pricingStructureLinear = t15.intersection(
  [
    t15.exact(
      t15.type({
        pricePerUnit: t15.string,
        usageMetricId: t15.string,
        isPricePercentage: t15.boolean,
        pricingType: t15.literal("LINEAR")
      })
    ),
    t15.partial({ maxPrice: t15.string, minPrice: t15.string })
  ],
  "pricingStructureLinear"
);
var pricingStructurePackage = t15.strict(
  {
    packageSize: t15.string,
    pricePerPackage: t15.string,
    usageMetricId: t15.string,
    pricingType: t15.literal("PACKAGE")
  },
  "pricingStructurePackage"
);
var pricingStructureVolume = t15.strict(
  {
    tiers: t15.array(pricingTier),
    usageMetricId: t15.string,
    pricingType: t15.literal("VOLUME")
  },
  "pricingStructureVolume"
);
var pricingStructureGraduated = t15.strict(
  {
    tiers: t15.array(pricingTier),
    usageMetricId: t15.string,
    pricingType: t15.literal("GRADUATED"),
    usageCalculationMode
  },
  "pricingStructureGraduated"
);
var pricingStructureSeatBased = t15.exact(
  t15.intersection([
    t15.type({
      pricePerSeat: t15.string,
      seatTypeId: t15.string,
      includedSeats: t15.number,
      pricingType: t15.literal("SEAT_BASED"),
      prorationStrategy,
      chargeMethod,
      tiers: t15.array(pricingTier),
      prorateFlatFees: t15.boolean
    }),
    t15.partial({
      overagesBillingFrequency: billingFrequency
    })
  ]),
  "pricingStructureSeatBased"
);
var pricingStructureModel = t15.union(
  [
    pricingStructureOneTime,
    pricingStructureFixed,
    pricingStructureLinear,
    pricingStructurePackage,
    pricingStructureVolume,
    pricingStructureGraduated,
    pricingStructureSeatBased
  ],
  "pricingStructureModel"
);

// src/models/price/types.ts
var priceParameterModel = t16.exact(
  t16.type({
    parameterId: t16.string,
    value: t16.string
  })
);
var priceModel = t16.exact(
  t16.intersection(
    [
      t16.type({
        id: t16.string,
        name: t16.string,
        sequenceAccountId: t16.string,
        productId: t16.string,
        createdAt: t16.string,
        structure: pricingStructureModel,
        currency,
        externalIds: t16.array(integrationExternalId),
        billingFrequency,
        billingType,
        parameters: t16.array(priceParameterModel)
      }),
      t16.partial({
        deletedAt: t16.string,
        listPriceId: t16.string,
        updatedAt: t16.string
      })
    ],
    "PriceModel"
  )
);
var pricesResponse = createPaginatedResponseNew(
  priceModel,
  "PricesResponse"
);

// src/models/price/decoder.ts
var toPrice = (value) => {
  return parseResponse({
    value,
    codec: priceModel,
    callerFunctionName: "toPrice"
  });
};
var toPricesResponse = (value) => {
  return parseResponse({
    value,
    codec: pricesResponse,
    callerFunctionName: "toPricesResponse"
  });
};

// src/models/price/mocks.ts
var mockPriceOneTime = {
  id: "bc61d4b8-e9d6-4f4a-9bcf-f5dae874c730",
  sequenceAccountId: "1986c663-9ee9-4811-bfbf-57d2ad666096",
  name: "Demo Product",
  structure: {
    pricingType: "ONE_TIME",
    price: "150.00"
  },
  currency: "GBP",
  productId: "d07037d5-3e31-4c3a-a360-e58555e2bf44",
  createdAt: "2022-06-28T16:47:00Z",
  updatedAt: "2022-06-28T16:47:00Z",
  // deletedAt: '2022-06-28T16:47:00Z',
  externalIds: [
    {
      key: "Xero",
      value: "id"
    }
  ],
  billingFrequency: "MONTHLY",
  billingType: "IN_ARREARS",
  parameters: [
    {
      parameterId: "paramId",
      value: "10"
    }
  ]
};
var mockPriceFixed = {
  ...mockPriceOneTime,
  structure: {
    pricingType: "FIXED",
    price: "150.00"
  }
};
var mockPriceLinear = {
  ...mockPriceOneTime,
  structure: {
    pricingType: "LINEAR",
    pricePerUnit: "150.00",
    usageMetricId: "3119afb8-417b-4739-89eb-558ab56fcde5",
    isPricePercentage: false
  }
};
var mockPriceVolume = {
  ...mockPriceOneTime,
  structure: {
    pricingType: "VOLUME",
    tiers: [{ price: "150.00", isPricePercentage: false }],
    usageMetricId: "3119afb8-417b-4739-89eb-558ab56fcde5"
  }
};
var mockPriceVolumePercentage = {
  ...mockPriceOneTime,
  structure: {
    pricingType: "VOLUME",
    tiers: [{ price: "1.5", isPricePercentage: true }],
    usageMetricId: "3119afb8-417b-4739-89eb-558ab56fcde5"
  }
};
var mockPriceGraduated = {
  ...mockPriceOneTime,
  structure: {
    pricingType: "GRADUATED",
    tiers: [{ price: "150.00", isPricePercentage: false }],
    usageMetricId: "3119afb8-417b-4739-89eb-558ab56fcde5",
    usageCalculationMode: "BILLING_PERIOD"
  }
};
var mockPricePackage = {
  ...mockPriceOneTime,
  structure: {
    pricingType: "PACKAGE",
    pricePerPackage: "150.00",
    packageSize: "20",
    usageMetricId: "3119afb8-417b-4739-89eb-558ab56fcde5"
  }
};
var mockPricesResponse = {
  items: [mockPriceFixed, mockPriceOneTime],
  pagination: mockPagination
};

// src/models/price/format.ts
var toPriceFrequencyLabel = (pricingType2, billingFrequency2) => {
  if (pricingType2 === "ONE_TIME") {
    return "One time";
  }
  if (!billingFrequency2) {
    return " - ";
  }
  if (pricingType2 === "PACKAGE") {
    return `Per package per ${toBillingFrequencyName(billingFrequency2)}`;
  }
  if (pricingType2 === "LINEAR") {
    return `Per unit per ${toBillingFrequencyName(billingFrequency2)}`;
  }
  if (pricingType2 === "SEAT_BASED") {
    return `Per seat per ${toBillingFrequencyName(billingFrequency2)}`;
  }
  return `Per ${toBillingFrequencyName(billingFrequency2)}`;
};

// src/models/product/types.ts
import * as t17 from "io-ts";
var productModelShape = {
  id: t17.string,
  name: t17.string,
  label: t17.string,
  sequenceAccountId: t17.string,
  createdAt: t17.string,
  updatedAt: t17.string
};
var productModel = t17.strict(productModelShape, "ProductModel");
var productsResponse = createPaginatedResponseNew(
  productModel,
  "ProductsResponse"
);

// src/models/billingProduct/types.ts
var billingProductModel = t18.strict(
  {
    ...productModelShape,
    prices: t18.array(priceModel)
  },
  "BillingProductModel"
);
var billingProductModelPatch = t18.strict(
  {
    ...productModelShape,
    prices: t18.array(
      t18.union([
        priceModel,
        t18.type({
          structure: t18.unknown
        })
      ])
    )
  },
  "BillingProductModel"
);
var billingProductsResponse = createPaginatedResponseNew(
  billingProductModelPatch,
  "BillingProductsResponse"
);

// src/models/billingProduct/decoder.ts
var toBillingProduct = (value) => {
  return parseResponse({
    value,
    codec: billingProductModel,
    callerFunctionName: "toProduct"
  });
};
var toBillingProductsResponse = (value) => {
  return parseResponse({
    value,
    codec: billingProductsResponse,
    callerFunctionName: "toProductsResponse"
  });
};

// src/models/billingProduct/mocks.ts
var mockBillingProduct = {
  id: "1",
  name: "shiny product",
  label: "label",
  sequenceAccountId: "sequenceAccountId",
  createdAt: "2023-02-28T16:38:00Z",
  updatedAt: "2023-02-28T16:38:00Z",
  prices: []
};
var mockBillingProductsResponse = {
  items: [mockBillingProduct],
  pagination: mockPagination
};

// src/models/billingSchedule/types.ts
import * as t21 from "io-ts";

// src/models/discount/types.ts
import * as t19 from "io-ts";
var discountCalculationType = t19.keyof({
  NOMINAL: null,
  PERCENTAGE: null
});
var discountDuration = t19.keyof({
  FOREVER: null,
  ONCE: null,
  REPEAT: null
});
var discountModel = t19.exact(
  t19.intersection(
    [
      t19.type({
        id: t19.string,
        amount: t19.number,
        billingScheduleId: t19.string,
        discountCalculationType,
        message: t19.string,
        priceIds: t19.array(t19.string),
        separateLineItem: t19.boolean,
        sequenceAccountId: t19.string,
        createdAt: t19.string,
        updatedAt: t19.string
      }),
      t19.partial({
        validFrom: t19.string,
        validTo: t19.string
      })
    ],
    "DiscountModel"
  )
);
var discountsResponse = createPaginatedResponseNew(
  discountModel,
  "DiscountsResponse"
);

// src/models/discount/decoder.ts
var toDiscount = (value) => {
  return parseResponse({
    value,
    codec: discountModel,
    callerFunctionName: "toDiscount"
  });
};
var toDiscountsResponse = (value) => {
  return parseResponse({
    value,
    codec: discountsResponse,
    callerFunctionName: "toDiscountsResponse"
  });
};

// src/models/discount/mocks.ts
var mockDiscount = {
  id: "d58bf2e3-7a5d-4900-8457-2521c6880f7d",
  amount: 25,
  billingScheduleId: "08a76ddb-230e-4700-a5e2-70f6edaf7d50",
  createdAt: "2022-06-28T16:47:00Z",
  discountCalculationType: "PERCENTAGE",
  message: "Loyalty Discount",
  priceIds: ["e007e884-5100-4183-8355-4771865cb4d7"],
  separateLineItem: false,
  sequenceAccountId: "1986c663-9ee9-4811-bfbf-57d2ad666096",
  updatedAt: "2022-06-28T16:47:00Z",
  validFrom: "2023-01-01",
  validTo: "2023-01-31"
};

// src/models/billingScheduleStatus/types.ts
import * as t20 from "io-ts";
var billingScheduleStatus = t20.keyof({
  DRAFT: null,
  PENDING: null,
  ACTIVE: null,
  SUSPENDED: null,
  CANCELLED: null,
  COMPLETED: null
});

// src/models/billingSchedule/types.ts
var productTaxRate = t21.exact(
  t21.type({
    priceId: t21.string,
    taxRateId: t21.string
  })
);
var billingScheduleType = t21.keyof({
  CUSTOM: null,
  PLAN: null,
  PHASES: null
});
var baseBillingScheduleRequiredFields = {
  id: t21.string,
  startDate: t21.string,
  autoIssueInvoices: t21.boolean
};
var minimum = t21.type({
  amount: t21.number,
  restrictToPrices: t21.array(t21.string)
});
var phaseDiscount = t21.type({
  restrictToPrices: t21.array(t21.string),
  type: discountCalculationType,
  amount: t21.number,
  message: t21.string,
  separateLineItem: t21.boolean
});
var relativePhaseDiscount = t21.type({
  id: t21.string,
  restrictToPrices: t21.array(t21.string),
  type: discountCalculationType,
  amount: t21.number,
  message: t21.string,
  separateLineItem: t21.boolean
});
var phase = t21.intersection([
  t21.type({
    id: t21.string,
    startDate: t21.string,
    priceIds: t21.array(t21.string)
  }),
  t21.partial({
    discounts: t21.array(phaseDiscount),
    minimums: t21.array(minimum),
    endDate: t21.string
  })
]);
var relativePhase = t21.intersection([
  t21.type({
    id: t21.string,
    priceIds: t21.array(t21.string),
    duration: t21.partial({
      years: t21.number,
      months: t21.number,
      weeks: t21.number,
      days: t21.number
    })
  }),
  t21.partial({
    discounts: t21.array(relativePhaseDiscount),
    minimums: t21.array(minimum)
  })
]);
var billingScheduleNonVersionFields = {
  id: t21.string,
  customerId: t21.string,
  sequenceAccountId: t21.string,
  status: billingScheduleStatus,
  createdAt: t21.string
};
var billingScheduleNonVersionPartialFields = {
  updatedAt: t21.string,
  archivedAt: t21.string,
  rollUpBilling: t21.boolean
};
var baseBillingSchedulePartialFields = {
  lastInvoiceId: t21.string,
  taxRates: t21.array(productTaxRate),
  purchaseOrderNumber: t21.string,
  firstBillingDate: t21.string,
  recurrenceDayOfMonth: t21.number,
  reference: t21.string,
  label: t21.string,
  endDate: t21.string
};
var customTypeBillingScheduleVersion = t21.exact(
  t21.intersection(
    [
      t21.type({
        ...baseBillingScheduleRequiredFields,
        type: t21.literal("CUSTOM"),
        priceIds: t21.array(t21.string),
        prices: t21.array(priceModel),
        version: t21.number
      }),
      t21.partial({
        ...baseBillingSchedulePartialFields,
        validityPeriod: t21.type({
          startDate: t21.string,
          endDate: t21.string
        })
      })
    ],
    "BillingScheduleModel"
  )
);
var planTypeBillingScheduleVersion = t21.exact(
  t21.intersection(
    [
      t21.type({
        ...baseBillingScheduleRequiredFields,
        type: t21.literal("PLAN"),
        planId: t21.string,
        version: t21.number
      }),
      t21.partial({
        ...baseBillingSchedulePartialFields,
        validityPeriod: t21.type({
          startDate: t21.string,
          endDate: t21.string
        })
      })
    ],
    "BillingScheduleModel"
  )
);
var billingScheduleVersion = t21.union(
  [planTypeBillingScheduleVersion, customTypeBillingScheduleVersion],
  "BillingScheduleVersion"
);
var phasesTypeBillingScheduleModel = t21.exact(
  t21.intersection(
    [
      t21.type({
        ...baseBillingScheduleRequiredFields,
        ...billingScheduleNonVersionFields,
        startDate: t21.string,
        type: t21.literal("PHASES"),
        priceIds: t21.array(t21.string),
        phases: t21.array(phase)
      }),
      t21.partial({
        ...baseBillingSchedulePartialFields,
        ...billingScheduleNonVersionPartialFields
      })
    ],
    "BillingScheduleModel"
  )
);
var customTypeBillingScheduleModel = t21.exact(
  t21.intersection(
    [
      t21.type({
        ...baseBillingScheduleRequiredFields,
        ...billingScheduleNonVersionFields,
        type: t21.literal("CUSTOM"),
        priceIds: t21.array(t21.string),
        prices: t21.array(priceModel)
      }),
      t21.partial({
        activeVersion: billingScheduleVersion,
        futureVersions: t21.array(billingScheduleVersion),
        ...baseBillingSchedulePartialFields,
        ...billingScheduleNonVersionPartialFields
      })
    ],
    "BillingScheduleModel"
  )
);
var planTypeBillingScheduleModel = t21.exact(
  t21.intersection(
    [
      t21.type({
        ...baseBillingScheduleRequiredFields,
        ...billingScheduleNonVersionFields,
        type: t21.literal("PLAN"),
        planId: t21.string
      }),
      t21.partial({
        ...baseBillingSchedulePartialFields,
        ...billingScheduleNonVersionPartialFields
      })
    ],
    "BillingScheduleModel"
  )
);
var billingScheduleModel = t21.union(
  [
    customTypeBillingScheduleModel,
    planTypeBillingScheduleModel,
    phasesTypeBillingScheduleModel
  ],
  "BillingScheduleModel"
);
var billingScheduleResponse = t21.intersection([
  t21.type({
    ...billingScheduleNonVersionFields,
    activeVersion: billingScheduleVersion,
    futureVersions: t21.array(billingScheduleVersion)
  }),
  t21.partial({
    type: billingScheduleType,
    ...billingScheduleNonVersionPartialFields,
    autoIssueInvoices: t21.boolean,
    recurrenceDayOfMonth: t21.number,
    startDate: t21.string,
    endDate: t21.string,
    taxRates: t21.array(productTaxRate),
    phases: t21.array(phase)
  })
]);
var billingScheduleUpdateResponse = billingScheduleModel;
var billingSchedulesResponse = createPaginatedResponseNew(
  billingScheduleModel,
  "BillingSchedulesResponse"
);

// src/models/billingSchedule/mocks.ts
var mockBillingSchedules = [
  {
    id: "9963ccc9-de6b-44b6-89ad-ff663474810f",
    planId: "plan-id-1",
    createdAt: "2022-09-21T08:52:34.865619Z",
    customerId: "customer-id-1",
    firstBillingDate: "2022-09-21T08:52:34.865619Z",
    sequenceAccountId: "3ba1ff62-f12b-4aa2-93c5-8c813f07de6e",
    status: "ACTIVE",
    startDate: "2022-01-01T12:00:00Z",
    endDate: "2022-12-01T12:00:00Z",
    autoIssueInvoices: false,
    taxRates: [
      {
        priceId: "productId1",
        taxRateId: "taxRateId1"
      }
    ],
    type: "PLAN"
  },
  {
    id: "ed1d1855-52e4-4b2b-b1a3-c0f312b298e7",
    customerId: "customer-id-2",
    planId: "plan-id-2",
    createdAt: "2022-09-21T08:52:34.833662Z",
    firstBillingDate: "2022-09-21T08:52:34.833662Z",
    sequenceAccountId: "3ba1ff62-f12b-4aa2-93c5-8c813f07de6e",
    status: "PENDING",
    startDate: "2022-01-01T12:00:00Z",
    endDate: "2022-12-01T12:00:00Z",
    autoIssueInvoices: false,
    taxRates: [
      {
        priceId: "productId2",
        taxRateId: "taxRateId2"
      }
    ],
    type: "PLAN"
  },
  {
    id: "2635be2f-2c42-48dd-933e-ed3489d834f1",
    customerId: "customer-id-3",
    createdAt: "2022-09-21T08:52:34.833662Z",
    firstBillingDate: "2022-09-21T08:52:34.833662Z",
    sequenceAccountId: "3ba1ff62-f12b-4aa2-93c5-8c813f07de6e",
    status: "ACTIVE",
    startDate: "2022-01-01T12:00:00Z",
    endDate: "2022-12-01T12:00:00Z",
    autoIssueInvoices: false,
    taxRates: [
      {
        priceId: "productId3",
        taxRateId: "taxRateId2"
      }
    ],
    type: "CUSTOM",
    priceIds: ["productId3"],
    prices: [mockPriceOneTime],
    activeVersion: {
      priceIds: ["0185ghb2-58e1-7243-8500-da09a5690374"],
      id: "018a0aa4-7369-7165-adf2-74b12e9afc2f",
      startDate: "2023-08-18T00:00:00Z",
      endDate: "2024-08-17T00:00:00Z",
      taxRates: [
        {
          priceId: "0185ghb2-58e1-7243-8500-da09a5690374",
          taxRateId: "0185edb2-58e1-7243-8500-da09a5690374"
        }
      ],
      autoIssueInvoices: false,
      recurrenceDayOfMonth: 10,
      type: "CUSTOM",
      version: 1,
      prices: [mockPriceOneTime]
    },
    futureVersions: []
  }
];
var mockBillingSchedulesResponse = {
  items: mockBillingSchedules,
  pagination: mockPagination
};
var mockBillingScheduleResponses = {
  plan: {
    type: "PLAN",
    id: "123a0aa4-7369-7165-adf2-74b12e9afc2f",
    status: "ACTIVE",
    customerId: "018a0511-4e46-752b-9808-a4695913e256",
    sequenceAccountId: "01846169-ff67-772c-bc6d-6b2b82ee1de5",
    createdAt: "2023-08-18T21:54:24.638393Z",
    updatedAt: "2023-08-18T21:54:24.638393Z",
    activeVersion: {
      id: "018a0aa4-7369-7165-adf2-74b12e9afc2f",
      /**
       * This needs to be a specific id in order to match up to the default mocks
       * in the mockServer packages. See mocks.ts in the mockServer packages for
       * more options and what they will return.
       */
      planId: "plan-id-1",
      startDate: "2023-08-18T00:00:00Z",
      endDate: "2024-08-17T00:00:00Z",
      taxRates: [
        {
          priceId: "018a08dd-75d3-7511-9901-1c73abffa152",
          taxRateId: "0185edb2-58e1-7243-8500-da09a5690374"
        },
        {
          priceId: "018a090a-267b-7c45-bf5d-c364eee670d0",
          taxRateId: "0185edb2-58e1-7243-8500-da09a5690374"
        }
      ],
      autoIssueInvoices: false,
      recurrenceDayOfMonth: 10,
      type: "PLAN",
      version: 1
    },
    futureVersions: []
  },
  custom: {
    type: "CUSTOM",
    id: "456a0aa4-7369-7165-adf2-74b12e9afc2f",
    status: "ACTIVE",
    customerId: "018a0511-4e46-752b-9808-a4695913e256",
    sequenceAccountId: "01846169-ff67-772c-bc6d-6b2b82ee1de5",
    createdAt: "2023-08-18T21:54:24.638393Z",
    updatedAt: "2023-08-18T21:54:24.638393Z",
    activeVersion: {
      priceIds: ["0185ghb2-58e1-7243-8500-da09a5690374"],
      id: "018a0aa4-7369-7165-adf2-74b12e9afc2f",
      startDate: "2023-08-18T00:00:00Z",
      endDate: "2024-08-17T00:00:00Z",
      taxRates: [
        {
          priceId: "0185ghb2-58e1-7243-8500-da09a5690374",
          taxRateId: "0185edb2-58e1-7243-8500-da09a5690374"
        }
      ],
      autoIssueInvoices: false,
      recurrenceDayOfMonth: 10,
      type: "CUSTOM",
      version: 1,
      prices: [mockPriceOneTime]
    },
    futureVersions: []
  },
  phases: {
    activeVersion: {
      priceIds: ["0185ghb2-58e1-7243-8500-da09a5690374"],
      id: "018a0aa4-7369-7165-adf2-74b12e9afc2f",
      startDate: "2023-08-18T00:00:00Z",
      endDate: "2024-08-17T00:00:00Z",
      taxRates: [
        {
          priceId: "0185ghb2-58e1-7243-8500-da09a5690374",
          taxRateId: "0185edb2-58e1-7243-8500-da09a5690374"
        }
      ],
      autoIssueInvoices: false,
      recurrenceDayOfMonth: 10,
      type: "CUSTOM",
      version: 1,
      prices: [mockPriceOneTime]
    },
    futureVersions: [],
    type: "PHASES",
    id: "456a0aa4-7369-7165-adf2-74b12e9afc2f",
    autoIssueInvoices: false,
    recurrenceDayOfMonth: 10,
    status: "ACTIVE",
    customerId: "018a0511-4e46-752b-9808-a4695913e256",
    sequenceAccountId: "01846169-ff67-772c-bc6d-6b2b82ee1de5",
    createdAt: "2023-08-18T21:54:24.638393Z",
    updatedAt: "2023-08-18T21:54:24.638393Z",
    startDate: "2024-01-01",
    endDate: "2024-05-02",
    taxRates: [],
    phases: [
      {
        id: "phase-1",
        startDate: "2024-01-01",
        endDate: "2024-05-02",
        priceIds: ["0185ghb2-58e1-7243-8500-da09a5690374"],
        discounts: [],
        minimums: []
      },
      {
        id: "phase-2",
        startDate: "2024-01-01",
        endDate: "2024-05-02",
        priceIds: ["0185ghb2-58e1-7243-8500-da09a5690374"],
        discounts: [],
        minimums: []
      }
    ]
  }
};
var mockBillingScheduleUpdateResponse = {
  id: "018a0aa4-7369-7165-adf2-74b12e9afc2f",
  createdAt: "2023-08-18T21:54:24.638393Z",
  updatedAt: "2023-08-18T21:54:24.638393Z",
  sequenceAccountId: "01846169-ff67-772c-bc6d-6b2b82ee1de5",
  status: "ACTIVE",
  planId: "018a08dc-e014-7443-a48e-9d82019447fc",
  customerId: "018a0511-4e46-752b-9808-a4695913e256",
  startDate: "2023-08-18T00:00:00Z",
  endDate: "2024-08-17T00:00:00Z",
  taxRates: [
    {
      priceId: "018a08dd-75d3-7511-9901-1c73abffa152",
      taxRateId: "0185edb2-58e1-7243-8500-da09a5690374"
    },
    {
      priceId: "018a090a-267b-7c45-bf5d-c364eee670d0",
      taxRateId: "0185edb2-58e1-7243-8500-da09a5690374"
    }
  ],
  autoIssueInvoices: false,
  recurrenceDayOfMonth: 10,
  type: "PLAN"
};

// src/models/billingSchedule/decoder.ts
var toBillingScheduleResponse = (value) => {
  return parseResponse({
    value,
    codec: billingScheduleResponse,
    callerFunctionName: "toBillingScheduleResponse"
  });
};
var toBillingScheduleUpdateResponse = (value) => {
  return parseResponse({
    value,
    codec: billingScheduleUpdateResponse,
    callerFunctionName: "toBillingScheduleUpdateResponse"
  });
};
var toBillingSchedulesResponse = (value) => {
  return parseResponse({
    value,
    codec: billingSchedulesResponse,
    callerFunctionName: "toBillingSchedulesResponse"
  });
};

// src/models/billingSchedulePreview/types.ts
import * as t22 from "io-ts";
var billingPeriodModel = t22.strict({
  start: t22.string,
  end: t22.string
});
var billingSchedulePreviewModel = t22.strict(
  {
    occurrences: t22.array(billingPeriodModel)
  },
  "BillingSchedulePreviewModel"
);

// src/models/billingSchedulePreview/decoder.ts
var toBillingSchedulePreview = (value) => {
  return parseResponse({
    value,
    codec: billingSchedulePreviewModel,
    callerFunctionName: "toBillingSchedulePreview"
  });
};

// src/models/billingSchedulePreview/mocks.ts
var mockBillingSchedulePreview = {
  occurrences: [
    {
      start: "2022-01-01",
      end: "2022-01-31"
    },
    {
      start: "2022-02-01",
      end: "2022-02-28"
    },
    {
      start: "2022-03-01",
      end: "2022-03-31"
    }
  ]
};

// src/models/billingScheduleSettings/types.ts
import * as t23 from "io-ts";
var paymentProvider = t23.keyof({
  STRIPE: null,
  NONE: null
});
var billingScheduleSettingsModel = t23.strict(
  {
    id: t23.string,
    billingScheduleId: t23.string,
    sequenceAccountId: t23.string,
    paymentProvider
  },
  "BillingScheduleSettingsModel"
);

// src/models/billingScheduleSettings/decoder.ts
var toBillingScheduleSettings = (value) => {
  return parseResponse({
    value,
    codec: billingScheduleSettingsModel,
    callerFunctionName: "toBillingScheduleSettings"
  });
};

// src/models/billingScheduleSettings/mocks.ts
var mockBillingScheduleSettings = {
  id: "15b0ea6f-8fb2-4e15-94dc-1df221159e59",
  billingScheduleId: "c09cb3cd-ea02-4fd6-83e6-78b6db91ddbe",
  sequenceAccountId: "cb78d7aa-3b5a-4888-9b6b-f4f0fda4db0d",
  paymentProvider: "STRIPE"
};

// src/models/branding/types.ts
import * as t24 from "io-ts";
var brandingModel = t24.exact(
  t24.intersection([
    t24.type({
      legalCompanyName: t24.string,
      address: addressModel,
      email: t24.string
    }),
    t24.partial({
      primaryColour: t24.string,
      logoUrl: t24.string,
      url: t24.string
    })
  ])
);

// src/models/branding/mocks.ts
var mockBranding = {
  legalCompanyName: "Acme Corp",
  email: "merchant@example.com",
  address: {
    line1: "15 Yemen Road",
    line2: "Road",
    town: "Yemen",
    postcode: "YE1 2YE",
    country: "GB"
  }
};

// src/models/branding/decoder.ts
var toBranding = (value) => {
  return parseResponse({
    value,
    codec: brandingModel,
    callerFunctionName: "toBranding"
  });
};

// src/models/bulk/decoder.ts
import * as t25 from "io-ts";
var toOK = (value) => {
  return parseResponse({
    value,
    codec: t25.string,
    callerFunctionName: "toOK"
  });
};
var toUndefined = (value) => {
  return parseResponse({
    value,
    codec: t25.undefined,
    callerFunctionName: "toUndefined"
  });
};

// src/models/contact/decoder.ts
var toContact = (value) => {
  return parseResponse({
    value,
    codec: contactModel,
    callerFunctionName: "toContactResponse"
  });
};

// src/models/contact/mocks.ts
var mockContact = {
  id: "9a1e38a9-4dc9-776f-f974-4e7ee9f4d6cc",
  contactType: "QUOTE_RECIPIENT",
  customerId: "e309e948-088e-4d77-b654-cd85498f1555",
  email: "jane.smith@example.com",
  sequenceAccountId: "25b3c342-6fa6-4375-9ed3-616f05abb77a",
  name: "Jane Smith",
  createdAt: "2022-06-28T16:47:00Z",
  deletedAt: "2022-06-28T16:47:00Z"
};

// src/models/contact/types.ts
import * as t26 from "io-ts";
var contactType = t26.keyof({
  BILLING_PRIMARY: null,
  BILLING: null,
  CUSTOMER_PRIMARY: null,
  QUOTE_RECIPIENT: null
});
var contactModel = t26.exact(
  t26.intersection([
    t26.type({
      id: t26.string,
      contactType,
      createdAt: t26.string,
      customerId: t26.string,
      email: t26.string,
      sequenceAccountId: t26.string,
      name: t26.string
    }),
    t26.partial({
      deletedAt: t26.string
    })
  ])
);

// src/models/country/format.ts
var toCountryLabel = (country2) => {
  return countries[country2];
};

// src/models/creditGrant/types.ts
import * as t27 from "io-ts";
var creditUnitType = t27.keyof({
  CURRENCY: null,
  METRIC: null
});
var creditGrantModel = t27.exact(
  t27.intersection([
    t27.type({
      id: t27.string,
      amount: t27.number,
      costOfCredit: t27.number,
      currency,
      createdAt: t27.string,
      creditUnitType,
      customerId: t27.string,
      sequenceAccountId: t27.string,
      name: t27.string
    }),
    t27.partial({
      effectiveDate: t27.string,
      expiryDate: t27.string,
      metricId: t27.string,
      taxRateId: t27.string
    })
  ])
);
var creditGrantsResponse = createPaginatedResponseNew(
  creditGrantModel,
  "CreditGrantsResponse"
);
var creditBalanceModel = t27.exact(
  t27.intersection([
    t27.type({
      id: t27.string,
      balance: t27.number,
      grantAmount: t27.number,
      issueDate: t27.string,
      name: t27.string
    }),
    t27.partial({
      expiryDate: t27.string
    })
  ])
);
var creditBalancesModel = t27.exact(
  t27.type({
    items: t27.array(creditBalanceModel)
  })
);

// src/models/creditGrant/decoder.ts
var toCreditGrant = (value) => {
  return parseResponse({
    value,
    codec: creditGrantModel,
    callerFunctionName: "toCreditGrant"
  });
};
var toCreditGrantsResponse = (value) => {
  return parseResponse({
    value,
    codec: creditGrantsResponse,
    callerFunctionName: "toCreditGrantsResponse"
  });
};
var toCreditBalances = (value) => {
  return parseResponse({
    value,
    codec: creditBalancesModel,
    callerFunctionName: "toCreditBalancesResponse"
  });
};

// src/models/creditGrant/format.ts
var creditUnitTypeLabelMap = {
  CURRENCY: "Cash",
  METRIC: "Units"
};

// src/models/creditGrant/mocks.ts
var mockCreditGrant = {
  id: "credit-grant-1",
  amount: 10,
  costOfCredit: 10,
  createdAt: "2023-01-03",
  creditUnitType: "CURRENCY",
  currency: "GBP",
  customerId: "customer-id-1",
  effectiveDate: "2023-01-01",
  expiryDate: "2023-01-31",
  metricId: "f092246c-6b90-4106-bcca-304ccf06bf45",
  name: "On-boarding Credits",
  sequenceAccountId: "dce9ae85-d8d0-42b4-bcad-f221a64363c6"
};
var mockCreditGrants = [mockCreditGrant];
var mockCreditGrantsResponse = {
  items: mockCreditGrants,
  pagination: { totalResultSize: 1 }
};
var mockCreditBalance = {
  id: "credit-balance-1",
  balance: 10,
  grantAmount: 100,
  issueDate: "2022-02-22",
  name: "Onboarding credits"
};
var mockCreditBalances = [mockCreditBalance];
var mockCreditBalancesResponse = {
  items: mockCreditBalances,
  pagination: { totalResultSize: 1 }
};

// src/models/creditGrantStatus/format.tsx
var statusToFormat = {
  ACTIVE: {
    children: "Active",
    sentiment: "info"
  },
  EXPIRED: {
    children: "Expired",
    sentiment: "error"
  }
};
var transformCreditGrantExpiry = (value) => {
  if (!value) {
    return "ACTIVE";
  }
  const dateObject = new Date(Date.parse(value));
  if (dateObject.toString() === "Invalid Date") {
    return "ACTIVE";
  }
  if (Date.now() < dateObject.valueOf()) {
    return "ACTIVE";
  } else {
    return "EXPIRED";
  }
};
var toCreditGrantStatusBadgeProps = ({
  status,
  size = "md"
}) => ({
  ...statusToFormat[status],
  size
});

// src/models/creditGrantStatus/types.ts
import * as t28 from "io-ts";
var creditGrantStatus = t28.keyof({
  ACTIVE: null,
  EXPIRED: null
});

// src/models/creditNote/types.ts
import * as t38 from "io-ts";

// src/models/invoice/types.ts
import * as t37 from "io-ts";

// src/models/customer/types.ts
import * as t31 from "io-ts";

// src/models/linkInfoKeyValue/types.ts
import * as t29 from "io-ts";
var linkInfoKeyValue = t29.exact(
  t29.intersection([
    t29.type({
      value: t29.string,
      key: integrationService,
      syncTime: t29.string
    }),
    t29.partial({
      externalUrl: t29.string
    })
  ])
);
var createLinkInfoKeyValue = t29.exact(
  t29.type({
    value: t29.string,
    key: integrationService
  })
);

// src/models/linkInfo/types.ts
import * as t30 from "io-ts";
var linkInfo = t30.exact(
  t30.intersection([
    t30.type({
      externalId: t30.string,
      externalService: integrationService,
      syncTime: t30.string
    }),
    t30.partial({
      externalUrl: t30.string
    })
  ])
);
var createLinkInfo = t30.exact(
  t30.type({
    externalId: t30.string,
    externalService: integrationService
  })
);

// src/models/customer/types.ts
var taxStatus = t31.keyof({
  TAXED: null,
  TAX_EXEMPT: null,
  REVERSE_CHARGED: null
});
var customerModel = t31.exact(
  t31.intersection(
    [
      t31.type({
        id: t31.string,
        sequenceAccountId: t31.string,
        createdAt: t31.string,
        legalName: t31.string,
        taxStatus,
        address: addressModel,
        email: t31.string,
        externalIds: t31.array(linkInfoKeyValue),
        billingEmails: t31.array(t31.string)
      }),
      t31.partial({
        contactName: t31.string,
        contacts: t31.array(contactModel),
        label: t31.string,
        linkedServices: t31.array(linkInfo),
        paymentReference: t31.string,
        telephone: t31.string,
        url: t31.string,
        archivedAt: t31.string
      })
    ],
    "CustomerModel"
  )
);
var customersResponse = createPaginatedResponseNew(
  customerModel,
  "CustomersResponse"
);
var customerResponseModel = t31.exact(
  t31.type({
    customer: customerModel
  })
);

// src/models/dates/types.ts
import * as t32 from "io-ts";
var inclusiveDateRange = t32.exact(
  t32.type({
    start: t32.string,
    endInclusive: t32.string
  })
);

// src/models/invoiceMerchantDetails/types.ts
import * as t33 from "io-ts";
var invoiceMerchantDetailsModel = t33.exact(
  t33.intersection(
    [
      t33.type({
        address: addressModel,
        email: t33.string,
        legalCompanyName: t33.string,
        customFields: t33.array(keyValuePairModel),
        includeBeneficiaryAddressInPaymentDetails: t33.boolean
      }),
      t33.partial({
        phoneNumber: t33.string,
        iban: t33.string,
        ukAccountDetails: sortCodeAccountNumberModel,
        usAchDetails: usAchDestinationModel,
        usWireDetails: usWireDestinationModel,
        caBankAccountDetails: canadianDestinationModel,
        canadianInternationalDestination: canadianInternationalDestinationModel,
        australianDestination: australianDestinationModel,
        logoUrl: t33.string,
        primaryColour: t33.string,
        taxId: t33.string
      })
    ],
    "InvoiceMerchantDetailsModel"
  )
);

// src/models/invoiceMerchantDetails/mocks.ts
var mockInvoiceMerchantDetails = {
  address: {
    line1: "15 Yemen Road",
    town: "Yemen",
    postcode: "YE1 2YE",
    country: "GB"
  },
  email: "merchant@example.com",
  taxId: "TAX123",
  legalCompanyName: "The merchant",
  customFields: [],
  includeBeneficiaryAddressInPaymentDetails: true
};

// src/models/invoiceMerchantDetails/decoder.ts
var toInvoiceMerchantDetails = (value) => {
  return parseResponse({
    value,
    codec: invoiceMerchantDetailsModel,
    callerFunctionName: "toInvoiceMerchantDetailsResponse"
  });
};

// src/models/invoicePaymentStatus/format.tsx
var statusToFormat2 = {
  UNPAID: {
    children: "Unpaid",
    sentiment: "neutral"
  },
  PARTIALLY_PAID: {
    children: "Partially paid",
    sentiment: "neutral"
  },
  PAID: {
    children: "Paid",
    sentiment: "success"
  },
  UNCOLLECTIBLE: {
    children: "Uncollectible",
    sentiment: "warning"
  }
};
var toInvoicePaymentStatusBadgeProps = ({
  status,
  size = "md"
}) => ({
  ...statusToFormat2[status],
  size
});
var toInvoicePaymentStatusText = (status) => statusToFormat2[status].children;

// src/models/invoicePaymentStatus/types.ts
import * as t34 from "io-ts";
var invoicePaymentStatus = t34.keyof({
  UNPAID: null,
  PARTIALLY_PAID: null,
  PAID: null,
  UNCOLLECTIBLE: null
});

// src/models/invoiceStatus/format.tsx
var statusToFormat3 = {
  IN_PROGRESS: {
    children: "Upcoming",
    sentiment: "info"
  },
  DRAFT: {
    children: "Draft",
    sentiment: "neutral"
  },
  FINAL: {
    children: "Final",
    sentiment: "info"
  },
  VOIDED: {
    children: "Void",
    sentiment: "neutral"
  },
  SENT: {
    children: "Sent",
    sentiment: "success"
  }
};
var toInvoiceStatusBadgeProps = ({
  status,
  size = "md"
}) => ({
  ...statusToFormat3[status],
  size
});

// src/models/invoiceStatus/types.ts
import * as t35 from "io-ts";
var invoiceStatus = t35.keyof({
  IN_PROGRESS: null,
  DRAFT: null,
  FINAL: null,
  SENT: null,
  VOIDED: null
});

// src/models/invoiceRenderSettings/types.ts
import * as t36 from "io-ts";
var paymentLinkDisplay = t36.keyof({
  SHOW_PAYMENT_LINK: null,
  HIDE_PAYMENT_LINK: null
});
var invoiceRenderSettingsModel = t36.exact(
  t36.type({
    paymentLinkDisplay
  }),
  "InvoiceRenderSettingsModel"
);

// src/models/invoice/types.ts
var invoicePaymentOption = t37.keyof({
  BANK_TRANSFER: null,
  LINK: null
});
var invoiceSubAccountUsage = t37.type({
  title: t37.string,
  value: t37.string,
  id: t37.string,
  lineItemGroupId: t37.string,
  usageItemGroupId: t37.string,
  groupedValues: t37.array(
    t37.type({
      grouping: t37.string,
      value: t37.number
    })
  ),
  invoiceId: t37.string
});
var invoiceUsageItemGroup = t37.type({
  id: t37.string,
  invoiceId: t37.string,
  title: t37.string,
  items: t37.array(invoiceSubAccountUsage)
});
var invoiceUsageItemGroupResponse = t37.type({
  items: t37.array(invoiceUsageItemGroup)
});
var invoiceModel = t37.exact(
  t37.intersection(
    [
      t37.type({
        id: t37.string,
        sequenceAccountId: t37.string,
        status: invoiceStatus,
        currency,
        customerLegalCompanyName: t37.string,
        customerBillingAddress: addressModel,
        customerShippingAddress: addressModel,
        paymentStatus: invoicePaymentStatus,
        totalTax: t37.string,
        netTotal: t37.string,
        grossTotal: t37.string,
        metadata: t37.array(keyValuePairModel),
        customerEmails: t37.array(t37.string),
        customerId: t37.string,
        creditNoteIds: t37.array(t37.string),
        linkedServices: t37.array(linkInfo),
        accountingDate: t37.string,
        createdAt: t37.string
      }),
      t37.partial({
        customerEmail: t37.string,
        invoiceNumber: t37.string,
        issueDate: t37.string,
        dueDate: t37.string,
        purchaseOrderNumber: t37.string,
        memo: t37.string,
        billingScheduleId: t37.string,
        billingPeriod: inclusiveDateRange,
        calculatedAt: t37.string,
        customerTaxId: t37.string,
        creditBalances: t37.string,
        merchantDetails: invoiceMerchantDetailsModel,
        paymentOptions: t37.array(invoicePaymentOption),
        reference: t37.string,
        customerTaxStatus: taxStatus,
        renderSettings: invoiceRenderSettingsModel,
        isCustomerArchived: t37.boolean
      })
    ],
    "InvoiceModel"
  )
);
var totalsModel = t37.exact(
  t37.type({
    netTotal: t37.string,
    totalTax: t37.string,
    grossTotal: t37.string
  })
);
var invoiceTotalsModel = t37.exact(
  t37.type({
    total: totalsModel,
    lineItemGroupTotals: t37.array(
      t37.exact(t37.type({ id: t37.string, total: totalsModel }))
    ),
    lineItemTotals: t37.array(
      t37.exact(t37.type({ id: t37.string, total: totalsModel }))
    )
  }),
  "InvoiceTotalsModel"
);

// src/models/lineItem/mocks.ts
var mockLineItems = [
  {
    id: "line-item-1",
    invoiceId: "invoice-1",
    title: "title",
    description: "description",
    quantity: "1",
    rate: "10",
    taxRate: "0.2",
    index: 1,
    netTotal: "1",
    totalTax: "0.2",
    grossTotal: "1.2",
    rateDisplay: "ABSOLUTE",
    externalIds: [
      {
        key: "Xero",
        value: "123"
      }
    ]
  },
  {
    id: "line-item-2",
    invoiceId: "invoice-1",
    title: "title",
    description: "description",
    quantity: "1",
    rate: "10",
    taxRate: "0.2",
    index: 2,
    netTotal: "1",
    totalTax: "0.2",
    grossTotal: "1.2",
    rateDisplay: "ABSOLUTE",
    externalIds: [
      {
        key: "Xero",
        value: "123"
      }
    ]
  },
  {
    id: "line-item-3",
    invoiceId: "invoice-1",
    title: "discount",
    description: "discounted rate",
    quantity: "1",
    rate: "-10",
    taxRate: "0.2",
    index: 3,
    netTotal: "1",
    totalTax: "0.2",
    grossTotal: "1.2",
    rateDisplay: "ABSOLUTE",
    externalIds: [
      {
        key: "Xero",
        value: "123"
      }
    ]
  }
];
var mockLineItemsResponse = {
  items: mockLineItems,
  pagination: mockPagination
};
var mockLineItemsResponseUnpaginated = {
  items: mockLineItems
};

// src/models/lineItemGroup/mocks.ts
var mockLineItemGroups = [
  {
    id: "line-item-1",
    invoiceId: "invoice-1",
    title: "title",
    description: "description",
    index: 1,
    netTotal: "1",
    totalTax: "0.2",
    grossTotal: "1.2"
  },
  {
    id: "line-item-2",
    invoiceId: "invoice-1",
    title: "title",
    description: "description",
    index: 2,
    netTotal: "1",
    totalTax: "0.2",
    grossTotal: "1.2"
  }
];
var mockLineItemGroupsResponse = {
  items: mockLineItemGroups,
  pagination: mockPagination
};
var mockLineItemGroupsResponseUnpaginated = {
  items: mockLineItemGroups
};

// src/models/invoice/mocks.ts
var mockDraftInvoice = {
  id: "invoice-1",
  sequenceAccountId: "ABC",
  status: "DRAFT",
  paymentStatus: "UNPAID",
  currency: "GBP",
  customerEmails: ["customer@example.com"],
  customerLegalCompanyName: "The Customer 1",
  customerBillingAddress: {
    line1: "15 Yemen Road",
    line2: "Road",
    town: "Yemen",
    postcode: "YE1 2YE",
    country: "GB"
  },
  customerShippingAddress: {
    line1: "15 Yemen Road",
    line2: void 0,
    town: "Yemen",
    postcode: "YE1 2YE",
    country: "GB"
  },
  isCustomerArchived: false,
  totalTax: "0",
  netTotal: "0",
  grossTotal: "0",
  issueDate: void 0,
  dueDate: "2022-11-25",
  purchaseOrderNumber: "PO123",
  customerId: "ID",
  memo: "Thanks",
  metadata: [],
  billingPeriod: { start: "2022-08-25", endInclusive: "2022-09-25" },
  accountingDate: "2022-09-25",
  createdAt: "2022-10-25T12:24:08.018565Z",
  customerTaxId: "TAX123",
  billingScheduleId: "9e73c8d9-bd9a-4483-83e4-5bf7967fa9df",
  creditNoteIds: ["id"],
  linkedServices: [],
  calculatedAt: "2022-10-21T13:24:08.018565Z"
};
var mockFinalInvoice = {
  id: "invoice-2",
  sequenceAccountId: "ABC",
  status: "FINAL",
  paymentStatus: "PARTIALLY_PAID",
  currency: "GBP",
  invoiceNumber: "INV00002",
  customerEmails: ["customer@example.com"],
  customerLegalCompanyName: "The Customer 2",
  customerBillingAddress: {
    line1: "15 Yemen Road",
    line2: void 0,
    town: "Yemen",
    postcode: "YE1 2YE",
    country: "GB"
  },
  customerShippingAddress: {
    line1: "15 Yemen Road",
    line2: void 0,
    town: "Yemen",
    postcode: "YE1 2YE",
    country: "GB"
  },
  isCustomerArchived: false,
  paymentOptions: ["BANK_TRANSFER"],
  totalTax: "0",
  netTotal: "0",
  grossTotal: "0",
  issueDate: void 0,
  dueDate: void 0,
  purchaseOrderNumber: void 0,
  customerId: "ID",
  memo: void 0,
  metadata: [],
  creditNoteIds: ["id"],
  linkedServices: [],
  accountingDate: "2022-09-25",
  merchantDetails: mockInvoiceMerchantDetails,
  createdAt: "2022-10-25T12:24:08.018565Z"
};
var mockVoidInvoice = {
  id: "invoice-3",
  sequenceAccountId: "ABC",
  status: "VOIDED",
  paymentStatus: "UNPAID",
  currency: "GBP",
  invoiceNumber: "INV00003",
  customerEmails: ["customer@example.com"],
  customerLegalCompanyName: "The Customer 3",
  customerBillingAddress: {
    line1: "15 Yemen Road",
    line2: void 0,
    town: "Yemen",
    postcode: "YE1 2YE",
    country: "GB"
  },
  customerShippingAddress: {
    line1: "15 Yemen Road",
    line2: void 0,
    town: "Yemen",
    postcode: "YE1 2YE",
    country: "GB"
  },
  isCustomerArchived: false,
  paymentOptions: ["BANK_TRANSFER"],
  totalTax: "0",
  netTotal: "0",
  grossTotal: "0",
  issueDate: void 0,
  dueDate: void 0,
  purchaseOrderNumber: void 0,
  customerId: "ID",
  memo: void 0,
  metadata: [],
  creditNoteIds: ["id"],
  linkedServices: [],
  accountingDate: "2022-09-25",
  merchantDetails: mockInvoiceMerchantDetails,
  createdAt: "2022-10-25T12:24:08.018565Z"
};
var mockInProgressInvoice = {
  id: "invoice-5",
  sequenceAccountId: "ABC",
  status: "IN_PROGRESS",
  paymentStatus: "UNPAID",
  currency: "GBP",
  customerEmails: ["customer@example.com"],
  customerLegalCompanyName: "The Customer 1",
  customerBillingAddress: {
    line1: "15 Yemen Road",
    line2: "Road",
    town: "Yemen",
    postcode: "YE1 2YE",
    country: "GB"
  },
  customerShippingAddress: {
    line1: "15 Yemen Road",
    line2: void 0,
    town: "Yemen",
    postcode: "YE1 2YE",
    country: "GB"
  },
  isCustomerArchived: false,
  totalTax: "0",
  netTotal: "0",
  grossTotal: "0",
  issueDate: void 0,
  dueDate: void 0,
  purchaseOrderNumber: "PO123",
  customerId: "ID",
  memo: "Thanks",
  metadata: [],
  billingPeriod: { start: "2022-08-25", endInclusive: "2022-09-25" },
  accountingDate: "2022-09-25",
  createdAt: "2022-10-25T12:24:08.018565Z",
  customerTaxId: "TAX123",
  billingScheduleId: "9e73c8d9-bd9a-4483-83e4-5bf7967fa9df",
  creditNoteIds: ["id"],
  linkedServices: [],
  calculatedAt: "2022-10-23T13:24:08.018565Z"
};
var mockInvoices = [
  mockDraftInvoice,
  mockFinalInvoice,
  mockVoidInvoice,
  {
    id: "invoice-4",
    sequenceAccountId: "ABC",
    status: "FINAL",
    paymentStatus: "PAID",
    currency: "GBP",
    invoiceNumber: "INV00004",
    customerEmails: ["customer@example.com"],
    customerLegalCompanyName: "The Customer 4",
    customerBillingAddress: {
      line1: "15 Yemen Road",
      line2: void 0,
      town: "Yemen",
      postcode: "YE1 2YE",
      country: "GB"
    },
    customerShippingAddress: {
      line1: "15 Yemen Road",
      line2: void 0,
      town: "Yemen",
      postcode: "YE1 2YE",
      country: "GB"
    },
    isCustomerArchived: false,
    paymentOptions: ["BANK_TRANSFER"],
    totalTax: "0",
    netTotal: "0",
    grossTotal: "0",
    issueDate: void 0,
    dueDate: void 0,
    purchaseOrderNumber: void 0,
    customerId: "ID",
    memo: void 0,
    metadata: [],
    creditNoteIds: ["id"],
    linkedServices: [],
    accountingDate: "2022-09-25",
    createdAt: "2022-10-25T12:24:08.018565Z"
  }
];
var mockInvoicesResponse = {
  items: mockInvoices,
  pagination: mockPagination
};
var mockInvoicesResponseNoAdditionalFields = {
  items: [mockInvoices[1]],
  pagination: mockPagination
};
var mockInvoiceTotals = {
  total: {
    totalTax: "0",
    netTotal: "0",
    grossTotal: "0"
  },
  lineItemGroupTotals: [
    {
      id: mockLineItemGroups[0].id,
      total: {
        totalTax: "0",
        netTotal: "0",
        grossTotal: "0"
      }
    }
  ],
  lineItemTotals: [
    {
      id: mockLineItems[0].id,
      total: {
        totalTax: "0",
        netTotal: "0",
        grossTotal: "0"
      }
    }
  ]
};
var mockUsageItemGroups = {
  items: [
    {
      id: "1aaeac35-cdc3-4adb-a741-5fa4816619ad",
      invoiceId: "6cedbb5e-4f77-4217-b8d4-020e7e4d33c9",
      title: "Successful API Calls",
      items: [
        {
          id: "cf8ad70f-f79a-4803-a41f-9a0b436c865a",
          invoiceId: "6cedbb5e-4f77-4217-b8d4-020e7e4d33c9",
          title: "Eldest Child - FE",
          value: "100",
          groupedValues: [],
          lineItemGroupId: "f4457a3c-a0f2-44ea-9c8d-548fa1298626",
          usageItemGroupId: "1aaeac35-cdc3-4adb-a741-5fa4816619ad"
        },
        {
          id: "f00fcb1a-76ff-44d9-b8c3-b444e554cc9c",
          invoiceId: "6cedbb5e-4f77-4217-b8d4-020e7e4d33c9",
          title: "Youngest Child - FE",
          value: "200",
          groupedValues: [],
          lineItemGroupId: "f4457a3c-a0f2-44ea-9c8d-548fa1298626",
          usageItemGroupId: "1aaeac35-cdc3-4adb-a741-5fa4816619ad"
        }
      ]
    }
  ]
};

// src/models/invoice/decoder.ts
var toInvoice = (value) => {
  return parseResponse({
    value,
    codec: invoiceModel,
    callerFunctionName: "toInvoiceResponse"
  });
};
var toInvoiceTotals = (value) => {
  return parseResponse({
    value,
    codec: invoiceTotalsModel,
    callerFunctionName: "toInvoiceTotals"
  });
};
var toInvoicesResponse = (value) => {
  return parseResponse({
    value,
    codec: createPaginatedResponseNew(invoiceModel, "InvoicesResponse"),
    callerFunctionName: "toInvoicesResponse"
  });
};
var toInvoiceUsageItemGroupResponse = (value) => {
  return parseResponse({
    value,
    codec: invoiceUsageItemGroupResponse,
    callerFunctionName: "toInvoiceSubAccountUsage"
  });
};

// src/models/creditNote/types.ts
var creditNoteStatus = t38.keyof({
  IN_PROGRESS: null,
  DRAFT: null,
  FINAL: null,
  SENT: null,
  VOIDED: null
});
var settingPreference = t38.keyof({
  ENABLED: null,
  DISABLED: null
});
var keyValuePairModel2 = t38.exact(
  t38.type({
    key: t38.string,
    value: t38.string
  })
);
var creditNoteModel = t38.exact(
  t38.intersection([
    t38.type({
      id: t38.string,
      currency,
      customerBillingAddress: addressModel,
      customerEmails: t38.array(t38.string),
      customerId: t38.string,
      customerLegalCompanyName: t38.string,
      customerShippingAddress: addressModel,
      grossTotal: t38.string,
      metadata: t38.array(keyValuePairModel2),
      netTotal: t38.string,
      sequenceAccountId: t38.string,
      status: creditNoteStatus,
      totalTax: t38.string,
      linkedServices: t38.array(linkInfo),
      settings: t38.type({
        generateCashCreditGrant: settingPreference
      })
    }),
    t38.partial({
      customerEmail: t38.string,
      creditNoteNumber: t38.string,
      billingPeriodEnd: t38.string,
      billingPeriodStart: t38.string,
      billingScheduleId: t38.string,
      customerTaxId: t38.string,
      issueDate: t38.string,
      memo: t38.string,
      purchaseOrderNumber: t38.string,
      invoiceId: t38.string,
      invoiceNumber: t38.string,
      merchantDetails: invoiceMerchantDetailsModel,
      creditGrantId: t38.string
    })
  ])
);
var creditNoteTotalsModel = t38.exact(
  t38.type({
    total: totalsModel,
    lineItemGroupTotals: t38.array(
      t38.exact(t38.type({ id: t38.string, total: totalsModel }))
    ),
    lineItemTotals: t38.array(
      t38.exact(t38.type({ id: t38.string, total: totalsModel }))
    )
  }),
  "CreditNotesTotalsModel"
);

// src/models/creditNote/decoder.ts
var toCreditNote = (value) => {
  return parseResponse({
    value,
    codec: creditNoteModel,
    callerFunctionName: "toCreditNote"
  });
};
var toCreditNotesResponse = (value) => {
  return parseResponse({
    value,
    codec: createPaginatedResponseNew(creditNoteModel, "CreditNotesResponse"),
    callerFunctionName: "toCreditNotesResponse"
  });
};
var toCreditNoteTotals = (value) => {
  return parseResponse({
    value,
    codec: creditNoteTotalsModel,
    callerFunctionName: "toCreditNoteTotals"
  });
};

// src/models/lineItemCreditNote/types.ts
import * as t40 from "io-ts";

// src/models/lineItem/types.ts
import * as t39 from "io-ts";
var rateDisplay = t39.keyof({
  ABSOLUTE: null,
  PERCENTAGE: null
});
var servicePeriod = t39.type({
  startDate: t39.string,
  endDate: t39.string
});
var lineItemModel = t39.exact(
  t39.intersection([
    t39.type({
      id: t39.string,
      invoiceId: t39.string,
      title: t39.string,
      quantity: t39.string,
      rate: t39.string,
      taxRate: t39.string,
      index: t39.number,
      grossTotal: t39.string,
      netTotal: t39.string,
      totalTax: t39.string,
      rateDisplay,
      externalIds: t39.array(integrationExternalId)
    }),
    t39.partial({
      groupId: t39.string,
      priceId: t39.string,
      description: t39.string,
      servicePeriodStart: t39.string,
      servicePeriodEnd: t39.string,
      servicePeriod
    })
  ]),
  "LineItemModel"
);

// src/models/lineItemCreditNote/types.ts
var lineItemCreditNoteModel = t40.exact(
  t40.intersection([
    t40.type({
      id: t40.string,
      creditNoteId: t40.string,
      title: t40.string,
      quantity: t40.string,
      rate: t40.string,
      taxRate: t40.string,
      index: t40.number,
      grossTotal: t40.string,
      netTotal: t40.string,
      totalTax: t40.string,
      rateDisplay,
      externalIds: t40.array(integrationExternalId)
    }),
    t40.partial({
      priceId: t40.string,
      groupId: t40.string,
      lineItemId: t40.string,
      description: t40.string
    })
  ]),
  "LineItemCreditNoteModel"
);

// src/models/lineItemCreditNote/decoder.ts
var toLineItemCreditNote = (value) => {
  return parseResponse({
    value,
    codec: lineItemCreditNoteModel,
    callerFunctionName: "toLineItemCreditNoteResponse"
  });
};
var toUnpaginatedLineItemsCreditNoteResponse = (value) => {
  return parseResponse({
    value,
    codec: createUnpaginatedResponse(
      lineItemCreditNoteModel,
      "LineItemsCreditNoteResponse"
    ),
    callerFunctionName: "toUnpaginatedLineItemsCreditNoteResponse"
  });
};
var toLineItemsCreditNotesResponse = (value) => {
  return parseResponse({
    value,
    codec: createPaginatedResponseNew(
      lineItemCreditNoteModel,
      "LineItemsCreditNoteResponse"
    ),
    callerFunctionName: "toLineItemsCreditNoteResponse"
  });
};

// src/models/lineItemCreditNote/mocks.ts
var mockLineItemsCreditNotes = [
  {
    id: "line-item-1",
    creditNoteId: "credit-notes-1",
    title: "title",
    description: "description",
    quantity: "1",
    rate: "10",
    taxRate: "0.2",
    index: 1,
    netTotal: "1",
    totalTax: "0.2",
    grossTotal: "1.2",
    rateDisplay: "ABSOLUTE",
    externalIds: []
  },
  {
    id: "line-item-2",
    creditNoteId: "credit-note-1",
    title: "title",
    description: "description",
    quantity: "1",
    rate: "10",
    taxRate: "0.2",
    index: 2,
    netTotal: "1",
    totalTax: "0.2",
    grossTotal: "1.2",
    rateDisplay: "ABSOLUTE",
    externalIds: []
  }
];
var mockLineItemsCreditNotesResponse = {
  items: mockLineItemsCreditNotes,
  pagination: mockPagination
};
var mockLineItemsResponseCreditNotesUnpaginated = {
  items: mockLineItemsCreditNotes
};

// src/models/lineItemGroupCreditNote/types.ts
import * as t41 from "io-ts";
var lineItemGroupCreditNoteModel = t41.exact(
  t41.intersection([
    t41.type({
      id: t41.string,
      creditNoteId: t41.string,
      title: t41.string,
      index: t41.number,
      grossTotal: t41.string,
      netTotal: t41.string,
      totalTax: t41.string
    }),
    t41.partial({
      description: t41.string,
      lineItemGroupId: t41.string
    })
  ]),
  "LineItemGroupCreditNoteModel"
);

// src/models/lineItemGroupCreditNote/mocks.ts
var mockLineItemGroupsCreditNotes = [
  {
    id: "line-item-group-1",
    creditNoteId: "credit-note-1",
    title: "title",
    description: "description",
    index: 1,
    netTotal: "1",
    totalTax: "0.2",
    grossTotal: "1.2"
  },
  {
    id: "line-item-group-2",
    creditNoteId: "credit-note-1",
    title: "title",
    description: "description",
    index: 2,
    netTotal: "1",
    totalTax: "0.2",
    grossTotal: "1.2"
  }
];
var mockLineItemGroupsCreditNotesResponse = {
  items: mockLineItemGroupsCreditNotes,
  pagination: mockPagination
};
var mockLineItemGroupsCreditNotesResponseUnpaginated = {
  items: mockLineItemGroupsCreditNotes
};

// src/models/lineItemGroupCreditNote/decoder.ts
var toLineItemGroupCreditNote = (value) => {
  return parseResponse({
    value,
    codec: lineItemGroupCreditNoteModel,
    callerFunctionName: "toLineItemGroupCreditNoteResponse"
  });
};
var toUnpaginatedLineItemGroupsCreditNoteResponse = (value) => {
  return parseResponse({
    value,
    codec: createUnpaginatedResponse(
      lineItemGroupCreditNoteModel,
      "LineItemGroupsCreditNoteResponse"
    ),
    callerFunctionName: "toUnpaginatedLineItemGroupsCreditNoteResponse"
  });
};
var toLineItemGroupsCreditNoteResponse = (value) => {
  return parseResponse({
    value,
    codec: createPaginatedResponseNew(
      lineItemGroupCreditNoteModel,
      "LineItemGroupsCreditNoteResponse"
    ),
    callerFunctionName: "toLineItemGroupsCreditNoteResponse"
  });
};

// src/models/creditNote/mocks.ts
var mockCreditNotes = [
  {
    id: "credit-note-1",
    sequenceAccountId: "ABC",
    status: "DRAFT",
    currency: "GBP",
    invoiceNumber: "INV00001",
    customerEmails: ["customer@example.com"],
    customerLegalCompanyName: "The Customer 1",
    customerBillingAddress: {
      line1: "15 Yemen Road",
      line2: "Road",
      town: "Yemen",
      postcode: "YE1 2YE",
      country: "GB"
    },
    customerShippingAddress: {
      line1: "15 Yemen Road",
      line2: void 0,
      town: "Yemen",
      postcode: "YE1 2YE",
      country: "GB"
    },
    totalTax: "0",
    netTotal: "0",
    grossTotal: "0",
    issueDate: void 0,
    purchaseOrderNumber: "PO123",
    customerId: "ID",
    memo: "Thanks",
    metadata: [],
    billingPeriodStart: "2022-08-25T12:24:08.018565Z",
    billingPeriodEnd: "2022-09-25T12:24:08.018565Z",
    linkedServices: [],
    settings: { generateCashCreditGrant: "DISABLED" }
  },
  {
    id: "credit-note-2",
    creditNoteNumber: "CN00002",
    sequenceAccountId: "ABC",
    status: "FINAL",
    currency: "GBP",
    invoiceNumber: "INV00002",
    customerEmails: ["customer@example.com"],
    customerLegalCompanyName: "The Customer 2",
    customerBillingAddress: {
      line1: "15 Yemen Road",
      line2: void 0,
      town: "Yemen",
      postcode: "YE1 2YE",
      country: "GB"
    },
    customerShippingAddress: {
      line1: "15 Yemen Road",
      line2: void 0,
      town: "Yemen",
      postcode: "YE1 2YE",
      country: "GB"
    },
    totalTax: "0",
    netTotal: "0",
    grossTotal: "0",
    issueDate: void 0,
    purchaseOrderNumber: void 0,
    customerId: "ID",
    memo: void 0,
    metadata: [],
    linkedServices: [],
    settings: { generateCashCreditGrant: "DISABLED" }
  },
  {
    id: "credit-note-3",
    creditNoteNumber: "CN00003",
    sequenceAccountId: "ABC",
    status: "VOIDED",
    currency: "GBP",
    invoiceNumber: "INV00003",
    customerEmails: ["customer@example.com"],
    customerLegalCompanyName: "The Customer 3",
    customerBillingAddress: {
      line1: "15 Yemen Road",
      line2: void 0,
      town: "Yemen",
      postcode: "YE1 2YE",
      country: "GB"
    },
    customerShippingAddress: {
      line1: "15 Yemen Road",
      line2: void 0,
      town: "Yemen",
      postcode: "YE1 2YE",
      country: "GB"
    },
    totalTax: "0",
    netTotal: "0",
    grossTotal: "0",
    issueDate: void 0,
    purchaseOrderNumber: void 0,
    customerId: "ID",
    memo: void 0,
    metadata: [],
    linkedServices: [],
    settings: { generateCashCreditGrant: "DISABLED" }
  },
  {
    id: "credit-note-4",
    creditNoteNumber: "CN00004",
    sequenceAccountId: "ABC",
    status: "FINAL",
    currency: "GBP",
    invoiceNumber: "INV00004",
    customerEmails: ["customer@example.com"],
    customerLegalCompanyName: "The Customer 4",
    customerBillingAddress: {
      line1: "15 Yemen Road",
      line2: void 0,
      town: "Yemen",
      postcode: "YE1 2YE",
      country: "GB"
    },
    customerShippingAddress: {
      line1: "15 Yemen Road",
      line2: void 0,
      town: "Yemen",
      postcode: "YE1 2YE",
      country: "GB"
    },
    totalTax: "0",
    netTotal: "0",
    grossTotal: "0",
    issueDate: void 0,
    purchaseOrderNumber: void 0,
    customerId: "ID",
    memo: void 0,
    metadata: [],
    linkedServices: [],
    settings: { generateCashCreditGrant: "DISABLED" }
  }
];
var mockCreditNotesResponse = {
  items: mockCreditNotes,
  pagination: mockPagination
};
var mockCreditNoteTotals = {
  total: {
    totalTax: "0",
    netTotal: "0",
    grossTotal: "0"
  },
  lineItemGroupTotals: [
    {
      id: mockLineItemGroupsCreditNotes[0].id,
      total: {
        totalTax: "0",
        netTotal: "0",
        grossTotal: "0"
      }
    }
  ],
  lineItemTotals: [
    {
      id: mockLineItemsCreditNotes[0].id,
      total: {
        totalTax: "0",
        netTotal: "0",
        grossTotal: "0"
      }
    }
  ]
};
var mockCreditNotePostRes = {
  id: "018a0a41-d714-774a-8c2f-9fb4d0442574",
  sequenceAccountId: "6b9b56c5-dce9-4a14-bb64-fa3f4f91d098",
  status: "DRAFT",
  currency: "USD",
  customerId: "customer-id-1",
  customerEmails: ["customer-1@example.com"],
  customerLegalCompanyName: "Legal Name1",
  customerBillingAddress: {
    line1: "Flat 1",
    line2: "123 Fake Street",
    town: "London",
    postcode: "AB1 2EF",
    country: "GB"
  },
  customerShippingAddress: {
    line1: "Flat 1",
    line2: "123 Fake Street",
    town: "London",
    postcode: "AB1 2EF",
    country: "GB"
  },
  totalTax: "0",
  netTotal: "0",
  grossTotal: "0",
  metadata: [],
  linkedServices: [],
  settings: { generateCashCreditGrant: "DISABLED" }
};

// src/models/creditNote/format.tsx
var statusToFormat4 = {
  IN_PROGRESS: {
    children: "Upcoming",
    sentiment: "info"
  },
  DRAFT: {
    children: "Draft",
    sentiment: "neutral"
  },
  FINAL: {
    children: "Final",
    sentiment: "info"
  },
  VOIDED: {
    children: "Void",
    sentiment: "neutral"
  },
  SENT: {
    children: "Sent",
    sentiment: "success"
  }
};
var toCreditNoteStatusBadgeProps = ({
  status,
  size = "md"
}) => ({
  ...statusToFormat4[status],
  size
});

// src/models/creditNoteContent/types.ts
import * as t43 from "io-ts";

// src/models/invoiceContent/types.ts
import * as t42 from "io-ts";

// src/models/lineItem/decoder.ts
var toLineItem = (value) => {
  return parseResponse({
    value,
    codec: lineItemModel,
    callerFunctionName: "toLineItemResponse"
  });
};
var toUnpaginatedLineItemsResponse = (value) => {
  return parseResponse({
    value,
    codec: createUnpaginatedResponse(lineItemModel, "LineItemsResponse"),
    callerFunctionName: "toUnpaginatedLineItemsResponse"
  });
};
var toLineItemsResponse = (value) => {
  return parseResponse({
    value,
    codec: createPaginatedResponseNew(lineItemModel, "LineItemsResponse"),
    callerFunctionName: "toLineItemsResponse"
  });
};

// src/models/lineItem/format.ts
var normalisedLineItemRate = (rate, isDiscount) => {
  const numericalRate = Number.parseFloat(rate);
  const normalised = isDiscount ? 0 - numericalRate : numericalRate;
  return normalised.toString();
};
var formatInitialLineItemRate = (rate, isDiscount) => {
  return isDiscount ? rate.split("-")[1] : rate;
};

// src/models/invoiceContent/types.ts
var invoiceContentInvoiceMerchantDetailsModel = t42.exact(
  t42.intersection(
    [
      t42.type({
        address: addressModel,
        email: t42.string,
        legalCompanyName: t42.string,
        customFields: t42.array(keyValuePairModel),
        includeBeneficiaryAddressInPaymentDetails: t42.boolean
      }),
      t42.partial({
        iban: t42.string,
        ukAccountDetails: sortCodeAccountNumberModel,
        usAchDetails: usAchDestinationModel,
        usWireDetails: usWireDestinationModel,
        caBankAccountDetails: canadianDestinationModel,
        canadianInternationalDestination: canadianInternationalDestinationModel,
        australianDestination: australianDestinationModel,
        logoUrl: t42.string,
        primaryColour: t42.string,
        taxId: t42.string
      })
    ],
    "InvoiceContentInvoiceMerchantDetailsModel"
  )
);
var invoiceContentInvoiceModel = t42.exact(
  t42.intersection(
    [
      t42.type({
        id: t42.string,
        status: invoiceStatus,
        currency,
        customerLegalCompanyName: t42.string,
        customerBillingAddress: addressModel,
        totalTax: t42.string,
        netTotal: t42.string,
        grossTotal: t42.string,
        metadata: t42.array(keyValuePairModel)
      }),
      t42.partial({
        invoiceNumber: t42.string,
        issueDate: t42.string,
        dueDate: t42.string,
        purchaseOrderNumber: t42.string,
        memo: t42.string,
        billingPeriod: inclusiveDateRange,
        customerTaxId: t42.string,
        creditBalances: t42.string,
        merchantDetails: invoiceContentInvoiceMerchantDetailsModel,
        paymentOptions: t42.array(invoicePaymentOption),
        reference: t42.string
      })
    ],
    "InvoiceContentInvoiceModel"
  )
);
var invoiceContentLineItemModel = t42.exact(
  t42.intersection([
    t42.type({
      id: t42.string,
      title: t42.string,
      quantity: t42.string,
      rate: t42.string,
      taxRate: t42.string,
      grossTotal: t42.string,
      netTotal: t42.string,
      totalTax: t42.string,
      rateDisplay
    }),
    t42.partial({
      groupId: t42.string,
      priceId: t42.string
    })
  ]),
  "InvoiceContentLineItemModel"
);
var invoiceContentLineItemGroupModel = t42.exact(
  t42.type({
    id: t42.string,
    title: t42.string,
    grossTotal: t42.string,
    netTotal: t42.string,
    totalTax: t42.string
  })
);
var invoiceContentMerchantModel = t42.exact(
  t42.type({
    defaultDueDateDays: t42.number
  })
);
var invoiceContent = t42.exact(
  t42.intersection([
    t42.type({
      invoice: invoiceContentInvoiceModel,
      lineItems: t42.array(invoiceContentLineItemModel),
      lineItemGroups: t42.array(invoiceContentLineItemGroupModel),
      merchantDetails: invoiceContentInvoiceMerchantDetailsModel
    }),
    t42.partial({
      merchant: invoiceContentMerchantModel
    })
  ])
);

// src/models/creditNoteContent/types.ts
var creditNoteContentCreditNoteModel = t43.exact(
  t43.intersection([
    t43.type({
      id: t43.string,
      currency,
      customerBillingAddress: addressModel,
      customerLegalCompanyName: t43.string,
      grossTotal: t43.string,
      metadata: t43.array(keyValuePairModel),
      netTotal: t43.string,
      status: creditNoteStatus,
      totalTax: t43.string
    }),
    t43.partial({
      creditNoteNumber: t43.string,
      billingPeriodEnd: t43.string,
      billingPeriodStart: t43.string,
      customerTaxId: t43.string,
      issueDate: t43.string,
      memo: t43.string,
      purchaseOrderNumber: t43.string,
      invoiceNumber: t43.string,
      merchantDetails: invoiceContentInvoiceMerchantDetailsModel
    })
  ])
);
var creditNoteContentLineItemModel = t43.exact(
  t43.intersection([
    t43.type({
      id: t43.string,
      title: t43.string,
      quantity: t43.string,
      rate: t43.string,
      taxRate: t43.string,
      grossTotal: t43.string,
      netTotal: t43.string,
      totalTax: t43.string,
      rateDisplay
    }),
    t43.partial({
      priceId: t43.string,
      groupId: t43.string,
      description: t43.string
    })
  ]),
  "CreditNoteContentLineItemModel"
);
var creditNoteContentLineItemGroupModel = t43.exact(
  t43.type({
    id: t43.string,
    title: t43.string,
    grossTotal: t43.string,
    netTotal: t43.string,
    totalTax: t43.string
  })
);
var creditNoteContent = t43.exact(
  t43.type({
    creditNote: creditNoteContentCreditNoteModel,
    lineItems: t43.array(creditNoteContentLineItemModel),
    lineItemGroups: t43.array(creditNoteContentLineItemGroupModel),
    merchantDetails: invoiceContentInvoiceMerchantDetailsModel,
    merchant: invoiceContentMerchantModel
  })
);

// src/models/creditNoteContent/decoder.ts
var toCreditNoteContent = (value) => {
  return parseResponse({
    value,
    codec: creditNoteContent,
    callerFunctionName: "toCreditNoteContent"
  });
};

// src/models/monetaryAmount/format.ts
var displayWithNarrowSymbol = ["USD"];
var currencyDisplayOptions = (currency2) => {
  let currencyDisplay;
  if (displayWithNarrowSymbol.includes(currency2)) {
    currencyDisplay = "narrowSymbol";
  } else {
    currencyDisplay = "symbol";
  }
  return currencyDisplay;
};
var toIntlNumber = (currency2, maximumFractionDigits = 2) => {
  const currencyDisplay = currencyDisplayOptions(currency2);
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currencyDisplay,
    currency: currency2,
    maximumFractionDigits
  });
};
var toMoney = ({ value, currency: currency2 }, fallback = "", maximumFractionDigits = 2) => {
  if (!value || !currency2) {
    return fallback;
  }
  return toIntlNumber(currency2, maximumFractionDigits).format(parseFloat(value));
};
var toCompactMoney = (num) => {
  return Intl.NumberFormat("en", {
    notation: "compact",
    style: "currency",
    currency: "GBP"
  }).format(num).toLowerCase();
};

// src/models/currency/format.ts
var toCurrencySymbol = (currency2) => {
  const numberParts = toIntlNumber(currency2).formatToParts(1);
  const currencyString = numberParts.find(
    ({ type: type60 }) => type60 === "currency"
  )?.value;
  return currencyString ?? currencyToSymbol[currency2];
};
var toCurrencyDescription = (currency2) => {
  const name = currencyToName[currency2];
  return `${name} (${currency2})`;
};

// src/models/customer/decoder.ts
var toCustomer = (value) => {
  return parseResponse({
    value,
    codec: customerModel,
    callerFunctionName: "toCustomer"
  });
};
var toCustomersResponse = (value) => {
  return parseResponse({
    value,
    codec: customersResponse,
    callerFunctionName: "toCustomersResponse"
  });
};
var toCustomerResponseModel = (value) => {
  return parseResponse({
    value,
    codec: customerResponseModel,
    callerFunctionName: "toCustomerResponseModel"
  });
};

// src/models/customer/format.ts
var customerOptions = (customers) => {
  return customers.map(({ id, legalName }) => ({
    label: legalName,
    value: id
  }));
};
var taxStatusMap = {
  TAXED: "Taxable",
  TAX_EXEMPT: "Exempt",
  REVERSE_CHARGED: "Reverse charge"
};

// src/models/customer/mocks.ts
var mockCustomers = [
  {
    id: "customer-id-1",
    createdAt: "2022-08-25T12:24:08.018565Z",
    sequenceAccountId: "6b9b56c5-dce9-4a14-bb64-fa3f4f91d098",
    legalName: "Legal Name1",
    contactName: "Contact Name1",
    address: {
      line1: "Flat 1",
      line2: "123 Fake Street",
      town: "London",
      postcode: "AB1 2EF",
      country: "GB"
    },
    telephone: void 0,
    email: "customer-1@example.com",
    url: void 0,
    label: "Test label",
    taxStatus: "TAX_EXEMPT",
    externalIds: [
      {
        key: "Stripe",
        value: "cus_0987654321",
        syncTime: "2022-08-25T12:24:08.018565Z"
      }
    ],
    billingEmails: ["billingemail-1@example.com", "billingemail-2@example.com"]
  },
  {
    id: "customer-id-2",
    createdAt: "2022-08-25T12:24:08.018565Z",
    sequenceAccountId: "6b9b56c5-dce9-4a14-bb64-fa3f4f91d098",
    legalName: "Legal Name2",
    contactName: "Contact Name2",
    address: {
      line1: "Flat 1",
      line2: "123 Fake Street",
      town: "London",
      postcode: "AB1 2EF",
      country: "GB"
    },
    telephone: void 0,
    email: "customer-2@example.com",
    url: void 0,
    label: void 0,
    taxStatus: "TAXED",
    externalIds: [
      {
        key: "Stripe",
        value: "cus_1234567890",
        syncTime: "2022-08-25T12:24:08.018565Z"
      }
    ],
    billingEmails: ["billingemail-3@example.com", "billingemail-4@example.com"]
  }
];
var mockCustomersResponse = {
  items: mockCustomers,
  pagination: mockPagination
};
var mockCustomerResponse = {
  customer: mockCustomers[0]
};

// src/models/customerAlias/decoder.ts
var toCustomerAliasesResponsePaginated = (value) => {
  return parseResponse({
    value,
    codec: customerAliasesResponsePaginated,
    callerFunctionName: "toCustomerAliasesResponsePaginated"
  });
};
var toCustomerAliasesResponseUnpaginated = (value) => {
  return parseResponse({
    value,
    codec: customerAliasesResponseUnpaginated,
    callerFunctionName: "toCustomerAliasesResponseUnpaginated"
  });
};
var toCustomerAlias = (value) => {
  return parseResponse({
    value,
    codec: customerAlias,
    callerFunctionName: "toCustomerAlias"
  });
};

// src/models/customerAlias/format.ts
var customerAliasOptions = (customerAliases) => {
  return customerAliases.map(({ value }) => ({
    label: value,
    value
  }));
};

// src/models/customerAlias/mocks.ts
var mockCustomerAlias = {
  id: "4df85087-f165-446b-8e93-ebecd8df9055",
  customerId: "customer-id-2",
  value: "alias-value",
  sequenceAccountId: "accountId",
  createdAt: "2021-08-02T12:00:00Z"
};
var mockCustomerAliasesResponsePaginated = {
  items: [mockCustomerAlias],
  pagination: mockPagination
};
var mockCustomerAliasesResponseUnpaginated = {
  items: [mockCustomerAlias]
};

// src/models/customerAlias/types.ts
import * as t44 from "io-ts";
var customerAlias = t44.intersection([
  t44.type({
    id: t44.string,
    sequenceAccountId: t44.string,
    customerId: t44.string,
    value: t44.string,
    createdAt: t44.string
  }),
  t44.partial({
    label: t44.string
  })
]);
var customerAliasesResponsePaginated = createPaginatedResponseNew(
  customerAlias,
  "CustomerAliasesResponsePaginated"
);
var customerAliasesResponseUnpaginated = createUnpaginatedResponse(
  customerAlias,
  "CustomerAliasesResponseUnpaginated"
);

// src/models/customerPortal/types.ts
import * as t45 from "io-ts";
var customerPortalCustomerModel = t45.exact(
  t45.type({
    legalName: t45.string,
    address: addressModel
  })
);
var customerPortalInvoiceMerchantDetails = t45.exact(
  t45.intersection(
    [
      t45.type({
        address: addressModel,
        customFields: t45.array(keyValuePairModel),
        email: t45.string,
        includeBeneficiaryAddressInPaymentDetails: t45.boolean,
        legalCompanyName: t45.string
      }),
      t45.partial({
        logoUrl: t45.string,
        phoneNumber: t45.string,
        primaryColour: t45.string,
        taxId: t45.string,
        iban: t45.string,
        caBankAccountDestination: canadianDestinationModel,
        canadianInternationalDestination: canadianInternationalDestinationModel,
        usAchDestination: usAchDestinationModel,
        usWireDestination: usWireDestinationModel,
        ukAccountDetails: sortCodeAccountNumberModel,
        australianDestination: australianDestinationModel
      })
    ],
    "CustomerPortalInvoiceMerchantDetailsModel"
  )
);
var customerPortalInvoiceModel = t45.exact(
  t45.intersection(
    [
      t45.type({
        id: t45.string,
        currency,
        invoiceNumber: t45.string,
        issueDate: t45.string,
        dueDate: t45.string,
        paymentStatus: invoicePaymentStatus,
        grossTotal: t45.string,
        customerLegalCompanyName: t45.string,
        customerBillingAddress: addressModel,
        paymentOptions: t45.array(invoicePaymentOption),
        totalTax: t45.string,
        netTotal: t45.string,
        merchantDetails: customerPortalInvoiceMerchantDetails,
        metadata: t45.array(keyValuePairModel),
        accountingDate: t45.string
      }),
      t45.partial({
        billingPeriod: inclusiveDateRange,
        purchaseOrderNumber: t45.string,
        memo: t45.string,
        customerTaxId: t45.string,
        creditBalances: t45.string,
        renderSettings: invoiceRenderSettingsModel
      })
    ],
    "InvoiceModel"
  )
);
var customerPortalUsageEventModel = t45.exact(
  t45.type({
    id: t45.string,
    eventTimestamp: t45.string,
    eventType: t45.string,
    properties: t45.array(keyValuePairModel)
  })
);
var customerPortalUsageMetricModel = t45.exact(
  t45.intersection([
    t45.type({
      id: t45.string,
      name: t45.string,
      eventType: t45.string,
      priceId: t45.string,
      aggregationType
    }),
    t45.partial({
      aggregationProperty: t45.string
    })
  ])
);
var customerPortalBillingScheduleModel = t45.exact(
  t45.type({
    id: t45.string,
    name: t45.string
  })
);
var usageDataModel = t45.exact(
  t45.type({
    periodStart: t45.string,
    amount: t45.string,
    cumulativeAmount: t45.string
  })
);
var usageDataResponseModel = t45.exact(
  t45.type({
    usageStart: t45.string,
    usageEnd: t45.string,
    metricName: t45.string,
    metricId: t45.string,
    total: t45.string,
    usageData: t45.array(usageDataModel)
  })
);
var usageDataDataResponseModel = t45.exact(
  t45.partial({
    data: usageDataResponseModel
  })
);
var usagePeriodType = t45.keyof({
  CURRENT: null,
  LAST: null,
  LAST_THREE: null,
  ALL: null
});
var customerPortalCreditType = t45.keyof({
  CASH: null,
  USAGE: null
});
var embeddedCustomerPortalCreditGrantModel = t45.exact(
  t45.intersection([
    t45.type({
      id: t45.string,
      sequenceAccountId: t45.string,
      customerId: t45.string,
      currency,
      type: customerPortalCreditType,
      name: t45.string,
      originalAmount: t45.string,
      currentBalance: t45.string,
      costOfCredit: t45.string,
      createdAt: t45.string
    }),
    t45.partial({
      expiryDate: t45.string,
      metricId: t45.string,
      taxRateId: t45.string,
      effectiveDate: t45.string
    })
  ])
);
var customerPortalCreditGrantModel = t45.exact(
  t45.intersection([
    t45.type({
      id: t45.string,
      type: customerPortalCreditType,
      name: t45.string,
      originalAmount: t45.string,
      currentBalance: t45.string
    }),
    t45.partial({
      expiryDate: t45.string
    })
  ])
);
var customerPortCreditTransactionModel = t45.exact(
  t45.intersection([
    t45.type({
      grantId: t45.string,
      date: t45.string,
      type: t45.string,
      amount: t45.string
    }),
    t45.partial({
      id: t45.string,
      reason: t45.string,
      invoiceId: t45.string,
      billingRunId: t45.string
    })
  ])
);
var customerPortalCreditBalanceModel = t45.exact(
  t45.type({
    type: customerPortalCreditType,
    id: t45.string,
    name: t45.string,
    balance: t45.string,
    grants: t45.array(embeddedCustomerPortalCreditGrantModel),
    transactions: t45.array(customerPortCreditTransactionModel)
  })
);
var customerPortalCreditBalanceDetailsModel = t45.exact(
  t45.type({
    balance: t45.string,
    type: customerPortalCreditType,
    id: t45.string,
    name: t45.string,
    grants: t45.array(customerPortalCreditGrantModel),
    transactions: t45.array(customerPortCreditTransactionModel)
  })
);
var customerPortalLineItemServicePeriodModel = t45.exact(
  t45.type({
    start: t45.string,
    endInclusive: t45.string
  })
);
var customerPortalLineItemModel = t45.exact(
  t45.intersection(
    [
      t45.type({
        grossTotal: t45.string,
        id: t45.string,
        index: t45.number,
        netTotal: t45.string,
        quantity: t45.string,
        rate: t45.string,
        rateDisplay,
        taxRate: t45.string,
        title: t45.string,
        totalTax: t45.string
      }),
      t45.partial({
        description: t45.string,
        groupId: t45.string,
        servicePeriodStart: t45.string,
        servicePeriodEnd: t45.string,
        servicePeriod: customerPortalLineItemServicePeriodModel
      })
    ],
    "LineItemModel"
  )
);
var customerPortalLineItemGroupModel = t45.exact(
  t45.intersection(
    [
      t45.type({
        grossTotal: t45.string,
        id: t45.string,
        index: t45.number,
        netTotal: t45.string,
        title: t45.string,
        totalTax: t45.string
      }),
      t45.partial({
        description: t45.string
      })
    ],
    "LineItemGroupModel"
  )
);
var customerPortalMerchantDetailsModel = t45.exact(
  t45.partial({
    logoUrl: t45.string,
    primaryColour: t45.string
  })
);

// src/models/customerPortal/mocks.ts
var mockCustomerPortalCustomer = {
  legalName: "Legal Name1",
  address: {
    line1: "15 Yemen Road",
    line2: "Road",
    town: "Yemen",
    postcode: "YE1 2YE",
    country: "GB"
  }
};
var mockCustomerPortalInvoice = {
  id: "invoice-1",
  paymentStatus: "UNPAID",
  currency: "GBP",
  grossTotal: "0",
  issueDate: "2022-10-25",
  dueDate: "2022-11-25",
  invoiceNumber: "INV0001",
  customerLegalCompanyName: "The Customer 1",
  customerBillingAddress: {
    line1: "15 Yemen Road",
    line2: "Road",
    town: "Yemen",
    postcode: "YE1 2YE",
    country: "GB"
  },
  paymentOptions: ["BANK_TRANSFER"],
  totalTax: "0",
  netTotal: "0",
  purchaseOrderNumber: "PO123",
  metadata: [],
  merchantDetails: {
    address: {
      line1: "15 Yemen Road",
      town: "Yemen",
      postcode: "YE1 2YE",
      country: "GB"
    },
    email: "merchant@example.com",
    taxId: "TAX123",
    legalCompanyName: "The merchant",
    customFields: [],
    includeBeneficiaryAddressInPaymentDetails: true
  },
  accountingDate: "2022-10-25"
};
var mockCustomerPortalInvoices = [
  mockCustomerPortalInvoice,
  {
    id: "invoice-2",
    paymentStatus: "UNPAID",
    currency: "GBP",
    grossTotal: "0",
    issueDate: "2022-10-25",
    dueDate: "2022-11-25",
    billingPeriod: { start: "2022-08-25", endInclusive: "2022-09-25" },
    invoiceNumber: "INV0002",
    customerLegalCompanyName: "The Customer 1",
    customerBillingAddress: {
      line1: "15 Yemen Road",
      line2: "Road",
      town: "Yemen",
      postcode: "YE1 2YE",
      country: "GB"
    },
    paymentOptions: ["BANK_TRANSFER"],
    totalTax: "0",
    netTotal: "0",
    purchaseOrderNumber: "PO123",
    memo: "Thanks",
    metadata: [],
    customerTaxId: "TAX123",
    merchantDetails: {
      address: {
        line1: "15 Yemen Road",
        town: "Yemen",
        postcode: "YE1 2YE",
        country: "GB"
      },
      email: "merchant@example.com",
      taxId: "TAX123",
      legalCompanyName: "The merchant",
      customFields: [],
      includeBeneficiaryAddressInPaymentDetails: true
    },
    accountingDate: "2022-10-25"
  }
];
var mockCustomerPortalInvoicesResponse = {
  items: mockCustomerPortalInvoices,
  pagination: mockPagination
};
var mockCustomerPortalUsageMetric = {
  id: "1",
  name: "API Calls",
  eventType: "call",
  priceId: "1",
  aggregationType: "COUNT"
};
var mockCustomerPortalUsageMetric2 = {
  id: "2",
  name: "Coffee",
  eventType: "coffee",
  aggregationProperty: "cost",
  priceId: "2",
  aggregationType: "COUNT"
};
var mockCustomerPortalUsageMetricsResponse = {
  items: [mockCustomerPortalUsageMetric, mockCustomerPortalUsageMetric2]
};
var mockCustomerPortalUsageEvent = {
  id: "event-id",
  eventTimestamp: "2022-08-25T12:00:00",
  eventType: "call",
  properties: []
};
var mockCustomerPortalUsageEvent2 = {
  id: "event-id",
  eventTimestamp: "2022-08-25T13:00:00",
  eventType: "coffee",
  properties: [{ key: "cost", value: "3.5" }]
};
var mockCustomerPortalUsageEventsResponse = {
  items: [mockCustomerPortalUsageEvent],
  pagination: mockPagination
};
var mockCustomerPortalBillingSchedulesResponse = {
  items: [
    {
      id: "id",
      name: "name"
    }
  ]
};
var mockUsageDataResponse = {
  usageStart: "2023-03-01",
  usageEnd: "2023-03-31",
  metricName: "coffee",
  metricId: "metric-id",
  total: "100",
  usageData: [
    {
      periodStart: "2023-03-01",
      amount: "100",
      cumulativeAmount: "100"
    }
  ]
};
var mockUsageDataDataResponse = {
  data: {
    ...mockUsageDataResponse
  }
};
var mockCustomerPortalCreditBalancesResponse = {
  items: [
    {
      type: "CASH",
      id: "id",
      name: "balance",
      balance: "10",
      grants: [
        {
          id: "123",
          type: "CASH",
          name: "GRANT 1",
          originalAmount: "80",
          currentBalance: "50",
          sequenceAccountId: "sequenceAccountId",
          customerId: "customerId",
          createdAt: "2022-08-25T13:00:00",
          currency: "GBP",
          costOfCredit: "80"
        }
      ],
      transactions: [
        {
          grantId: "123",
          date: "2023-02-01",
          type: "CASH",
          amount: "30"
        }
      ]
    }
  ]
};
var mockCustomerPortalCreditBalanceDetails = {
  balance: "50",
  type: "CASH",
  id: "id",
  name: "API calls",
  grants: [
    {
      id: "123",
      type: "CASH",
      name: "GRANT 1",
      originalAmount: "80",
      currentBalance: "50"
    }
  ],
  transactions: [
    {
      grantId: "123",
      date: "2023-02-01",
      type: "CASH",
      amount: "30"
    }
  ]
};
var mockCustomerPortalLineItems = {
  items: [
    {
      id: "line-item-1",
      title: "title",
      description: "description",
      quantity: "1",
      rate: "10",
      taxRate: "0.2",
      index: 1,
      netTotal: "1",
      totalTax: "0.2",
      grossTotal: "1.2",
      rateDisplay: "ABSOLUTE"
    },
    {
      id: "line-item-2",
      title: "title",
      description: "description",
      quantity: "1",
      rate: "10",
      taxRate: "0.2",
      index: 2,
      netTotal: "1",
      totalTax: "0.2",
      grossTotal: "1.2",
      rateDisplay: "ABSOLUTE"
    }
  ]
};
var mockCustomerPortalLineItemGroups = {
  items: [
    {
      id: "line-item-1",
      title: "title",
      description: "description",
      index: 1,
      netTotal: "1",
      totalTax: "0.2",
      grossTotal: "1.2"
    },
    {
      id: "line-item-2",
      title: "title",
      description: "description",
      index: 2,
      netTotal: "1",
      totalTax: "0.2",
      grossTotal: "1.2"
    }
  ]
};

// src/models/customerPortal/decoder.ts
var toCustomerPortalCustomer = (value) => {
  return parseResponse({
    value,
    codec: customerPortalCustomerModel,
    callerFunctionName: "toCustomerPortalCustomer"
  });
};
var toCustomerPortalInvoice = (value) => {
  return parseResponse({
    value,
    codec: customerPortalInvoiceModel,
    callerFunctionName: "toCustomerPortalInvoice"
  });
};
var toCustomerPortalInvoicesResponse = (value) => {
  return parseResponse({
    value,
    codec: createPaginatedResponseNew(
      customerPortalInvoiceModel,
      "InvoicesResponse"
    ),
    callerFunctionName: "toCustomerPortalInvoicesResponse"
  });
};
var toCustomerPortalUsageMetricsResponse = (value) => {
  return parseResponse({
    value,
    codec: createUnpaginatedResponse(
      customerPortalUsageMetricModel,
      "UsageMetricsResponse"
    ),
    callerFunctionName: "toCustomerPortalUsageMetricsResponse"
  });
};
var toCustomerPortalUsageEventsResponse = (value) => {
  return parseResponse({
    value,
    codec: createPaginatedResponseNew(
      customerPortalUsageEventModel,
      "UsageEventsResponse"
    ),
    callerFunctionName: "toCustomerPortalUsageEventsResponse"
  });
};
var toCustomerPortalBillingSchedulesResponse = (value) => {
  return parseResponse({
    value,
    codec: createUnpaginatedResponse(
      customerPortalBillingScheduleModel,
      "billingSchedule"
    ),
    callerFunctionName: "toCustomerPortalBillingSchedulesResponse"
  });
};
var toUsageDataResponse = (value) => {
  return parseResponse({
    value,
    codec: usageDataResponseModel,
    callerFunctionName: "toUsageDataResponse"
  });
};
var toUsageDataDataResponse = (value) => {
  return parseResponse({
    value,
    codec: usageDataDataResponseModel,
    callerFunctionName: "toUsageDataDataResponse"
  });
};
var toCustomerPortalCreditBalancesResponse = (value) => {
  return parseResponse({
    value,
    codec: createUnpaginatedResponse(
      customerPortalCreditBalanceModel,
      "customerPortalCreditBalance"
    ),
    callerFunctionName: "toCustomerPortalCreditBalancesResponse"
  });
};
var toCustomerPortalCreditBalanceDetails = (value) => {
  return parseResponse({
    value,
    codec: customerPortalCreditBalanceDetailsModel,
    callerFunctionName: "toCustomerPortalCreditBalanceDetails"
  });
};
var toCustomerPortalLineItemsResponse = (value) => {
  return parseResponse({
    value,
    codec: createUnpaginatedResponse(
      customerPortalLineItemModel,
      "LineItemsResponse"
    ),
    callerFunctionName: "toCustomerPortalLineItemsResponse"
  });
};
var toCustomerPortalLineItemGroupsResponse = (value) => {
  return parseResponse({
    value,
    codec: createUnpaginatedResponse(
      customerPortalLineItemGroupModel,
      "LineItemGroupsResponse"
    ),
    callerFunctionName: "toCustomerPortalLineItemGroupsResponse"
  });
};

// src/models/dates/format.ts
var monthNamesShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
var weekdayNamesShort = [
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Sun"
];
var DAYS_OF_WEEK = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY"
];
var MONTHS = [
  "JANUARY",
  "FEBRUARY",
  "MARCH",
  "APRIL",
  "MAY",
  "JUNE",
  "JULY",
  "AUGUST",
  "SEPTEMBER",
  "OCTOBER",
  "NOVEMBER",
  "DECEMBER"
];
var MONTH_LIMITS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

// src/models/googleSheetsExports/types.ts
import * as t46 from "io-ts";
var googleSheetsExportsModel = t46.type({
  template: t46.union([
    t46.literal("ALL"),
    t46.literal("USAGE_ANALYTICS"),
    t46.literal("AR_ANALYTICS"),
    t46.literal("SALES_COMMISSIONS"),
    t46.literal("REVENUE_ANALYTICS")
  ]),
  sheetUrl: t46.string
});

// src/models/googleSheetsExports/decoder.ts
var toGoogleSheetsExports = (value) => {
  return parseResponse({
    value,
    codec: googleSheetsExportsModel,
    callerFunctionName: "toUsageMetric"
  });
};

// src/models/googleSheetsExports/mocks.ts
var mockGoogleSheetsExport = {
  template: "ALL",
  sheetUrl: "https://docs.google.com/spreadsheets/d/1x2x3x4x5x6x7x8x9x0/edit#gid=0"
};

// src/models/integrationId/types.ts
import * as t47 from "io-ts";
var integrationId = t47.exact(
  t47.intersection([
    t47.type({
      id: t47.string,
      service: integrationService
    }),
    t47.partial({
      lastSynced: t47.string,
      url: t47.string
    })
  ])
);

// src/models/invoiceAccountingDateSettings/types.ts
import * as t48 from "io-ts";
var accountingDatePreference = t48.keyof({
  END_OF_BILLING_PERIOD: null,
  INTENDED_INVOICE_CREATION_DATE: null,
  INVOICE_ISSUE_DATE: null
});
var invoiceAccountingDateSettingsModel = t48.strict(
  {
    id: t48.string,
    sequenceAccountId: t48.string,
    preference: accountingDatePreference
  },
  "InvoiceSettingsModel"
);

// src/models/invoiceAccountingDateSettings/decoder.ts
var toInvoiceAccountingDateSettings = (value) => {
  return parseResponse({
    value,
    codec: invoiceAccountingDateSettingsModel,
    callerFunctionName: "toInvoiceAccountingDateSettings"
  });
};

// src/models/invoiceAccountingDateSettings/mocks.ts
var mockInvoiceAccountingDateSettings = {
  id: "15b0ea6f-8fb2-4e15-94dc-1df221159e59",
  sequenceAccountId: "cb78d7aa-3b5a-4888-9b6b-f4f0fda4db0d",
  preference: "INTENDED_INVOICE_CREATION_DATE"
};

// src/models/invoiceContent/decoder.ts
var toInvoiceContent = (value) => {
  return parseResponse({
    value,
    codec: invoiceContent,
    callerFunctionName: "toInvoiceContent"
  });
};

// src/models/invoiceContent/mocks.ts
var mockInvoiceContent = {
  invoice: {
    id: "invoice-1",
    status: "DRAFT",
    currency: "GBP",
    customerLegalCompanyName: "The Customer 1",
    customerBillingAddress: {
      line1: "15 Yemen Road",
      line2: "Road",
      town: "Yemen",
      postcode: "YE1 2YE",
      country: "GB"
    },
    paymentOptions: ["BANK_TRANSFER"],
    totalTax: "0",
    netTotal: "0",
    grossTotal: "0",
    dueDate: "2022-11-25",
    purchaseOrderNumber: "PO123",
    memo: "Thanks",
    metadata: [],
    billingPeriod: { start: "2022-08-25", endInclusive: "2022-09-25" },
    customerTaxId: "TAX123"
  },
  lineItems: [
    {
      id: "line-item-1",
      title: "title",
      quantity: "1",
      rate: "10",
      taxRate: "0.2",
      netTotal: "1",
      totalTax: "0.2",
      grossTotal: "1.2",
      rateDisplay: "ABSOLUTE"
    },
    {
      id: "line-item-2",
      title: "title",
      quantity: "1",
      rate: "10",
      taxRate: "0.2",
      netTotal: "1",
      totalTax: "0.2",
      grossTotal: "1.2",
      rateDisplay: "ABSOLUTE"
    },
    {
      id: "line-item-3",
      title: "discount",
      quantity: "1",
      rate: "-10",
      taxRate: "0.2",
      netTotal: "1",
      totalTax: "0.2",
      grossTotal: "1.2",
      rateDisplay: "ABSOLUTE"
    }
  ],
  lineItemGroups: [
    {
      id: "line-item-1",
      title: "title",
      netTotal: "1",
      totalTax: "0.2",
      grossTotal: "1.2"
    },
    {
      id: "line-item-2",
      title: "title",
      netTotal: "1",
      totalTax: "0.2",
      grossTotal: "1.2"
    }
  ],
  merchantDetails: {
    address: {
      line1: "15 Yemen Road",
      town: "Yemen",
      postcode: "YE1 2YE",
      country: "GB"
    },
    email: "merchant@example.com",
    taxId: "TAX123",
    legalCompanyName: "The merchant",
    customFields: [],
    includeBeneficiaryAddressInPaymentDetails: true
  }
};

// src/models/invoiceContentV2/types.ts
import * as t51 from "io-ts";

// src/models/customerCreditBalance/types.ts
import * as t49 from "io-ts";
var customerCreditBalanceType = t49.keyof({
  CASH: null,
  USAGE: null
});
var customerCreditBalanceGrant = t49.exact(
  t49.intersection(
    [
      t49.type({
        currentBalance: t49.string,
        id: t49.string,
        name: t49.string,
        originalAmount: t49.string,
        type: customerCreditBalanceType,
        sequenceAccountId: t49.string,
        customerId: t49.string,
        currency,
        costOfCredit: t49.string,
        createdAt: t49.string
      }),
      t49.partial({
        expiryDate: t49.string,
        metricId: t49.string,
        taxRateId: t49.string,
        effectiveDate: t49.string
      })
    ],
    "CustomerCreditBalanceGrantModel"
  )
);
var customerCreditBalanceTransaction = t49.exact(
  t49.intersection(
    [
      t49.type({
        amount: t49.string,
        date: t49.string,
        grantId: t49.string,
        type: t49.string
      }),
      t49.partial({
        reason: t49.string,
        id: t49.string,
        invoiceId: t49.string,
        billingRunId: t49.string
      })
    ],
    "CustomerCreditBalanceTransactionModel"
  )
);
var customerCreditBalance = t49.exact(
  t49.type({
    balance: t49.string,
    grants: t49.array(customerCreditBalanceGrant),
    id: t49.string,
    name: t49.string,
    transactions: t49.array(customerCreditBalanceTransaction),
    type: customerCreditBalanceType
  })
);
var customerCreditBalancesResponseUnpaginated = createUnpaginatedResponse(
  customerCreditBalance,
  "CustomerCreditBalancesResponseUnpaginated"
);

// src/models/invoiceCurrencyConversion/types.ts
import * as t50 from "io-ts";
var currencyConversionModel = t50.exact(
  t50.type({
    id: t50.string,
    sequenceAccountId: t50.string,
    invoiceId: t50.string,
    currency,
    totalTax: t50.string,
    netTotal: t50.string,
    grossTotal: t50.string
  }),
  "CurrencyConversionModel"
);

// src/models/invoiceCurrencyConversion/mocks.ts
var mockCurrencyConversion = {
  id: "018d9d70-8eb1-7ccf-b9d1-dfd0b374f4a3",
  sequenceAccountId: "018d9d71-8eb1-7ccf-b9d1-dfd0b374f4a4",
  invoiceId: "018d9d72-8eb1-7ccf-b9d1-dfd0b374f4a5",
  currency: "USD",
  totalTax: "25.00",
  netTotal: "125.00",
  grossTotal: "150.00"
};

// src/models/invoiceCurrencyConversion/decoder.ts
var toCurrencyConversion = (value) => {
  return parseResponse({
    value,
    codec: currencyConversionModel,
    callerFunctionName: "toCurrencyConversionResponse"
  });
};

// src/models/invoiceContentV2/types.ts
var invoiceContentV2InvoiceModel = t51.exact(
  t51.intersection(
    [
      t51.type({
        id: t51.string,
        status: invoiceStatus,
        currency,
        customerLegalCompanyName: t51.string,
        customerBillingAddress: addressModel,
        totalTax: t51.string,
        netTotal: t51.string,
        grossTotal: t51.string,
        metadata: t51.array(keyValuePairModel),
        customerId: t51.string,
        accountingDate: t51.string,
        customerPortalEnabled: t51.boolean,
        creditBalances: t51.array(customerCreditBalance)
      }),
      t51.partial({
        invoiceNumber: t51.string,
        issueDate: t51.string,
        dueDate: t51.string,
        purchaseOrderNumber: t51.string,
        reference: t51.string,
        memo: t51.string,
        paymentOptions: t51.array(invoicePaymentOption),
        billingPeriod: inclusiveDateRange,
        customerTaxId: t51.string,
        merchantDetails: invoiceContentInvoiceMerchantDetailsModel,
        customerTaxStatus: taxStatus,
        renderSettings: invoiceRenderSettingsModel
      })
    ],
    "InvoiceContentV2InvoiceModel"
  )
);
var invoiceContentInvoiceSubAccountUsage = t51.type({
  id: t51.string,
  title: t51.string,
  value: t51.string
});
var invoiceContentUsageItemGroup = t51.type({
  id: t51.string,
  invoiceId: t51.string,
  title: t51.string,
  items: t51.array(invoiceContentInvoiceSubAccountUsage)
});
var invoiceContentV2LineItemModel = t51.exact(
  t51.intersection([
    t51.type({
      id: t51.string,
      title: t51.string,
      quantity: t51.string,
      rate: t51.string,
      taxRate: t51.string,
      grossTotal: t51.string,
      netTotal: t51.string,
      totalTax: t51.string,
      rateDisplay
    }),
    t51.partial({
      groupId: t51.string,
      priceId: t51.string,
      description: t51.string
    })
  ]),
  "InvoiceContentV2LineItemModel"
);
var invoiceContentV2 = t51.exact(
  t51.intersection([
    t51.type({
      invoice: invoiceContentV2InvoiceModel,
      lineItems: t51.array(invoiceContentV2LineItemModel),
      lineItemGroups: t51.array(invoiceContentLineItemGroupModel),
      merchantDetails: invoiceContentInvoiceMerchantDetailsModel
    }),
    t51.partial({
      merchant: invoiceContentMerchantModel,
      usageItemGroups: t51.array(invoiceContentUsageItemGroup),
      currencyConversions: t51.array(currencyConversionModel)
    })
  ])
);

// src/models/invoiceContentV2/decoder.ts
var toInvoiceContentV2 = (value) => {
  return parseResponse({
    value,
    codec: invoiceContentV2,
    callerFunctionName: "toInvoiceContentV2"
  });
};

// src/models/customerCreditBalance/mocks.ts
var mockCustomerCreditBalance = {
  balance: "75",
  grants: [
    {
      currentBalance: "75",
      id: "018d8919-400d-79d1-9ccf-f3fab14eff9c",
      name: "Cash Grant",
      originalAmount: "100",
      type: "CASH",
      sequenceAccountId: "sequenceAccountId",
      customerId: "customerId",
      createdAt: "2022-08-25T13:00:00",
      currency: "GBP",
      costOfCredit: "80"
    }
  ],
  id: "USD",
  name: "USD",
  transactions: [
    {
      amount: "25",
      date: "2024-02-27",
      grantId: "018d8919-400d-79d1-9ccf-f3fab14eff9c",
      type: "DEBIT",
      reason: ""
    }
  ],
  type: "CASH"
};
var mockCustomerCreditBalancesResponseUnpaginated = {
  items: [mockCustomerCreditBalance]
};

// src/models/invoiceContentV2/mocks.ts
var mockInvoiceContentV2 = {
  invoice: {
    id: "invoice-1",
    status: "DRAFT",
    currency: "GBP",
    customerLegalCompanyName: "The Customer 1",
    customerBillingAddress: {
      line1: "15 Yemen Road",
      line2: "Road",
      town: "Yemen",
      postcode: "YE1 2YE",
      country: "GB"
    },
    paymentOptions: ["BANK_TRANSFER"],
    totalTax: "0",
    netTotal: "0",
    grossTotal: "0",
    dueDate: "2022-11-25",
    purchaseOrderNumber: "PO123",
    memo: "Thanks",
    metadata: [],
    billingPeriod: { start: "2022-08-25", endInclusive: "2022-09-25" },
    customerTaxId: "TAX123",
    customerId: "customer-id-123",
    accountingDate: "2022-11-25",
    customerPortalEnabled: true,
    creditBalances: [mockCustomerCreditBalance]
  },
  lineItems: [
    {
      id: "line-item-1",
      title: "title",
      quantity: "1",
      rate: "10",
      taxRate: "0.2",
      netTotal: "1",
      totalTax: "0.2",
      grossTotal: "1.2",
      rateDisplay: "ABSOLUTE"
    },
    {
      id: "line-item-2",
      title: "title",
      quantity: "1",
      rate: "10",
      taxRate: "0.2",
      netTotal: "1",
      totalTax: "0.2",
      grossTotal: "1.2",
      rateDisplay: "ABSOLUTE"
    },
    {
      id: "line-item-3",
      title: "discount",
      quantity: "1",
      rate: "-10",
      taxRate: "0.2",
      netTotal: "1",
      totalTax: "0.2",
      grossTotal: "1.2",
      rateDisplay: "ABSOLUTE"
    }
  ],
  lineItemGroups: [
    {
      id: "line-item-1",
      title: "title",
      netTotal: "1",
      totalTax: "0.2",
      grossTotal: "1.2"
    },
    {
      id: "line-item-2",
      title: "title",
      netTotal: "1",
      totalTax: "0.2",
      grossTotal: "1.2"
    }
  ],
  merchantDetails: {
    address: {
      line1: "15 Yemen Road",
      town: "Yemen",
      postcode: "YE1 2YE",
      country: "GB"
    },
    email: "merchant@example.com",
    taxId: "TAX123",
    legalCompanyName: "The merchant",
    customFields: [],
    includeBeneficiaryAddressInPaymentDetails: true
  },
  currencyConversions: [mockCurrencyConversion]
};

// src/models/invoiceSettings/types.ts
import * as t52 from "io-ts";
var invoicePaymentProvider = t52.keyof({
  STRIPE: null,
  NONE: null
});
var invoiceSettingsModel = t52.strict(
  {
    id: t52.string,
    invoiceId: t52.string,
    sequenceAccountId: t52.string,
    paymentProvider: invoicePaymentProvider,
    customerId: t52.string
  },
  "InvoiceSettingsModel"
);

// src/models/invoiceSettings/decoder.ts
var toInvoiceSettings = (value) => {
  return parseResponse({
    value,
    codec: invoiceSettingsModel,
    callerFunctionName: "toInvoiceSettings"
  });
};

// src/models/invoiceSettings/format.ts
var paymentProviderToLabel = (paymentProvider2) => {
  switch (paymentProvider2) {
    case "STRIPE":
      return "Stripe";
    case "NONE":
      return "None";
  }
};

// src/models/invoiceSettings/mocks.ts
var mockInvoiceSettings = {
  id: "15b0ea6f-8fb2-4e15-94dc-1df221159e59",
  invoiceId: "c09cb3cd-ea02-4fd6-83e6-78b6db91ddbe",
  sequenceAccountId: "cb78d7aa-3b5a-4888-9b6b-f4f0fda4db0d",
  paymentProvider: "STRIPE",
  customerId: "id"
};

// src/models/lineItemGroup/types.ts
import * as t53 from "io-ts";
var lineItemGroupModel = t53.exact(
  t53.intersection([
    t53.type({
      id: t53.string,
      invoiceId: t53.string,
      title: t53.string,
      index: t53.number,
      grossTotal: t53.string,
      netTotal: t53.string,
      totalTax: t53.string
    }),
    t53.partial({
      description: t53.string
    })
  ]),
  "LineItemGroupModel"
);

// src/models/lineItemGroup/decoder.ts
var toLineItemGroup = (value) => {
  return parseResponse({
    value,
    codec: lineItemGroupModel,
    callerFunctionName: "toLineItemGroupResponse"
  });
};
var toUnpaginatedLineItemGroupsResponse = (value) => {
  return parseResponse({
    value,
    codec: createUnpaginatedResponse(
      lineItemGroupModel,
      "LineItemGroupsResponse"
    ),
    callerFunctionName: "toUnpaginatedLineItemGroupsResponse"
  });
};
var toLineItemGroupsResponse = (value) => {
  return parseResponse({
    value,
    codec: createPaginatedResponseNew(
      lineItemGroupModel,
      "LineItemGroupsResponse"
    ),
    callerFunctionName: "toLineItemGroupsResponse"
  });
};

// src/models/linkedEntity/decoder.ts
var toLinkedEntityModel = (value) => {
  return parseResponse({
    value,
    codec: linkedEntityModel,
    callerFunctionName: "toLinkedEntityModel"
  });
};

// src/models/linkedEntity/mocks.ts
var mockLinkedEntity = {
  id: "id",
  entityId: "customerId",
  sequenceAccountId: "sequenceAccountId",
  entityType: "CUSTOMER",
  externalService: "Xero",
  externalId: "xeroId",
  createdAt: "2022-10-25T12:24:08.018565Z"
};

// src/models/linkedEntity/types.ts
import * as t54 from "io-ts";
var linkedEntityType = t54.keyof({
  CREDIT_NOTE: null,
  CUSTOMER: null,
  INVOICE: null,
  PRICE: null,
  QUOTE: null
});
var linkedEntityModel = t54.exact(
  t54.intersection([
    t54.type({
      id: t54.string,
      entityId: t54.string,
      sequenceAccountId: t54.string,
      entityType: linkedEntityType,
      externalService: integrationService,
      externalId: t54.string,
      createdAt: t54.string
    }),
    t54.partial({
      externalAccountId: t54.string,
      externalUrl: t54.string,
      deletedAt: t54.string
    })
  ])
);

// src/models/merchant/types.ts
import * as t55 from "io-ts";
var merchantBankAccountDetailsModel = t55.exact(
  t55.type({
    key: currency,
    value: accountDetailsModel
  })
);
var merchantModel = t55.exact(
  t55.intersection(
    [
      t55.type({
        id: t55.string,
        sequenceAccountId: t55.string,
        invoiceNumberPrefix: t55.string,
        creditNoteNumberPrefix: t55.string,
        legalCompanyName: t55.string,
        address: addressModel,
        email: t55.string,
        defaultDueDateDays: t55.number,
        lastInvoiceNumber: t55.number,
        lastCreditNoteNumber: t55.number,
        bankAccountDetails: t55.array(merchantBankAccountDetailsModel),
        customerPortalEnabled: t55.boolean,
        includeBeneficiaryAddressInPaymentDetails: t55.boolean,
        ccMerchantOnInvoiceEmails: t55.boolean
      }),
      t55.partial({
        phoneNumber: t55.string,
        appUrl: t55.string
      })
    ],
    "MerchantModel"
  )
);

// src/models/merchant/mocks.ts
var mockMerchant = {
  id: "merchant-1",
  sequenceAccountId: "ABC",
  invoiceNumberPrefix: "INV",
  creditNoteNumberPrefix: "CN",
  legalCompanyName: "COMPANY",
  lastInvoiceNumber: 2,
  lastCreditNoteNumber: 1,
  address: {
    line1: "15 Yemen Road",
    line2: "Road",
    town: "Yemen",
    postcode: "YE1 2YE",
    country: "GB"
  },
  phoneNumber: "01234567890",
  email: "merchant@example.com",
  defaultDueDateDays: 30,
  bankAccountDetails: [],
  customerPortalEnabled: true,
  includeBeneficiaryAddressInPaymentDetails: true,
  ccMerchantOnInvoiceEmails: true
};

// src/models/merchant/decoder.ts
var toMerchant = (value) => {
  return parseResponse({
    value,
    codec: merchantModel,
    callerFunctionName: "toMerchantResponse"
  });
};

// src/models/monetaryAmount/types.ts
import * as t56 from "io-ts";
var monetaryAmountModel = t56.exact(
  t56.type(
    {
      currency,
      value: t56.string
    },
    "MonetaryAmountModel"
  )
);

// src/models/notificationPolicy/types.ts
import * as t57 from "io-ts";
var notificationChannel = t57.keyof({
  EMAIL: null,
  WEBHOOK: null
});
var notificationTypeGroups = {
  CUSTOMERS: null,
  INVOICES: null,
  INTEGRATIONS: null,
  MERCHANT: null,
  BILLING_SCHEDULES: null,
  CREDIT_NOTES: null,
  QUOTES: null
};
var notificationTypeGroup = t57.keyof(notificationTypeGroups);
var notificationTypes = {
  CUSTOMER_CREATED: "CUSTOMERS",
  CUSTOMER_UPDATED: "CUSTOMERS",
  CUSTOMER_ARCHIVED: "CUSTOMERS",
  INVOICE_CREATED: "INVOICES",
  INVOICE_ISSUED: "INVOICES",
  INVOICE_UPDATED: "INVOICES",
  INTEGRATION_SYNC_COMPLETED: "INTEGRATIONS",
  INTEGRATION_WEBHOOK_HANDLED: "INTEGRATIONS",
  MERCHANT_UPDATED: "MERCHANT",
  BILLING_SCHEDULE_CREATED: "BILLING_SCHEDULES",
  BILLING_SCHEDULE_UPDATED: "BILLING_SCHEDULES",
  BILLING_SCHEDULE_ARCHIVED: "BILLING_SCHEDULES",
  CREDIT_NOTE_CREATED: "CREDIT_NOTES",
  CREDIT_NOTE_UPDATED: "CREDIT_NOTES",
  CREDIT_NOTE_ISSUED: "CREDIT_NOTES",
  QUOTE_PUBLISHED: "QUOTES",
  QUOTE_ACCEPTED: "QUOTES"
};
var notificationType = t57.keyof(notificationTypes);
var notificationPolicyModel = t57.exact(
  t57.intersection([
    t57.type({
      id: t57.string,
      createdAt: t57.string,
      sequenceAccountId: t57.string,
      name: t57.string,
      recipients: t57.array(t57.string),
      channel: notificationChannel
    }),
    t57.partial({
      notificationTypes: t57.array(notificationType),
      webhookSecret: t57.string
    })
  ])
);

// src/models/notificationPolicy/mocks.ts
var mockNotificationPolicy = {
  id: "policy-1",
  sequenceAccountId: "ABC",
  createdAt: "time",
  name: "policy",
  recipients: ["recipient1"],
  channel: "EMAIL"
};
var mockNotificationPoliciesResponse = {
  items: [mockNotificationPolicy],
  pagination: mockPagination
};

// src/models/notificationPolicy/decoder.ts
var toNotificationPolicy = (value) => {
  return parseResponse({
    value,
    codec: notificationPolicyModel,
    callerFunctionName: "toNotificationPolicy"
  });
};
var toNotificationPoliciesResponse = (value) => {
  return parseResponse({
    value,
    codec: createPaginatedResponseNew(
      notificationPolicyModel,
      "notificationPoliciesResponse"
    ),
    callerFunctionName: "toNotificationPoliciesResponse"
  });
};

// src/models/oauthClient/types.ts
import * as t58 from "io-ts";
var oauthClientModel = t58.exact(
  t58.intersection([
    t58.type({
      id: t58.string,
      sequenceAccountId: t58.string,
      name: t58.string,
      scopes: t58.array(t58.string)
    }),
    t58.partial({
      pinnedApiVersion: t58.string
    })
  ])
);
var createOAuthClientResponseModel = t58.exact(
  t58.type({
    id: t58.string,
    name: t58.string,
    secret: t58.string
  })
);

// src/models/oauthClient/mocks.ts
var mockOAuthClient = {
  id: "client-1",
  sequenceAccountId: "ABC",
  name: "my client",
  scopes: ["product"]
};
var mockOAuthClientsResponse = {
  items: [mockOAuthClient],
  pagination: mockPagination
};
var mockCreateOAuthClientResponse = {
  id: "client-1",
  name: "my client",
  secret: "secret"
};

// src/models/oauthClient/decoder.ts
var toOAuthClient = (value) => {
  return parseResponse({
    value,
    codec: oauthClientModel,
    callerFunctionName: "toOAuthClient"
  });
};
var toOAuthClientsResponse = (value) => {
  return parseResponse({
    value,
    codec: createPaginatedResponseNew(oauthClientModel, "OAuthClientsResponse"),
    callerFunctionName: "toOAuthClientsResponse"
  });
};
var toCreateOAuthClientResponse = (value) => {
  return parseResponse({
    value,
    codec: createOAuthClientResponseModel,
    callerFunctionName: "toCreateOAuthClientResponse"
  });
};

// src/models/payer/types.ts
import * as t59 from "io-ts";
var payerModel = t59.exact(
  t59.intersection(
    [
      t59.type({
        accountHolderName: t59.string,
        address: addressModel,
        type: t59.keyof({ UK_BANK_ACCOUNT: null, IBAN: null })
      }),
      t59.partial({
        ukBankAccount: t59.union([sortCodeAccountNumberModel, t59.undefined]),
        iban: t59.union([t59.string, t59.undefined]),
        bankAccountId: t59.string,
        customerId: t59.string,
        email: t59.string,
        phone: t59.string
      })
    ],
    "PayerModel"
  )
);

// src/models/percentage/format.ts
import Big from "big.js";
function percentageFromDecimal(percentage) {
  return Big(Big(percentage).times(100)).toFixed(10).replace(/\.?0+$/, "").toString();
}
function decimalFromPercentage(percentage) {
  return Big(Big(percentage).div(100)).toFixed(4).toString();
}

// src/models/plan/types.ts
import * as t60 from "io-ts";
var planStatus = t60.keyof({
  PENDING: null,
  ACTIVE: null,
  SUSPENDED: null,
  CANCELLED: null,
  COMPLETED: null
});
var PropagationMode = t60.keyof({
  NEVER: null,
  IMMEDIATE: null,
  NEXT_BILLING_DATE: null
});
var planModel = t60.exact(
  t60.intersection(
    [
      t60.type({
        id: t60.string,
        name: t60.string,
        label: t60.string,
        currency,
        eligibleCustomerIds: t60.array(t60.string),
        sequenceAccountId: t60.string,
        createdAt: t60.string,
        updatedAt: t60.string,
        prices: t60.array(priceModel),
        versionChangeBehaviour: PropagationMode,
        schedulesCount: t60.number
      }),
      t60.partial({
        parentId: t60.string,
        versionEffectiveFrom: t60.string,
        minimum: t60.string
      })
    ],
    "PlanModel"
  )
);
var plansResponse = createPaginatedResponseNew(
  planModel,
  "PlansResponse"
);

// src/models/plan/mocks.ts
var mockPlans = [
  {
    id: "plan-id-1",
    name: "Sample plan 1",
    label: "Sample plan - EU",
    sequenceAccountId: "78c7558d-ae00-43a0-8b56-e1a27909550d",
    currency: "GBP",
    prices: [
      {
        id: "b082fe4c-8b37-40bf-ab42-e5687f9a6ad6",
        sequenceAccountId: "78c7558d-ae00-43a0-8b56-e1a27909550d",
        name: "Demo Product",
        structure: {
          pricingType: "FIXED",
          price: "0.25"
        },
        productId: "cd7f4d4a-bda5-48c6-966e-a42aab3568d0",
        createdAt: "2022-10-11T05:24:33.74399Z",
        currency: "GBP",
        externalIds: [
          {
            key: "Xero",
            value: "id"
          }
        ],
        billingFrequency: "MONTHLY",
        billingType: "IN_ARREARS",
        parameters: []
      }
    ],
    eligibleCustomerIds: [],
    createdAt: "2022-10-11T05:26:20.428828Z",
    updatedAt: "2022-10-11T05:26:20.428828Z",
    versionChangeBehaviour: "IMMEDIATE",
    versionEffectiveFrom: "2022-10-11",
    schedulesCount: 5
  },
  {
    id: "plan-id-2",
    name: "Sample plan 2",
    label: "Sample plan - EU",
    sequenceAccountId: "78c7558d-ae00-43a0-8b56-e1a27909550d",
    currency: "GBP",
    prices: [
      {
        id: "b082fe4c-8b37-40bf-ab42-e5687f9a6ad6",
        sequenceAccountId: "78c7558d-ae00-43a0-8b56-e1a27909550d",
        name: "Demo Product",
        structure: {
          pricingType: "FIXED",
          price: "0.25"
        },
        productId: "cd7f4d4a-bda5-48c6-966e-a42aab3568d0",
        createdAt: "2022-10-11T05:24:33.74399Z",
        currency: "GBP",
        externalIds: [
          {
            key: "Xero",
            value: "id"
          }
        ],
        billingFrequency: "MONTHLY",
        billingType: "IN_ARREARS",
        parameters: []
      },
      {
        id: "b082fe4c-8b37-40bf-ab42-e5687f9a6ad7",
        sequenceAccountId: "78c7558d-ae00-43a0-8b56-e1a27909550d",
        name: "Demo Product 2",
        structure: {
          pricingType: "FIXED",
          price: "0.25"
        },
        productId: "cd7f4d4a-bda5-48c6-966e-a42aab3568d0",
        createdAt: "2022-10-11T05:24:33.74399Z",
        currency: "GBP",
        externalIds: [
          {
            key: "Xero",
            value: "id"
          }
        ],
        billingFrequency: "MONTHLY",
        billingType: "IN_ARREARS",
        parameters: []
      }
    ],
    eligibleCustomerIds: [],
    createdAt: "2022-10-11T05:26:20.428828Z",
    updatedAt: "2022-10-11T05:26:20.428828Z",
    versionChangeBehaviour: "IMMEDIATE",
    versionEffectiveFrom: "2022-10-11",
    schedulesCount: 5
  }
];
var mockPlansResponse = {
  items: mockPlans,
  pagination: mockPagination
};

// src/models/plan/decoder.ts
var toPlan = (value) => {
  return parseResponse({
    value,
    codec: planModel,
    callerFunctionName: "toPlan"
  });
};
var toPlansResponse = (value) => {
  return parseResponse({
    value,
    codec: plansResponse,
    callerFunctionName: "toPlansResponse"
  });
};

// src/models/pricingStructure/decoder.ts
var toPriceTypeUrlChunk = (value) => {
  return parseResponse({
    value,
    codec: priceTypeUrlChunk,
    callerFunctionName: "toPriceTypeUrlChunk"
  });
};

// src/models/pricingStructure/format.ts
var toPricingTypeLabel = (value, fallback) => {
  const { group, label } = pricingTypeDescriptions[value];
  return `${group} > ${label}` ?? fallback;
};
var toPricingTypeLabelShort = (value, fallback) => {
  const { group, labelShort } = pricingTypeDescriptions[value];
  return `${group} > ${labelShort}` ?? fallback;
};
var toPricingTypeTableLabel = (value, fallback) => {
  return pricingTypeDescriptions[value]?.tableLabel ?? fallback ?? "";
};
var toPricingTypeOptions = (pricingTypes) => {
  return pricingTypes.map((pricingType2) => {
    const { label, urlChunk } = pricingTypeDescriptions[pricingType2];
    return {
      value: urlChunk,
      label
    };
  });
};
var toPriceSummary = (price) => {
  switch (price.structure.pricingType) {
    case "FIXED":
      return toMoney(
        {
          currency: price.currency,
          value: price.structure.price
        },
        "",
        10
      );
    case "ONE_TIME":
      return toMoney(
        {
          currency: price.currency,
          value: price.structure.price
        },
        "",
        10
      );
    case "LINEAR":
      if (price.structure.isPricePercentage) {
        return `${price.structure.pricePerUnit}% (${price.currency})`;
      }
      return `${toMoney(
        {
          currency: price.currency,
          value: price.structure.pricePerUnit
        },
        "",
        10
      )} per unit`;
    case "PACKAGE":
      return `${toMoney(
        {
          currency: price.currency,
          value: price.structure.pricePerPackage
        },
        "",
        10
      )} per package`;
    case "VOLUME":
    case "GRADUATED":
      if (price.structure.tiers[0].isPricePercentage) {
        return `Starts from ${price.structure.tiers[0].price}% (${price.currency})`;
      } else {
        return `Starts from ${toMoney(
          {
            currency: price.currency,
            value: price.structure.tiers[0].price
          },
          "",
          10
        )}${price.structure.tiers[0].fee ? ` + ${toMoney(
          {
            currency: price.currency,
            value: price.structure.tiers[0].fee
          },
          "",
          10
        )}` : ""}`;
      }
    case "SEAT_BASED":
      if (price.structure.tiers?.length) {
        return `Starts from ${toMoney(
          {
            currency: price.currency,
            value: price.structure.tiers[0].price
          },
          "",
          10
        )}`;
      }
      return `${toMoney(
        {
          currency: price.currency,
          value: price.structure.pricePerSeat
        },
        "",
        10
      )} per seat`;
  }
};
var toProrationStrategyLabel = (prorationStrategy2) => {
  switch (prorationStrategy2) {
    case "USE_MAXIMUM":
      return "Charge full amount (no proration)";
    case "PRORATE_INCREMENTS":
      return "Prorate added seats only (recommended)";
    case "PRORATE_ALL_CHANGES":
      return "Prorate added and removed seats";
  }
};
var toProrationStrategyOptions = (prorationStrategies) => {
  return prorationStrategies.map((prorationStrategy2) => ({
    value: prorationStrategy2,
    label: toProrationStrategyLabel(prorationStrategy2)
  }));
};
var toChargeMethodLabel = (chargeMethod2) => {
  switch (chargeMethod2) {
    case "CHARGE_FIXED":
      return "Charge fixed";
    case "CHARGE_OVERAGES":
      return "Charge overages";
    case "CHARGE_CONSUMED":
      return "Charge consumed";
    case "CHARGE_MINIMUM":
      return "Charge minimum";
  }
};
var toChargeMethodOptions = (chargeMethods) => {
  return chargeMethods.map((chargeMethod2) => ({
    value: chargeMethod2,
    label: toChargeMethodLabel(chargeMethod2)
  }));
};

// src/models/product/decoder.ts
var toProduct = (value) => {
  return parseResponse({
    value,
    codec: productModel,
    callerFunctionName: "toProduct"
  });
};
var toProductsResponse = (value) => {
  return parseResponse({
    value,
    codec: productsResponse,
    callerFunctionName: "toProductsResponse"
  });
};

// src/models/product/mocks.ts
var mockProduct = {
  id: "id",
  name: "name",
  label: "label",
  sequenceAccountId: "sequenceAccountId",
  createdAt: "2023-02-28T16:38:00Z",
  updatedAt: "2023-02-28T16:38:00Z"
};
var mockProductsResponse = {
  items: [mockProduct],
  pagination: mockPagination
};

// src/models/productStatus/format.tsx
var statusToFormat5 = {
  DRAFT: {
    children: "Draft",
    sentiment: "neutral"
  },
  ACTIVE: {
    children: "Active",
    sentiment: "info"
  },
  ARCHIVED: {
    children: "Archived",
    sentiment: "error"
  }
};
var toProductStatusBadgeProps = ({
  status,
  size = "md"
}) => ({
  ...statusToFormat5[status],
  size
});

// src/models/productStatus/types.ts
import * as t61 from "io-ts";
var productStatus = t61.keyof({
  ACTIVE: null,
  DRAFT: null,
  ARCHIVED: null
});

// src/models/quoteStatus/format.tsx
var STATUS_FORMAT_STYLE_MAP = {
  DRAFT: {
    children: "Draft",
    sentiment: "neutral"
  },
  PUBLISHED: {
    children: "Published",
    sentiment: "info"
  },
  READY_TO_SIGN: {
    children: "Published",
    sentiment: "info"
  },
  ACCEPTED: {
    children: "Signed",
    sentiment: "success"
  },
  EXECUTED: {
    children: "Executed",
    sentiment: "info"
  },
  EXPIRED: {
    children: "Expired",
    sentiment: "error"
  }
};
var toQuoteStatusBadgeProps = ({
  status,
  isPublished,
  isExpired,
  size = "md"
}) => {
  const statusReference = isExpired ? "EXPIRED" : isPublished && status === "DRAFT" ? "PUBLISHED" : status;
  return {
    ...STATUS_FORMAT_STYLE_MAP[statusReference],
    size
  };
};

// src/models/quoteStatus/types.ts
import * as t62 from "io-ts";
var quoteStatus = t62.keyof({
  DRAFT: null,
  READY_TO_SIGN: null,
  PUBLISHED: null,
  ACCEPTED: null,
  EXECUTED: null
});

// src/models/rtkqResponseError/types.ts
import * as t63 from "io-ts";
var validationErrorItem = t63.recursion(
  "ValidationErrorItem",
  () => t63.exact(
    t63.intersection(
      [
        t63.type({
          code: t63.keyof({ validationError: null, error: null }),
          message: t63.string
        }),
        t63.partial({
          key: t63.string,
          errors: t63.array(validationErrorItem)
        })
      ],
      "ValidationErrorItem"
    )
  )
);
var validationError = t63.strict(
  {
    type: t63.literal("validationError"),
    message: t63.string,
    errors: t63.array(validationErrorItem)
  },
  "ValidationError"
);
var validationErrorParent = t63.strict(
  {
    error: validationError
  },
  "ValidationErrorParent"
);
var fetchBaseQueryStatusError = t63.strict(
  {
    status: t63.number,
    data: validationErrorParent
  },
  "FetchBaseQueryStatusError"
);
var fetchBaseQueryFetchError = t63.exact(
  t63.intersection(
    [
      t63.type({
        status: t63.literal("FETCH_ERROR"),
        error: t63.string
      }),
      t63.partial({
        data: t63.undefined
      })
    ],
    "FetchBaseQueryFetchError"
  )
);
var fetchBaseQueryParsingError = t63.strict(
  {
    status: t63.literal("PARSING_ERROR"),
    originalStatus: t63.number,
    data: t63.string,
    error: t63.string
  },
  "FetchBaseQueryParsingError"
);
var fetchBaseQueryCustomError = t63.exact(
  t63.intersection(
    [
      t63.type({
        status: t63.literal("CUSTOM_ERROR"),
        error: t63.string
      }),
      t63.partial({
        data: t63.unknown
      })
    ],
    "FetchBaseQueryCustomError"
  )
);
var serializedError = t63.strict(
  {
    name: t63.string,
    message: t63.string,
    stack: t63.string,
    code: t63.string
  },
  "SerializedError"
);
var rtkqResponseError = t63.strict(
  {
    error: t63.union([
      fetchBaseQueryStatusError,
      fetchBaseQueryFetchError,
      fetchBaseQueryParsingError,
      fetchBaseQueryCustomError,
      serializedError
    ])
  },
  "RtkqResponseError"
);
var rtkqResponseData = t63.strict(
  {
    data: t63.unknown
  },
  "RtkqResponseData"
);
var rtkqResponse = t63.union([rtkqResponseError, rtkqResponseData]);

// src/models/rtkqResponseError/mocks.ts
var mockCustomerParsingError = {
  error: {
    type: "validationError",
    message: "JSON parsing failed",
    errors: [
      {
        code: "validationError",
        message: "Unable to deserialise JSON due to missing fields (line1). Please make sure all fields are present."
      }
    ]
  }
};
var mockCustomerValidationError = {
  error: {
    type: "validationError",
    message: "Data validation failed",
    errors: [
      {
        code: "validationError",
        message: "Invalid IBAN",
        key: "accountDetails",
        errors: [{ code: "error", message: "Invalid IBAN", errors: [] }]
      },
      {
        code: "validationError",
        message: "Invalid reference",
        key: "paymentReference",
        errors: [
          { code: "validationError", message: "Invalid reference", errors: [] }
        ]
      }
    ]
  }
};

// src/models/rtkqResponseError/decoder.ts
var toRtkqResponseError = (value) => {
  return parseResponse({
    value,
    codec: rtkqResponseError,
    callerFunctionName: "toRtkqResponseError"
  });
};
var toRtkqResponse = (value) => {
  return parseResponse({
    value,
    codec: rtkqResponse,
    callerFunctionName: "toRtkqResponse"
  });
};

// src/models/seatChange/types.ts
import * as t64 from "io-ts";
var seatChangeType = t64.keyof({
  SEAT_ADDED: null,
  SEAT_REMOVED: null
});
var seatChangeModel = t64.exact(
  t64.intersection(
    [
      t64.type({
        changeType: seatChangeType,
        id: t64.string,
        seatSnapshotId: t64.string,
        timestamp: t64.string
      }),
      t64.partial({
        description: t64.string,
        externalId: t64.string,
        reason: t64.string
      })
    ],
    "seatChangeModel"
  )
);

// src/models/seatSnapshot/types.ts
import * as t65 from "io-ts";
var seatSnapshotModel = t65.exact(
  t65.intersection(
    [
      t65.type({
        customerAlias: t65.string,
        customerSnapshotId: t65.string,
        id: t65.string,
        seatChanges: t65.array(seatChangeModel),
        seatType: t65.string,
        sequenceAccountId: t65.string,
        snapshotTimestamp: t65.string,
        total: t65.number
      }),
      t65.partial({ reason: t65.string })
    ],
    "seatSnapshotModel"
  )
);
var seatSnapshotsResponse = createPaginatedResponseNew(
  seatSnapshotModel,
  "seatSnapshotsResponse"
);

// src/models/seatSnapshot/decoder.ts
var toSeatSnapshot = (value) => {
  return parseResponse({
    value,
    codec: seatSnapshotModel,
    callerFunctionName: "toSeatSnapshot"
  });
};
var toSeatSnapshotsResponse = (value) => {
  return parseResponse({
    value,
    codec: seatSnapshotsResponse,
    callerFunctionName: "toSeatSnapshotsResponse"
  });
};

// src/models/seatSnapshot/mocks.ts
var mockSeatSnapshot = {
  id: "0184421a-8202-70ea-a729-30308a40bbf7",
  customerAlias: "customer-id-2H4u5BBwBWsS5V2sroRFqJfTXpW",
  customerSnapshotId: "event-id-H4twuTWpYx1rkd8OMTki2hTUcZ",
  seatChanges: [],
  seatType: "admin",
  sequenceAccountId: "0184421e-a9cc-711b-af93-bf0511d4d833",
  snapshotTimestamp: "2022-10-01T00:00:00Z",
  total: 1
};
var mockSeatSnapshotsResponse = {
  items: [mockSeatSnapshot],
  pagination: mockPagination
};

// src/models/seatTotal/types.ts
import * as t66 from "io-ts";
var seatTotalModel = t66.strict(
  {
    id: t66.string,
    changeTimestamp: t66.string,
    customerAlias: t66.string,
    seatType: t66.string,
    total: t66.number
  },
  "seatTotalModel"
);
var seatTypeBalance = t66.strict({
  seatType: t66.string,
  total: t66.number,
  changeTimestamp: t66.string
});
var seatBalanceModel = t66.strict(
  {
    id: t66.string,
    sequenceAccountId: t66.string,
    legalName: t66.string,
    customerAliases: t66.array(t66.string),
    total: t66.number,
    changeTimestamp: t66.string,
    balances: t66.array(seatTypeBalance)
  },
  "seatBalanceModel"
);
var seatTotalsResponse = createPaginatedResponseNew(
  seatTotalModel,
  "seatTotalsResponse"
);
var seatBalancesResponse = createPaginatedResponseNew(
  seatBalanceModel,
  "seatBalancesResponse"
);

// src/models/seatTotal/decoder.ts
var toSeatTotal = (value) => {
  return parseResponse({
    value,
    codec: seatTotalModel,
    callerFunctionName: "toSeatTotalResponse"
  });
};
var toSeatTotalsResponse = (value) => {
  return parseResponse({
    value,
    codec: seatTotalsResponse,
    callerFunctionName: "toSeatTotalsResponse"
  });
};
var toSeatBalancesResponse = (value) => {
  return parseResponse({
    value,
    codec: seatBalancesResponse,
    callerFunctionName: "toSeatBalancesResponse"
  });
};

// src/models/seatTotal/mocks.ts
var mockSeatTotal = {
  id: "0184421a-8202-70ea-a729-30308a40bbf7",
  changeTimestamp: "2023-09-01T10:00:00.000Z",
  customerAlias: "test-customer",
  seatType: "administrator",
  total: 10
};
var mockSeatBalance = {
  id: "0184421a-8202-70ea-a729-30308a40bbf7",
  sequenceAccountId: "",
  legalName: "test-customer",
  customerAliases: ["test-customer"],
  total: 10,
  changeTimestamp: "2023-09-01T10:00:00.000Z",
  balances: [
    {
      seatType: "administrator",
      total: 10,
      changeTimestamp: "2023-09-01T10:00:00.000Z"
    }
  ]
};
var mockSeatTotalsResponse = {
  items: [mockSeatTotal],
  pagination: mockPagination
};
var mockSeatBalancesResponse = {
  items: [mockSeatBalance],
  pagination: mockPagination
};

// src/models/seatType/types.ts
import * as t67 from "io-ts";
var seatTypeModel = t67.intersection([
  t67.exact(
    t67.type(
      {
        id: t67.string,
        key: t67.string,
        label: t67.string,
        sequenceAccountId: t67.string,
        createdAt: t67.string,
        updatedAt: t67.string
      },
      "seatTypeModel"
    )
  ),
  t67.partial({
    deletedAt: t67.string,
    sequenceUserId: t67.string
  })
]);
var seatTypesResponse = createPaginatedResponseNew(
  seatTypeModel,
  "seatTypesResponse"
);

// src/models/seatType/decoder.ts
var toSeatType = (value) => {
  return parseResponse({
    value,
    codec: seatTypeModel,
    callerFunctionName: "toSeatTypeResponse"
  });
};
var toSeatTypesResponse = (value) => {
  return parseResponse({
    value,
    codec: seatTypesResponse,
    callerFunctionName: "toSeatTypesResponse"
  });
};

// src/models/seatType/mocks.ts
var mockSeatType = {
  id: "bc61d4b8-e9d6-4f4a-9bcf-f5dae874c730",
  createdAt: "2022-06-28T16:47:00Z",
  key: "admin",
  label: "Administrator",
  sequenceAccountId: "1986c663-9ee9-4811-bfbf-57d2ad666096",
  updatedAt: "2022-06-28T16:47:00Z"
};
var mockSeatTypesResponse = {
  items: [mockSeatType],
  pagination: mockPagination
};

// src/models/self/types.ts
import * as t68 from "io-ts";
var sequenceUser = t68.exact(
  t68.type({
    id: t68.string,
    email: t68.string,
    createdAt: t68.string
  }),
  "SequenceUserModel"
);
var selfModel = t68.exact(
  t68.type({
    sequenceUser,
    sequenceAccounts: t68.array(t68.string),
    launchDarklyHash: t68.string
  }),
  "CustomerModel"
);

// src/models/self/mocks.ts
var mockSelf = {
  sequenceUser: {
    id: "user-id-1",
    email: "foo@example.com",
    createdAt: ""
  },
  sequenceAccounts: ["account-id-1"],
  launchDarklyHash: "96053e2731801c3aa3c44c550b72af55c75ef0c17cbb1ae51c038368fd8ce7e6"
};

// src/models/self/decoder.ts
var toSelf = (value) => {
  return parseResponse({
    value,
    codec: selfModel,
    callerFunctionName: "toSelf"
  });
};

// src/models/sequenceAccount/types.ts
import * as t69 from "io-ts";
var sequenceAccountModel = t69.intersection([
  t69.exact(
    t69.type({
      id: t69.string,
      createdAt: t69.string,
      sequenceOrganisationId: t69.string,
      companyName: t69.string,
      companyNumber: t69.string,
      country,
      sendCustomerNotifications: t69.boolean,
      alertEmailAddresses: t69.array(t69.string)
    })
  ),
  t69.partial({
    deletedAt: t69.string
  })
]);

// src/models/sequenceAccount/mocks.ts
var mockSequenceAccount = {
  id: "id",
  createdAt: "2022-06-28T16:47:00Z",
  sequenceOrganisationId: "orgId",
  companyName: "Acme Corp",
  companyNumber: "A123",
  country: "GB",
  sendCustomerNotifications: true,
  alertEmailAddresses: ["alert@example.com"]
};

// src/models/sequenceAccount/decoder.ts
var toSequenceAccount = (value) => {
  return parseResponse({
    value,
    codec: sequenceAccountModel,
    callerFunctionName: "toSequenceAccount"
  });
};

// src/models/sequenceAccountId/types.ts
import * as t70 from "io-ts";
var sequenceAccountIdModel = t70.exact(
  t70.type({
    id: t70.string
  })
);

// src/models/sequenceAccountId/mocks.ts
var mockSequenceAccountId = {
  id: "id"
};

// src/models/sequenceAccountId/decoder.ts
var toSequenceAccountId = (value) => {
  return parseResponse({
    value,
    codec: sequenceAccountIdModel,
    callerFunctionName: "toSequenceAccountId"
  });
};

// src/models/sequenceAccountSettings/types.ts
import * as t71 from "io-ts";
var sequenceAccountSettingsModel = t71.exact(
  t71.type({
    id: t71.string,
    sequenceAccountId: t71.string,
    enabledCurrencies: t71.array(currency)
  })
);

// src/models/sequenceAccountSettings/decoder.ts
var toSequenceAccountSettings = (value) => {
  return parseResponse({
    value,
    codec: sequenceAccountSettingsModel,
    callerFunctionName: "toSequenceAccountSettings"
  });
};

// src/models/sequenceAccountSettings/mocks.ts
var mockSequenceAccountSettings = {
  id: "settings-1",
  sequenceAccountId: "account-1",
  enabledCurrencies: ["GBP", "USD", "EUR", "ZAR"]
};

// src/models/taxRates/types.ts
import * as t72 from "io-ts";
var taxRateModel = t72.exact(
  t72.intersection(
    [
      t72.type({
        id: t72.string,
        sequenceAccountId: t72.string,
        amount: t72.string,
        country,
        invoiceName: t72.string,
        invoiceShortName: t72.string,
        isPublished: t72.boolean,
        name: t72.string,
        subRates: t72.array(t72.any),
        version: t72.number,
        versionId: t72.string,
        isArchived: t72.boolean
      }),
      t72.partial({
        region: t72.string,
        description: t72.string
      })
    ],
    "TaxRateModel"
  )
);
var taxRatesResponse = createPaginatedResponseNew(
  taxRateModel,
  "TaxRatesResponse"
);

// src/models/taxRates/decoder.ts
var toTaxRate = (value) => {
  return parseResponse({
    value,
    codec: taxRateModel,
    callerFunctionName: "toTaxRate"
  });
};
var toTaxRatesResponse = (value) => {
  return parseResponse({
    value,
    codec: taxRatesResponse,
    callerFunctionName: "toTaxRatesResponse"
  });
};

// src/models/taxRates/mocks.ts
var mockTaxRates = [
  {
    id: "8614937b-ce90-4944-b060-a7ddab90dbf5",
    sequenceAccountId: "2780077d-0bd3-4027-95bf-e16a1447578d",
    amount: "0.2",
    country: "GB",
    invoiceName: "VAT",
    invoiceShortName: "VAT",
    isPublished: true,
    name: "VAT",
    subRates: [],
    version: 0,
    versionId: "8384005b-9be3-4108-826c-01142a33af75",
    isArchived: false
  }
];
var mockTaxRatesResponse = {
  items: mockTaxRates,
  pagination: mockPagination
};

// src/models/taxRegistration/types.ts
import * as t73 from "io-ts";
var taxRegistrationModel = t73.exact(
  t73.intersection(
    [
      t73.type({
        id: t73.string,
        taxIdentifier: t73.string,
        country,
        sequenceAccountId: t73.string,
        customerId: t73.string
      }),
      t73.partial({
        merchantId: t73.string,
        state
      })
    ],
    "TaxRegistrationModel"
  )
);
var taxRegistrationsResponse = createPaginatedResponseNew(
  taxRegistrationModel,
  "TaxRegistrationsResponse"
);

// src/models/taxRegistration/mocks.ts
var mockTaxRegistration = {
  id: "8614937b-ce90-4944-b060-a7ddab90dbf5",
  sequenceAccountId: "2780077d-0bd3-4027-95bf-e16a1447578d",
  taxIdentifier: "T4XE5",
  country: "GB",
  customerId: "8384005b-9be3-4108-826c-01142a33af75"
};
var mockTaxRegistrations = [
  mockTaxRegistration
];
var mockTaxRegistrationsResponse = {
  items: mockTaxRegistrations,
  pagination: mockPagination
};

// src/models/taxRegistration/decoder.ts
var toTaxRegistration = (value) => {
  return parseResponse({
    value,
    codec: taxRegistrationModel,
    callerFunctionName: "toTaxRegistration"
  });
};
var toTaxRegistrationsResponse = (value) => {
  return parseResponse({
    value,
    codec: taxRegistrationsResponse,
    callerFunctionName: "toTaxRegistrationsResponse"
  });
};

// src/models/usageEvents/types.ts
import * as t74 from "io-ts";
var usageEventModel = t74.exact(
  t74.type({
    id: t74.string,
    customerAlias: t74.string,
    customerEventId: t74.string,
    eventTimestamp: t74.string,
    eventType: t74.string,
    eventProperties: t74.record(t74.string, t74.unknown),
    sequenceAccountId: t74.string
  })
);
var usageEventsResponse = createPaginatedResponseNew(
  usageEventModel,
  "UsageEventsResponse"
);

// src/models/usageEvents/decoder.ts
var toUsageEvent = (value) => {
  return parseResponse({
    value,
    codec: usageEventModel,
    callerFunctionName: "toUsageEvent"
  });
};
var toUsageEventsResponse = (value) => {
  return parseResponse({
    value,
    codec: usageEventsResponse,
    callerFunctionName: "toUsageEventsResponse"
  });
};

// src/models/usageEvents/mocks.ts
var mockUsageEvents = [
  {
    id: "01849e38-bbb0-7fab-86eb-62865adf75c7",
    customerEventId: "eventid-33bb8cbb-430f-43d1-b26a-29a9e534e598",
    customerAlias: "7d9249ce-aa44-45fe-99dd-2847dd4b3112",
    eventType: "message_sent",
    eventTimestamp: "2022-06-28T16:47:00Z",
    eventProperties: { type: "abcd", length: 1 },
    sequenceAccountId: "78c7558d-ae00-43a0-8b56-e1a27909550d"
  }
];
var mockUsageEventsResponse = {
  items: mockUsageEvents,
  pagination: mockPagination
};

// src/models/usageMetrics/types.ts
import * as t75 from "io-ts";
var metricType = t75.keyof({
  SIMPLE: null,
  GROUPED: null
});
var customParameterType = t75.keyof({
  INTEGER: null,
  POSITIVE_INTEGER: null,
  NUMBER: null,
  POSITIVE_NUMBER: null
});
var customParameterModel = t75.exact(
  t75.type({
    id: t75.string,
    usageMetricId: t75.string,
    name: t75.string,
    type: customParameterType,
    description: t75.string,
    defaultValue: t75.string
  })
);
var usageMetricModel = t75.exact(
  t75.intersection([
    t75.type({
      id: t75.string,
      name: t75.string,
      eventType: t75.string,
      aggregationType,
      propertyFilters: t75.record(t75.string, t75.array(t75.string)),
      metricType,
      sequenceAccountId: t75.string,
      parameters: t75.array(customParameterModel)
    }),
    t75.partial({
      description: t75.string,
      aggregationProperty: t75.string,
      unit: t75.string,
      groupingProperty: t75.string,
      createdAt: t75.string,
      caseSensitive: t75.boolean,
      propertiesToNegate: t75.array(t75.string)
    })
  ])
);
var usageMetricsResponse = createPaginatedResponseNew(
  usageMetricModel,
  "UsageMetricsResponse"
);
var uniqueUsageEventProperties = t75.strict({
  items: t75.array(t75.string)
});
var uniqueUsageEventTypes = t75.strict({
  items: t75.array(t75.string)
});

// src/models/usageMetrics/decoder.ts
var toUsageMetric = (value) => {
  return parseResponse({
    value,
    codec: usageMetricModel,
    callerFunctionName: "toUsageMetric"
  });
};
var toUsageMetricsResponse = (value) => {
  return parseResponse({
    value,
    codec: usageMetricsResponse,
    callerFunctionName: "toUsageMetricsResponse"
  });
};
var toUniqueUsageEventProperties = (value) => {
  return parseResponse({
    value,
    codec: uniqueUsageEventProperties,
    callerFunctionName: "toUniqueUsageEventProperties"
  });
};
var toUniqueUsageEventTypes = (value) => {
  return parseResponse({
    value,
    codec: uniqueUsageEventTypes,
    callerFunctionName: "toUniqueUsageEventTypes"
  });
};

// src/models/usageMetrics/format.ts
var metricPropertyMatchers = {
  is: "matches",
  isNot: "does not match"
};
var metricPropertyMatchersOptions = Object.keys(
  metricPropertyMatchers
).map((key) => ({
  label: metricPropertyMatchers[key],
  value: key
}));

// src/models/usageMetrics/mocks.ts
var mockUsageMetric = {
  id: "id",
  name: "name",
  eventType: "eventType",
  aggregationType: "COUNT",
  propertyFilters: { key: ["value"] },
  propertiesToNegate: ["key"],
  metricType: "SIMPLE",
  sequenceAccountId: "sequenceAccountId",
  parameters: [
    {
      id: "id",
      usageMetricId: "id",
      name: "param",
      type: "INTEGER",
      description: "My param",
      defaultValue: "10"
    }
  ]
};
var mockUsageMetricsResponse = {
  items: [mockUsageMetric],
  pagination: mockPagination
};
var mockUniqueUsageEventProperties = {
  items: ["property-one", "property-two", "property-three"]
};
var mockUniqueUsageEventTypes = {
  items: ["type-one", "type-two", "type-three"]
};

// src/models/usageMetricsCalculation/decoder.ts
var toUsageMetricCalculation = (value) => {
  return parseResponse({
    value,
    codec: usageMetricCalculation,
    callerFunctionName: "toUsageMetricCalculation"
  });
};

// src/models/usageMetricsCalculation/mocks.ts
var mockUsageMetricCalculation = {
  eventCount: 5,
  eventType: "message_sent",
  maxEventId: "0183ea03-aca0-7019-b80d-6aacce344e92",
  metricType: "GROUPED",
  minEventId: "0183d0f1-6b5a-74d4-9129-1f4b90191666",
  name: "total_messages_sent",
  unit: "bytes",
  value: 150.035,
  aggregationType: "SUM"
};

// src/models/usageMetricsCalculation/types.ts
import * as t76 from "io-ts";
var usageMetricCalculation = t76.exact(
  t76.intersection([
    t76.type({
      eventCount: t76.number,
      eventType: t76.string,
      metricType,
      aggregationType,
      name: t76.string,
      value: t76.number
    }),
    t76.partial({
      minEventId: t76.string,
      maxEventId: t76.string,
      unit: t76.string
    })
  ])
);

// src/models/user/types.ts
import * as t77 from "io-ts";
var userModel = t77.exact(
  t77.type({
    id: t77.string,
    email: t77.string,
    sequenceAccountIds: t77.array(t77.string),
    state: t77.string
  })
);

// src/models/user/decoder.ts
var toUsers = (value) => {
  return parseResponse({
    value,
    codec: createPaginatedResponseNew(userModel, "UsersResponse"),
    callerFunctionName: "toUsers"
  });
};
var toUser = (value) => {
  return parseResponse({
    value,
    codec: userModel,
    callerFunctionName: "toUser"
  });
};

// src/models/user/mocks.ts
var mockUsersResponse = {
  items: [
    {
      id: "id",
      email: "user@example.com",
      sequenceAccountIds: ["sequenceAccountId"],
      state: "active"
    }
  ],
  pagination: mockPagination
};
var mockUser = {
  id: "id",
  email: "user@example.com",
  sequenceAccountIds: ["sequenceAccountId"],
  state: "active"
};

// src/models/invoicesGrid/types.ts
import * as t78 from "io-ts";
var invoicesGrid = t78.strict(
  {
    sequenceAccountId: t78.string,
    customerDetails: t78.array(
      t78.type({
        customerId: t78.string,
        legalName: t78.string,
        total: t78.string,
        netTotal: t78.string,
        monthDetails: t78.array(
          t78.type({
            month: t78.string,
            total: t78.string,
            netTotal: t78.string,
            invoiceIds: t78.array(t78.string)
          })
        )
      })
    ),
    monthDetails: t78.array(
      t78.type({
        month: t78.string,
        total: t78.string,
        netTotal: t78.string,
        invoiceIds: t78.array(t78.string)
      })
    ),
    accountTotal: t78.string,
    accountNetTotal: t78.string
  },
  "InvoicesGrid"
);

// src/models/invoicesGrid/decoder.ts
var toInvoicesGrid = (value) => {
  return parseResponse({
    value,
    codec: invoicesGrid,
    callerFunctionName: "toInvoicesGrid"
  });
};

// src/models/invoicesGrid/mocks.ts
var mockInvoicesGrid = {
  sequenceAccountId: "ac4c5184-b282-40b6-862c-ac9de3859e27",
  customerDetails: [
    {
      customerId: "4ecc7384-e25e-459d-b811-fb5f3ae73923",
      legalName: "Saas Corp",
      total: "600",
      netTotal: "400",
      monthDetails: [
        {
          month: "2023-09-01",
          total: "300",
          netTotal: "200",
          invoiceIds: ["b78f0591-afcc-43bc-851f-2288aa25b07b"]
        },
        {
          month: "2023-10-01",
          total: "300",
          netTotal: " 200",
          invoiceIds: ["227b8ff9-42ad-47f8-bfa5-9e5760d4d5d8"]
        }
      ]
    },
    {
      customerId: "a0bc49b1-8e9a-4995-af73-5db2f9bd494b",
      legalName: "Hermanos Cafeteros Inc.",
      total: "600",
      netTotal: "400",
      monthDetails: [
        {
          month: "2023-09-01",
          total: "300",
          netTotal: "200",
          invoiceIds: ["12e4c680-a33d-4440-b01b-6e259e0a51d4"]
        },
        {
          month: "2023-10-01",
          total: "300",
          netTotal: "200",
          invoiceIds: [
            "c82c7f82-2d76-49b4-832b-c9bb1969a5c6",
            "1b4d180d-ae8d-413c-9a97-08a7a85a2980"
          ]
        }
      ]
    }
  ],
  accountTotal: "1200",
  accountNetTotal: "800",
  monthDetails: [
    {
      month: "2023-09-01",
      total: "600",
      netTotal: "400",
      invoiceIds: [
        "b78f0591-afcc-43bc-851f-2288aa25b07b",
        "12e4c680-a33d-4440-b01b-6e259e0a51d4"
      ]
    },
    {
      month: "2023-10-01",
      total: "600",
      netTotal: "400",
      invoiceIds: [
        "227b8ff9-42ad-47f8-bfa5-9e5760d4d5d8",
        "c82c7f82-2d76-49b4-832b-c9bb1969a5c6",
        "1b4d180d-ae8d-413c-9a97-08a7a85a2980"
      ]
    }
  ]
};

// src/models/customerCreditBalance/decoder.ts
var toCustomerCreditBalancesResponseUnpaginated = (value) => {
  return parseResponse({
    value,
    codec: customerCreditBalancesResponseUnpaginated,
    callerFunctionName: "toCustomerCreditBalancesResponseUnpaginated"
  });
};

// src/models/insights/types.ts
import * as t79 from "io-ts";
var totalCustomersModel = t79.exact(
  t79.type({
    total: t79.number,
    numCustomersWithActiveSchedule: t79.number,
    numCustomersNoLongerBilled: t79.number,
    numCustomersNeverBilled: t79.number
  })
);
var insightsUsageEventsModel = t79.exact(
  t79.type({
    totalEventCount: t79.number,
    eventsByDay: t79.array(
      t79.exact(
        t79.type({
          eventCount: t79.number,
          date: t79.string
        })
      )
    )
  })
);
var insightsInvoicedRevenueModel = t79.exact(
  t79.type({
    currency,
    totalAmount: t79.number,
    invoicedRevenueByMonth: t79.array(
      t79.exact(
        t79.type({
          amount: t79.number,
          periodStart: t79.string
        })
      )
    )
  })
);
var insightsOutstandingInvoicesModel = t79.exact(
  t79.type({
    currency,
    totalAmount: t79.number,
    outstandingNow: t79.exact(
      t79.type({
        amount: t79.number,
        numberOfInvoices: t79.number
      })
    ),
    overdueFrom0to30days: t79.exact(
      t79.type({
        amount: t79.number,
        numberOfInvoices: t79.number
      })
    ),
    overdueFrom31to60days: t79.exact(
      t79.type({
        amount: t79.number,
        numberOfInvoices: t79.number
      })
    ),
    overdueFrom61days: t79.exact(
      t79.type({
        amount: t79.number,
        numberOfInvoices: t79.number
      })
    )
  })
);
var insightsUsageMetricDataModel = t79.exact(
  t79.type({
    periodStart: t79.string,
    amount: t79.string,
    cumulativeAmount: t79.string
  }),
  "InsightsUsageMetricDataModel"
);
var insightsUsageMetricResponse = t79.exact(
  t79.type({
    data: t79.type({
      usageStart: t79.string,
      usageEnd: t79.string,
      metricName: t79.string,
      metricId: t79.string,
      total: t79.string,
      usageData: t79.array(insightsUsageMetricDataModel)
    })
  }),
  "InsightsUsageMetricResponse"
);

// src/models/insights/decoder.ts
var toTotalCustomersResponse = (value) => {
  return parseResponse({
    value,
    codec: totalCustomersModel,
    callerFunctionName: "toTotalCustomersResponse"
  });
};
var toInsightsUsageEventsResponse = (value) => {
  return parseResponse({
    value,
    codec: insightsUsageEventsModel,
    callerFunctionName: "toInsightsUsageEventsResponse"
  });
};
var toInsightsInvoicedRevenueResponse = (value) => {
  return parseResponse({
    value,
    codec: insightsInvoicedRevenueModel,
    callerFunctionName: "toInsightsInvoicedRevenueResponse"
  });
};
var toInsightsOutstandingInvoicesResponse = (value) => {
  return parseResponse({
    value,
    codec: insightsOutstandingInvoicesModel,
    callerFunctionName: "toInsightsOutstandingInvoicesResponse"
  });
};
var toInsightsUsageMetricResponse = (value) => {
  return parseResponse({
    value,
    codec: insightsUsageMetricResponse,
    callerFunctionName: "toInsightsUsageMetricResponse"
  });
};

// src/models/insights/mocks.ts
var mockTotalCustomers = {
  total: 100,
  numCustomersWithActiveSchedule: 50,
  numCustomersNoLongerBilled: 25,
  numCustomersNeverBilled: 25
};
var mockInsightsUsageEvents = {
  totalEventCount: 100,
  eventsByDay: [
    {
      eventCount: 10,
      date: "2021-01-01"
    },
    {
      eventCount: 20,
      date: "2021-01-02"
    },
    {
      eventCount: 30,
      date: "2021-01-03"
    },
    {
      eventCount: 40,
      date: "2021-01-04"
    }
  ]
};
var mockInsightsInvoicedRevenue = {
  currency: "GBP",
  totalAmount: 1e3,
  invoicedRevenueByMonth: [
    {
      amount: 100,
      periodStart: "2021-01-01"
    },
    {
      amount: 200,
      periodStart: "2021-02-01"
    },
    {
      amount: 300,
      periodStart: "2021-03-01"
    },
    {
      amount: 400,
      periodStart: "2021-04-01"
    }
  ]
};
var mockInsightsOutstandingInvoices = {
  currency: "GBP",
  totalAmount: 1e3,
  outstandingNow: {
    amount: 100,
    numberOfInvoices: 10
  },
  overdueFrom0to30days: {
    amount: 200,
    numberOfInvoices: 20
  },
  overdueFrom31to60days: {
    amount: 300,
    numberOfInvoices: 30
  },
  overdueFrom61days: {
    amount: 400,
    numberOfInvoices: 40
  }
};
var mockInsightsUsageMetricResponse = {
  data: {
    usageStart: "2021-01-01",
    usageEnd: "2021-01-31",
    metricName: "Card Payments",
    metricId: "card_payments",
    total: "100",
    usageData: [
      {
        periodStart: "2021-01-01",
        amount: "10",
        cumulativeAmount: "10"
      },
      {
        periodStart: "2021-01-02",
        amount: "20",
        cumulativeAmount: "30"
      },
      {
        periodStart: "2021-01-03",
        amount: "30",
        cumulativeAmount: "60"
      },
      {
        periodStart: "2021-01-04",
        amount: "40",
        cumulativeAmount: "100"
      }
    ]
  }
};

// src/models/priceMetadata/types.ts
import * as t80 from "io-ts";
var priceMetadataBillingScheduleDetailModel = t80.exact(
  t80.type({
    billingScheduleId: t80.string,
    customerLegalName: t80.string,
    customerId: t80.string
  })
);
var priceMetadataModel = t80.exact(
  t80.type({
    billingSchedules: t80.array(priceMetadataBillingScheduleDetailModel)
  }),
  "PriceMetadataModel"
);

// src/models/priceMetadata/decoder.ts
var toPriceMetadata = (value) => {
  return parseResponse({
    value,
    codec: priceMetadataModel,
    callerFunctionName: "toPriceMetadata"
  });
};

// src/models/priceMetadata/mocks.ts
var mockPriceMetadata = {
  billingSchedules: [
    {
      billingScheduleId: "e309e948-088e-4d77-b654-cd85498f1555",
      customerLegalName: "John Doe",
      customerId: "12345"
    }
  ]
};
export {
  DAYS_OF_WEEK,
  INFINITY,
  MONTHS,
  MONTH_LIMITS,
  PropagationMode,
  accountDetailsModel,
  accountDetailsTypeDescription,
  accountingDatePreference,
  addressModel,
  aggregationType,
  australianDestinationModel,
  billingFrequency,
  billingFrequencyOptions,
  billingPeriodModel,
  billingProductModel,
  billingProductModelPatch,
  billingProductsResponse,
  billingScheduleModel,
  billingSchedulePreviewModel,
  billingScheduleResponse,
  billingScheduleSettingsModel,
  billingScheduleStatus,
  billingScheduleType,
  billingScheduleUpdateResponse,
  billingScheduleVersion,
  billingSchedulesResponse,
  billingType,
  brandingModel,
  canadianDestinationModel,
  canadianInternationalDestinationModel,
  chargeMethod,
  contactModel,
  contactType,
  countries,
  country,
  createLinkInfo,
  createLinkInfoKeyValue,
  createOAuthClientResponseModel,
  createPaginatedResponseNew,
  createUnpaginatedResponse,
  creditBalanceModel,
  creditBalancesModel,
  creditGrantModel,
  creditGrantStatus,
  creditGrantsResponse,
  creditNoteContent,
  creditNoteContentCreditNoteModel,
  creditNoteContentLineItemGroupModel,
  creditNoteContentLineItemModel,
  creditNoteModel,
  creditNoteStatus,
  creditNoteTotalsModel,
  creditUnitType,
  creditUnitTypeLabelMap,
  currencies,
  currency,
  currencyConversionModel,
  currencyDisplayOptions,
  currencyToName,
  currencyToSymbol,
  customParameterModel,
  customParameterType,
  customerAlias,
  customerAliasOptions,
  customerAliasesResponsePaginated,
  customerAliasesResponseUnpaginated,
  customerCreditBalance,
  customerCreditBalancesResponseUnpaginated,
  customerModel,
  customerOptions,
  customerPortCreditTransactionModel,
  customerPortalBillingScheduleModel,
  customerPortalCreditBalanceDetailsModel,
  customerPortalCreditBalanceModel,
  customerPortalCreditGrantModel,
  customerPortalCreditType,
  customerPortalCustomerModel,
  customerPortalInvoiceModel,
  customerPortalLineItemGroupModel,
  customerPortalLineItemModel,
  customerPortalLineItemServicePeriodModel,
  customerPortalMerchantDetailsModel,
  customerPortalUsageEventModel,
  customerPortalUsageMetricModel,
  customerResponseModel,
  customersResponse,
  decimalFromPercentage,
  discountCalculationType,
  discountDuration,
  discountModel,
  discountsResponse,
  embeddedCustomerPortalCreditGrantModel,
  emptyPaginatedResponseNew,
  emptyUnpaginatedResponse,
  fetchBaseQueryCustomError,
  fetchBaseQueryFetchError,
  fetchBaseQueryParsingError,
  formatInitialLineItemRate,
  googleSheetsExportsModel,
  importIntegrationCustomersProgressResponse,
  importIntegrationCustomersResponse,
  inclusiveDateRange,
  insightsInvoicedRevenueModel,
  insightsOutstandingInvoicesModel,
  insightsUsageEventsModel,
  insightsUsageMetricDataModel,
  insightsUsageMetricResponse,
  integration,
  integrationCustomer,
  integrationCustomersForServiceResponse,
  integrationCustomersResponse,
  integrationExternalId,
  integrationId,
  integrationLedgerAccount,
  integrationLedgerAccountOptions,
  integrationLedgerAccountStatus,
  integrationLedgerAccountsResponse,
  integrationOAuthRedirectResponse,
  integrationService,
  integrationState,
  integrationType,
  invoiceAccountingDateSettingsModel,
  invoiceContent,
  invoiceContentInvoiceMerchantDetailsModel,
  invoiceContentInvoiceModel,
  invoiceContentInvoiceSubAccountUsage,
  invoiceContentLineItemGroupModel,
  invoiceContentLineItemModel,
  invoiceContentMerchantModel,
  invoiceContentUsageItemGroup,
  invoiceContentV2,
  invoiceContentV2InvoiceModel,
  invoiceContentV2LineItemModel,
  invoiceMerchantDetailsModel,
  invoiceModel,
  invoicePaymentOption,
  invoicePaymentProvider,
  invoicePaymentStatus,
  invoiceSettingsModel,
  invoiceStatus,
  invoiceSubAccountUsage,
  invoiceTotalsModel,
  invoiceUsageItemGroup,
  invoiceUsageItemGroupResponse,
  invoicesGrid,
  keyValuePairModel,
  lineItemCreditNoteModel,
  lineItemGroupCreditNoteModel,
  lineItemGroupModel,
  lineItemModel,
  linkInfo,
  linkInfoKeyValue,
  linkedEntityModel,
  linkedEntityType,
  merchantBankAccountDetailsModel,
  merchantModel,
  metricPropertyMatchers,
  metricPropertyMatchersOptions,
  metricType,
  mockBillingProduct,
  mockBillingProductsResponse,
  mockBillingSchedulePreview,
  mockBillingScheduleResponses,
  mockBillingScheduleSettings,
  mockBillingScheduleUpdateResponse,
  mockBillingSchedulesResponse,
  mockBranding,
  mockContact,
  mockCreateOAuthClientResponse,
  mockCreditBalance,
  mockCreditBalances,
  mockCreditBalancesResponse,
  mockCreditGrant,
  mockCreditGrants,
  mockCreditGrantsResponse,
  mockCreditNotePostRes,
  mockCreditNoteTotals,
  mockCreditNotes,
  mockCreditNotesResponse,
  mockCurrencyConversion,
  mockCustomerAlias,
  mockCustomerAliasesResponsePaginated,
  mockCustomerAliasesResponseUnpaginated,
  mockCustomerCreditBalance,
  mockCustomerCreditBalancesResponseUnpaginated,
  mockCustomerParsingError,
  mockCustomerPortalBillingSchedulesResponse,
  mockCustomerPortalCreditBalanceDetails,
  mockCustomerPortalCreditBalancesResponse,
  mockCustomerPortalCustomer,
  mockCustomerPortalInvoice,
  mockCustomerPortalInvoices,
  mockCustomerPortalInvoicesResponse,
  mockCustomerPortalLineItemGroups,
  mockCustomerPortalLineItems,
  mockCustomerPortalUsageEvent,
  mockCustomerPortalUsageEvent2,
  mockCustomerPortalUsageEventsResponse,
  mockCustomerPortalUsageMetric,
  mockCustomerPortalUsageMetric2,
  mockCustomerPortalUsageMetricsResponse,
  mockCustomerResponse,
  mockCustomerValidationError,
  mockCustomers,
  mockCustomersResponse,
  mockDiscount,
  mockDraftInvoice,
  mockFinalInvoice,
  mockGoogleSheetsExport,
  mockImportIntegrationCustomersProgressResponse,
  mockImportIntegrationCustomersResponse,
  mockInProgressInvoice,
  mockInsightsInvoicedRevenue,
  mockInsightsOutstandingInvoices,
  mockInsightsUsageEvents,
  mockInsightsUsageMetricResponse,
  mockIntegration,
  mockIntegrationCustomers,
  mockIntegrationCustomersForService,
  mockIntegrationLedgerAccounts,
  mockIntegrationOAuthRedirectResponse,
  mockIntegrationsResponse,
  mockInvoiceAccountingDateSettings,
  mockInvoiceContent,
  mockInvoiceContentV2,
  mockInvoiceMerchantDetails,
  mockInvoiceSettings,
  mockInvoiceTotals,
  mockInvoices,
  mockInvoicesGrid,
  mockInvoicesResponse,
  mockInvoicesResponseNoAdditionalFields,
  mockLineItemGroups,
  mockLineItemGroupsCreditNotes,
  mockLineItemGroupsCreditNotesResponse,
  mockLineItemGroupsCreditNotesResponseUnpaginated,
  mockLineItemGroupsResponse,
  mockLineItemGroupsResponseUnpaginated,
  mockLineItems,
  mockLineItemsCreditNotes,
  mockLineItemsCreditNotesResponse,
  mockLineItemsResponse,
  mockLineItemsResponseCreditNotesUnpaginated,
  mockLineItemsResponseUnpaginated,
  mockLinkedEntity,
  mockMerchant,
  mockNotificationPoliciesResponse,
  mockNotificationPolicy,
  mockOAuthClient,
  mockOAuthClientsResponse,
  mockPagination,
  mockPlans,
  mockPlansResponse,
  mockPriceFixed,
  mockPriceGraduated,
  mockPriceLinear,
  mockPriceMetadata,
  mockPriceOneTime,
  mockPricePackage,
  mockPriceVolume,
  mockPriceVolumePercentage,
  mockPricesResponse,
  mockProduct,
  mockProductsResponse,
  mockSeatBalance,
  mockSeatBalancesResponse,
  mockSeatSnapshot,
  mockSeatSnapshotsResponse,
  mockSeatTotal,
  mockSeatTotalsResponse,
  mockSeatType,
  mockSeatTypesResponse,
  mockSelf,
  mockSequenceAccount,
  mockSequenceAccountId,
  mockSequenceAccountSettings,
  mockTaxRates,
  mockTaxRatesResponse,
  mockTaxRegistration,
  mockTaxRegistrations,
  mockTaxRegistrationsResponse,
  mockTokenResponse,
  mockTotalCustomers,
  mockUniqueUsageEventProperties,
  mockUniqueUsageEventTypes,
  mockUsageDataDataResponse,
  mockUsageDataResponse,
  mockUsageEvents,
  mockUsageEventsResponse,
  mockUsageItemGroups,
  mockUsageMetric,
  mockUsageMetricCalculation,
  mockUsageMetricsResponse,
  mockUser,
  mockUsersResponse,
  mockVoidInvoice,
  monetaryAmountModel,
  monthNamesShort,
  normalisedLineItemRate,
  notificationChannel,
  notificationPolicyModel,
  notificationType,
  notificationTypeGroup,
  notificationTypeGroups,
  notificationTypes,
  oauthClientModel,
  paginationResponseNew,
  parseResponse,
  payerModel,
  paymentProvider,
  paymentProviderToLabel,
  percentageFromDecimal,
  phase,
  planModel,
  planStatus,
  plansResponse,
  priceMetadataBillingScheduleDetailModel,
  priceMetadataModel,
  priceModel,
  priceParameterModel,
  priceToBillingType,
  priceTypeUrlChunk,
  pricesResponse,
  pricingStructureFixed,
  pricingStructureGraduated,
  pricingStructureLinear,
  pricingStructureModel,
  pricingStructureOneTime,
  pricingStructurePackage,
  pricingStructureSeatBased,
  pricingStructureVolume,
  pricingTier,
  pricingType,
  pricingTypeDescriptions,
  productModel,
  productModelShape,
  productStatus,
  productTaxRate,
  productsResponse,
  prorationStrategy,
  quoteStatus,
  rateDisplay,
  relativePhase,
  rtkqResponse,
  rtkqResponseData,
  rtkqResponseError,
  seatBalanceModel,
  seatBalancesResponse,
  seatChangeModel,
  seatChangeType,
  seatSnapshotModel,
  seatSnapshotsResponse,
  seatTotalModel,
  seatTotalsResponse,
  seatTypeModel,
  seatTypesResponse,
  selfModel,
  sequenceAccountIdModel,
  sequenceAccountModel,
  sequenceAccountSettingsModel,
  sequenceUser,
  serializedError,
  setNotify,
  settingPreference,
  sortCodeAccountNumberModel,
  state,
  stateFieldName,
  states,
  statesForCountry,
  taxRateModel,
  taxRatesResponse,
  taxRegistrationModel,
  taxRegistrationsResponse,
  taxStatus,
  taxStatusMap,
  toAggregationType,
  toBillingFrequencyLabel,
  toBillingFrequencyName,
  toBillingFrequencyPluralName,
  toBillingProduct,
  toBillingProductsResponse,
  toBillingSchedulePreview,
  toBillingScheduleResponse,
  toBillingScheduleSettings,
  toBillingScheduleUpdateResponse,
  toBillingSchedulesResponse,
  toBillingType,
  toBranding,
  toChargeMethodLabel,
  toChargeMethodOptions,
  toCompactMoney,
  toContact,
  toCountryLabel,
  toCreateOAuthClientResponse,
  toCreditBalances,
  toCreditGrant,
  toCreditGrantStatusBadgeProps,
  toCreditGrantsResponse,
  toCreditNote,
  toCreditNoteContent,
  toCreditNoteStatusBadgeProps,
  toCreditNoteTotals,
  toCreditNotesResponse,
  toCurrencyConversion,
  toCurrencyDescription,
  toCurrencySymbol,
  toCustomer,
  toCustomerAlias,
  toCustomerAliasesResponsePaginated,
  toCustomerAliasesResponseUnpaginated,
  toCustomerCreditBalancesResponseUnpaginated,
  toCustomerPortalBillingSchedulesResponse,
  toCustomerPortalCreditBalanceDetails,
  toCustomerPortalCreditBalancesResponse,
  toCustomerPortalCustomer,
  toCustomerPortalInvoice,
  toCustomerPortalInvoicesResponse,
  toCustomerPortalLineItemGroupsResponse,
  toCustomerPortalLineItemsResponse,
  toCustomerPortalUsageEventsResponse,
  toCustomerPortalUsageMetricsResponse,
  toCustomerResponseModel,
  toCustomersResponse,
  toDiscount,
  toDiscountsResponse,
  toGoogleSheetsExports,
  toImportIntegrationCustomersProgressResponse,
  toImportIntegrationCustomersResponse,
  toInsightsInvoicedRevenueResponse,
  toInsightsOutstandingInvoicesResponse,
  toInsightsUsageEventsResponse,
  toInsightsUsageMetricResponse,
  toIntegration,
  toIntegrationCustomersForServiceResponse,
  toIntegrationCustomersResponse,
  toIntegrationLedgerAccountsResponse,
  toIntegrationOAuthRedirectResponse,
  toIntlNumber,
  toInvoice,
  toInvoiceAccountingDateSettings,
  toInvoiceContent,
  toInvoiceContentV2,
  toInvoiceMerchantDetails,
  toInvoicePaymentStatusBadgeProps,
  toInvoicePaymentStatusText,
  toInvoiceSettings,
  toInvoiceStatusBadgeProps,
  toInvoiceTotals,
  toInvoiceUsageItemGroupResponse,
  toInvoicesGrid,
  toInvoicesResponse,
  toLineItem,
  toLineItemCreditNote,
  toLineItemGroup,
  toLineItemGroupCreditNote,
  toLineItemGroupsCreditNoteResponse,
  toLineItemGroupsResponse,
  toLineItemsCreditNotesResponse,
  toLineItemsResponse,
  toLinkedEntityModel,
  toListIntegrationsResponse,
  toMerchant,
  toMoney,
  toNotificationPoliciesResponse,
  toNotificationPolicy,
  toOAuthClient,
  toOAuthClientsResponse,
  toOK,
  toPlan,
  toPlansResponse,
  toPrice,
  toPriceFrequencyLabel,
  toPriceMetadata,
  toPriceSummary,
  toPriceTypeUrlChunk,
  toPricesResponse,
  toPricingTypeLabel,
  toPricingTypeLabelShort,
  toPricingTypeOptions,
  toPricingTypeTableLabel,
  toProduct,
  toProductStatusBadgeProps,
  toProductsResponse,
  toProrationStrategyLabel,
  toProrationStrategyOptions,
  toQuoteStatusBadgeProps,
  toRtkqResponse,
  toRtkqResponseError,
  toSeatBalancesResponse,
  toSeatSnapshot,
  toSeatSnapshotsResponse,
  toSeatTotal,
  toSeatTotalsResponse,
  toSeatType,
  toSeatTypesResponse,
  toSelf,
  toSequenceAccount,
  toSequenceAccountId,
  toSequenceAccountSettings,
  toTaxRate,
  toTaxRatesResponse,
  toTaxRegistration,
  toTaxRegistrationsResponse,
  toTokenResponse,
  toTotalCustomersResponse,
  toUndefined,
  toUniqueUsageEventProperties,
  toUniqueUsageEventTypes,
  toUnpaginatedLineItemGroupsCreditNoteResponse,
  toUnpaginatedLineItemGroupsResponse,
  toUnpaginatedLineItemsCreditNoteResponse,
  toUnpaginatedLineItemsResponse,
  toUsageCalculationModeDescription,
  toUsageCalculationModeLabel,
  toUsageDataDataResponse,
  toUsageDataResponse,
  toUsageEvent,
  toUsageEventsResponse,
  toUsageMetric,
  toUsageMetricCalculation,
  toUsageMetricsResponse,
  toUser,
  toUsers,
  tokenResponse,
  totalCustomersModel,
  totalsModel,
  transformCreditGrantExpiry,
  uniqueUsageEventProperties,
  uniqueUsageEventTypes,
  usAchDestinationModel,
  usWireDestinationModel,
  usageBasedPricingTypes,
  usageCalculationMode,
  usageCalculationModeOptions,
  usageDataDataResponseModel,
  usageDataModel,
  usageDataResponseModel,
  usageEventModel,
  usageEventsResponse,
  usageMetricCalculation,
  usageMetricModel,
  usageMetricsResponse,
  usagePeriodType,
  userModel,
  validationError,
  validationErrorItem,
  validationErrorParent,
  weekdayNamesShort
};
//# sourceMappingURL=index.js.map